/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 67);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newKey = newKey;
exports.resetTest = resetTest;
exports.getSiteId = getSiteId;
exports.getDeviceType = getDeviceType;
exports.getAccountId = getAccountId;
exports.replacePlaceholders = replacePlaceholders;
exports.isNumbers = isNumbers;
exports.getMonthlyPaymentPerThousand = getMonthlyPaymentPerThousand;
exports.getTotalMonthlyPayments = getTotalMonthlyPayments;
exports.getAdjustedDueAtSigning = getAdjustedDueAtSigning;
exports.getDisclaimerPlaceholderObj = getDisclaimerPlaceholderObj;
exports.filterSummary = filterSummary;
exports.filterFinal = filterFinal;
exports.filterLoanLease = filterLoanLease;
exports.extractEPriceData = extractEPriceData;
exports.parseEPriceButtonLabel = parseEPriceButtonLabel;
exports.titleCase = titleCase;
exports.getDOMContainer = getDOMContainer;
exports.getAffiliatePromotion = exports.getParameterValue = exports.getCookieValue = exports.setClassNames = exports.getDisplayPayments = void 0;

var _constants = __webpack_require__(6);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* eslint unknown-word: 0 */
var lastKey = 0;

function newKey(prefix) {
  lastKey += 1;
  return "".concat(prefix).concat(lastKey);
} // for testing purpose


function resetTest() {
  lastKey = 0;
}

function getSiteId(rData) {
  return rData.parameterMap && rData.parameterMap.siteId || rData.siteId;
}

function getDeviceType(rData) {
  return rData.parameterMap && rData.parameterMap.deviceType || rData.deviceType;
}

function getAccountId(rData) {
  return rData.parameterMap && rData.parameterMap.accountId || rData.accountId;
}
/**
 *
 * @param {Array} paymentsArray List of all available LOAN, LEASE payment options
 * @param {Array} keys List of payment object properties by which to sort
 * @param {Array} orders Order in which to sort the payment object to their respective properties, asc is default
 * @return {Object} Selected LOAN, LEASE payment object
 */


var getDisplayPayments = function getDisplayPayments(paymentsArray) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  /**
   * Sort the payment object based on the list of properties in the `keys` argument.
   * The list is maintained if the sort is based on a missing property
   */
  var sortedPaymentsArray = _toConsumableArray(paymentsArray).sort(function (paymentOne, paymentTwo) {
    var sortConditions = keys.map(function (key, index) {
      var order = orders[index] ? orders[index] : _constants.ASC;
      var criterea = 0;

      switch (order) {
        case _constants.DESC:
          criterea = paymentTwo[key] - paymentOne[key];
          break;

        case _constants.ASC:
        default:
          criterea = paymentOne[key] - paymentTwo[key];
          break;
      }

      return criterea;
    });
    return sortConditions.reduce(function (result, condition) {
      return result || condition;
    });
  });
  /* Select the first LOAN LEASE Payment in the list */


  return sortedPaymentsArray.reduce(function (paymentObj, payment) {
    var _payment$financeType = payment.financeType,
        financeType = _payment$financeType === void 0 ? '' : _payment$financeType;

    if (!paymentObj[financeType]) {
      return _objectSpread({}, paymentObj, _defineProperty({}, financeType, payment));
    }

    return paymentObj;
  }, {});
};

exports.getDisplayPayments = getDisplayPayments;

function replacePlaceholders(labelWithPlaceholder, placeholderValuesObj) {
  // global and ignore case flags which permits replace() to replace each occurrence of matched items
  // ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
  if (!placeholderValuesObj || Object.entries(placeholderValuesObj).length === 0) {
    if (!labelWithPlaceholder || Object.entries(labelWithPlaceholder).length === 0) {
      return 'Invalid Input';
    }

    return labelWithPlaceholder;
  }

  var regex = new RegExp(Object.keys(placeholderValuesObj).join('|'), 'gi');
  return labelWithPlaceholder.replace(regex, function (matched) {
    return placeholderValuesObj[matched];
  });
}

function numberCheck(num) {
  return typeof num === 'number' && Number.isFinite(num);
}

function isNumbers(nums) {
  if (!nums || !Array.isArray(nums)) {
    return false;
  }

  return nums.every(numberCheck);
} // Logic is copied from PaymentCalculaterTool.java in cms project
// export function getMonthlyPayment(price, downPayment,interestRate,numberOfMonths) {
// 	if (price && downPayment && interestRate && numberOfMonths && isNumbers([price, downPayment,interestRate,numberOfMonths])) {
// 		return Math.round(((price - downPayment) * (interestRate / 100 / 12)) / (1 - (1 + interestRate / 100 / 12) ** (-numberOfMonths)));
// 	}
// 	return '';
// }


function getMonthlyPaymentPerThousand(monthlyPayment, amountFinanced) {
  if (isNumbers([amountFinanced, monthlyPayment]) && amountFinanced > 0) {
    return monthlyPayment / (amountFinanced / 1000.0);
  }

  return '';
}

function getTotalMonthlyPayments(monthlyPayment, term) {
  if (isNumbers([term, monthlyPayment])) {
    return monthlyPayment * term;
  }

  return '';
}

function getAdjustedDueAtSigning(dueAtSigning, rebate) {
  if (isNumbers([dueAtSigning, rebate]) && dueAtSigning - rebate > 0) {
    return dueAtSigning - rebate;
  } else {
    return 0;
  }
}

function getDisclaimerPlaceholderObj(paymentInfo) {
  if (paymentInfo._type === 'LOAN') {
    var apr = paymentInfo.apr,
        dealershipName = paymentInfo.dealershipName,
        downPayment = paymentInfo.downPayment,
        lenderLegalName = paymentInfo.lenderLegalName,
        loanCreditScore = paymentInfo.loanCreditScore,
        monthlyPaymentPerThousand = paymentInfo.monthlyPaymentPerThousand,
        loanProgramEndDate = paymentInfo.loanProgramEndDate,
        term = paymentInfo.term;
    return {
      '<%=loanCreditScore%>': loanCreditScore,
      '<%=APR%>': apr,
      '<%=term%>': term,
      '<%=monthlyPaymentPerThousand%>': monthlyPaymentPerThousand,
      '<%=downPayment%>': downPayment,
      '<%=lenderLegalName%>': lenderLegalName,
      '<%=loanProgramEndDate%>': loanProgramEndDate,
      '<%=dealershipName%>': dealershipName
    };
  } else if (paymentInfo._type === 'LEASE') {
    var leaseCreditScore = paymentInfo.leaseCreditScore,
        leaseLenderLegalName = paymentInfo.leaseLenderLegalName,
        leaseProgramEndDate = paymentInfo.leaseProgramEndDate,
        leaseTerm = paymentInfo.leaseTerm,
        leaseDueAtSigning = paymentInfo.leaseDueAtSigning,
        acquisitionFee = paymentInfo.acquisitionFee,
        capCostTotal = paymentInfo.capCostTotal,
        totalMonthlyPayments = paymentInfo.totalMonthlyPayments,
        capCostReduction = paymentInfo.capCostReduction,
        leaseSecurityDeposit = paymentInfo.leaseSecurityDeposit,
        monthlyPayment = paymentInfo.monthlyPayment,
        excessMileCharge = paymentInfo.excessMileCharge,
        annualMiles = paymentInfo.annualMiles,
        _dealershipName = paymentInfo.dealershipName;
    return {
      '<%=leaseCreditScore%>': leaseCreditScore,
      '<%=leaseLenderLegalName%>': leaseLenderLegalName,
      '<%=leaseProgramEndDate%>': leaseProgramEndDate,
      '<%=leaseTerm%>': leaseTerm,
      '<%=leaseDueAtSigning%>': leaseDueAtSigning,
      '<%=acquisitionFee%>': acquisitionFee,
      '<%=capCostTotal%>': capCostTotal,
      '<%=totalMonthlyPayments%>': totalMonthlyPayments,
      '<%=capCostReduction%>': capCostReduction,
      '<%=leaseSecurityDeposit%>': leaseSecurityDeposit,
      '<%=monthlyPayment%>': monthlyPayment,
      '<%=excessMileCharge%>': excessMileCharge,
      '<%=annualMiles%>': annualMiles,
      '<%=dealershipName%>': _dealershipName
    };
  }

  return {};
} // filter out final price items that do not match the priceType
// this data is consumed by the PricingSummary component


function filterSummary(summaryItems, priceType) {
  return summaryItems.filter(function (item) {
    return item && item.priceType && item.priceType === priceType.toUpperCase() || !item.priceType;
  });
} // filters out the final price from the summary object
// this data is consumed by the PricingSummary component


function filterFinal(summaryItems) {
  return summaryItems.filter(function (item) {
    return item.isFinalPrice === true;
  });
} // filters out the loan and lease from the summary object
// this data is consumed by the PricingLoanLease component


function filterLoanLease(summaryItems) {
  return summaryItems.filter(function (item) {
    return item._type === 'LOAN' || item._type === 'LEASE';
  });
}

function extractEPriceData(ePriceDetail) {
  var ePriceIndex = ePriceDetail.findIndex(function (element) {
    return element._type === 'EPRICE';
  }); // ePrice difference should be placed before ePrice value per Rules Provider

  var ePriceDifference = ePriceDetail[ePriceIndex].formatted;
  var ePriceValue = ePriceDetail[ePriceIndex + 1].formatted;
  var final = {};

  if (ePriceValue) {
    final = {
      ePriceValue: ePriceValue,
      ePriceDifference: ePriceDifference
    };
  }

  return final;
}

function parseEPriceButtonLabel(dPriceArr) {
  var ePriceLabelArr = dPriceArr.filter(function (item) {
    return item._type === 'SHOWEPRICE';
  })[0] || {};
  return ePriceLabelArr.label || 'Show ePrice!';
}

function titleCase(str, sep) {
  return str.toLowerCase().split(sep).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join('');
}

function getDOMContainer(doc, cssClass) {
  var _doc$querySelectorAll = doc.querySelectorAll(cssClass),
      _doc$querySelectorAll2 = _slicedToArray(_doc$querySelectorAll, 1),
      container = _doc$querySelectorAll2[0];

  return container;
}
/**
 * Filters undefined, null or empty strings as well as boolean false from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 * From Tim Burgher in vehicle title's utility file
 */


var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.concat().filter(function (className) {
    return className;
  }).join(' ') || null;
};
/**
 * Filters list of cookies down to the cookie with name matching cookieName param. if it exists, and returns
 * its value, if it is defined, or an empty string otherwise.
 *
 * @param cookies
 * @param cookieName
 * @returns {String} cookie name if the cookie exists, or empty string.
 */


exports.setClassNames = setClassNames;

var getCookieValue = function getCookieValue() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return cookies.filter(function (cookie) {
    return cookie.name === cookieName;
  }).reduce(function (value, cookie) {
    return cookie.value || value;
  }, '');
};
/**
 * Returns promo code from the 'affiliate_promotions' url parameter if it exists
 *
 * @param parameterMap
 * @param parameterName
 * @returns {String} parameter value if the url parameter equal to parameterName exists, or empty string.
 */


exports.getCookieValue = getCookieValue;

var getParameterValue = function getParameterValue() {
  var parameterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var parameterMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return parameterMap[parameterName] || '';
};
/**
 * Returns affiliate offer promo code if one exists in the url parameter 'affiliate_promotions'
 * or in the 'DDC.Affiliate.PromoCode' cookie.
 * Prioritizes url parameter over cookie.
 *
 * @param rData
 * @returns {String} Promo code, if one exists, or empty string
 */


exports.getParameterValue = getParameterValue;

var getAffiliatePromotion = function getAffiliatePromotion() {
  var rData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getParameterValue('affiliate_promotions', rData.parameterMap) || getCookieValue('DDC.Affiliate.PromoCode', rData.cookies);
};

exports.getAffiliatePromotion = getAffiliatePromotion;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(64);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THE_DEALERSHIP = exports.SLASH_MO = exports.PLUS_TAXES_ASTERISK = exports.PLUS_SALES_TAXES_ASTERISK = exports.PLEASE_CALL = exports.PER_MONTH = exports.LEASE = exports.INSTANT_EPRICE_DISABLED_POPOVER = exports.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = exports.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = exports.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = exports.FINANCE = exports.EST_LEASE_DISCLAIMER_HEADING = exports.EST_FINANCE_DISCLAIMER_HEADING = exports.EPRICE_PENDING = exports.DETAILS = exports.DETAILED_PRICING = exports.DEALERSHIP_NAME_PRICE = exports.CUSTOMIZE_PAYMENTS = void 0;
var CUSTOMIZE_PAYMENTS = 'CUSTOMIZE_PAYMENTS';
exports.CUSTOMIZE_PAYMENTS = CUSTOMIZE_PAYMENTS;
var DEALERSHIP_NAME_PRICE = 'DEALERSHIP_NAME_PRICE';
exports.DEALERSHIP_NAME_PRICE = DEALERSHIP_NAME_PRICE;
var DETAILED_PRICING = 'DETAILED_PRICING';
exports.DETAILED_PRICING = DETAILED_PRICING;
var DETAILS = 'DETAILS';
exports.DETAILS = DETAILS;
var EPRICE_PENDING = 'EPRICE_PENDING';
exports.EPRICE_PENDING = EPRICE_PENDING;
var EST_FINANCE_DISCLAIMER_HEADING = 'EST_FINANCE_DISCLAIMER_HEADING';
exports.EST_FINANCE_DISCLAIMER_HEADING = EST_FINANCE_DISCLAIMER_HEADING;
var EST_LEASE_DISCLAIMER_HEADING = 'EST_LEASE_DISCLAIMER_HEADING';
exports.EST_LEASE_DISCLAIMER_HEADING = EST_LEASE_DISCLAIMER_HEADING;
var FINANCE = 'FINANCE';
exports.FINANCE = FINANCE;
var FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE = FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
var FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE = FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE;
var FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = 'FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE';
exports.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE = FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE;
var INSTANT_EPRICE_DISABLED_POPOVER = 'INSTANT_EPRICE_DISABLED_POPOVER';
exports.INSTANT_EPRICE_DISABLED_POPOVER = INSTANT_EPRICE_DISABLED_POPOVER;
var LEASE = 'LEASE';
exports.LEASE = LEASE;
var PER_MONTH = 'PER_MONTH';
exports.PER_MONTH = PER_MONTH;
var PLEASE_CALL = 'PLEASE_CALL';
exports.PLEASE_CALL = PLEASE_CALL;
var PLUS_SALES_TAXES_ASTERISK = 'PLUS_SALES_TAXES_ASTERISK';
exports.PLUS_SALES_TAXES_ASTERISK = PLUS_SALES_TAXES_ASTERISK;
var PLUS_TAXES_ASTERISK = 'PLUS_TAXES_ASTERISK';
exports.PLUS_TAXES_ASTERISK = PLUS_TAXES_ASTERISK;
var SLASH_MO = 'SLASH_MO';
exports.SLASH_MO = SLASH_MO;
var THE_DEALERSHIP = 'THE_DEALERSHIP';
exports.THE_DEALERSHIP = THE_DEALERSHIP;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_ACCOUNT = exports.SET_DEALER_ADDRESS = exports.SET_WIDGET_INFO = exports.VCDA_ERROR = exports.SET_MODAL = exports.SET_INCENTIVE = exports.SET_PRICING = void 0;
// This file should only contain action type constants.
var SET_PRICING = 'SET_PRICING';
exports.SET_PRICING = SET_PRICING;
var SET_INCENTIVE = 'SET_INCENTIVE';
exports.SET_INCENTIVE = SET_INCENTIVE;
var SET_MODAL = 'SET_MODAL';
exports.SET_MODAL = SET_MODAL;
var VCDA_ERROR = 'VCDA_ERROR';
exports.VCDA_ERROR = VCDA_ERROR;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;
var SET_DEALER_ADDRESS = 'SET_DEALER_ADDRESS';
exports.SET_DEALER_ADDRESS = SET_DEALER_ADDRESS;
var SET_ACCOUNT = 'SET_ACCOUNT';
exports.SET_ACCOUNT = SET_ACCOUNT;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_RESET_CLASSES = exports.DESC = exports.ASC = exports.OFFSET_INTEGRATED_DR_HEIGHT = exports.OFFSET_HEIGHT = exports.NO_PRICE_ITEMS = exports.LEASE = exports.LOAN = void 0;
var LOAN = 'LOAN';
exports.LOAN = LOAN;
var LEASE = 'LEASE';
exports.LEASE = LEASE;
var NO_PRICE_ITEMS = 'No prices were returned from vcda.';
exports.NO_PRICE_ITEMS = NO_PRICE_ITEMS;
var OFFSET_HEIGHT = 66;
exports.OFFSET_HEIGHT = OFFSET_HEIGHT;
var OFFSET_INTEGRATED_DR_HEIGHT = 33;
exports.OFFSET_INTEGRATED_DR_HEIGHT = OFFSET_INTEGRATED_DR_HEIGHT;
var ASC = 'asc';
exports.ASC = ASC;
var DESC = 'desc';
exports.DESC = DESC;
var BUTTON_RESET_CLASSES = 'p-0 text-left bg-transparent border-0';
exports.BUTTON_RESET_CLASSES = BUTTON_RESET_CLASSES;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CaDisclaimer = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CaDisclaimer = function CaDisclaimer(_ref) {
  var dealerAddress = _ref.dealerAddress,
      isFooter = _ref.isFooter;
  var CAAlternateDisclaimerProvinces = ['AB', 'BC', 'MB', 'ON', 'QC', 'SK'];
  var staticDisclaimerClasses = 'final-price-disclaimer ddc-font-size-xsmall text-muted w-100 ';
  var disclaimerClasses = staticDisclaimerClasses + (isFooter ? 'text-left summary-disclaimer' : 'text-right');
  var disclaimerLabel = _labels.PLUS_TAXES_ASTERISK;

  if (CAAlternateDisclaimerProvinces.includes(dealerAddress.state)) {
    disclaimerLabel = _labels.PLUS_SALES_TAXES_ASTERISK;
  }

  if (dealerAddress.country === 'CA') {
    return _react.default.createElement("div", {
      className: disclaimerClasses
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(disclaimerLabel);
      }
    }));
  } else {
    return null;
  }
};

exports.CaDisclaimer = CaDisclaimer;
CaDisclaimer.propTypes = {
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
CaDisclaimer.defaultProps = {
  dealerAddress: {},
  isFooter: false
};
var _default = CaDisclaimer;
exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelAsHTML = function LabelAsHTML(props) {
  var label = props.label,
      isStyleEditable = props.isStyleEditable,
      vehicleTypeClass = props.vehicleTypeClass,
      typeClass = props.typeClass;
  return (
    /* eslint react/no-danger: 0 */
    _react.default.createElement("span", {
      className: "price-label",
      "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-label") : null,
      "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-label") : null,
      dangerouslySetInnerHTML: {
        __html: label
      }
    })
  );
};

LabelAsHTML.defaultProps = {
  isStyleEditable: false,
  vehicleTypeClass: '',
  typeClass: ''
};
LabelAsHTML.propTypes = {
  label: _propTypes.default.string.isRequired,
  isStyleEditable: _propTypes.default.bool,
  vehicleTypeClass: _propTypes.default.string,
  typeClass: _propTypes.default.string
};
var _default = LabelAsHTML;
exports.default = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priceDetailsScrollEvent = priceDetailsScrollEvent;
exports.disclaimerDetailsModalEvents = disclaimerDetailsModalEvents;
exports.ePriceButtonTrackEvent = ePriceButtonTrackEvent;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var defaultClickEvent = {
  event: 'widgetUserEvent',
  element: 'More details button',
  elementCTA: 'Details',
  action: 'clicked',
  result: 'Revealed detail information popup',
  widgetName: 'ws-detailed-pricing',
  widgetId: 'detailed-pricing1',
  widgetState: 'default',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = {};

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
    trackingObject = window.jQuery(document) || {};
  }

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function priceDetailsScrollEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Price details link',
    elementCTA: 'Pricing Detail',
    result: 'Scrolled to destination',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

function disclaimerDetailsModalEvents(widgetName, widgetId, modalState) {
  var eventData;

  if (modalState) {
    eventData = {
      element: 'Disclaimer details link',
      elementCTA: undefined,
      result: 'Opened dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  } else {
    eventData = {
      element: 'Close button',
      elementCTA: undefined,
      result: 'Closed dialog',
      widgetState: 'Disclaimer dialog',
      widgetName: widgetName,
      widgetId: widgetId
    };
  }

  trackGoogleAnalyticsEvent(eventData);
}

function ePriceButtonTrackEvent(buttonLabel, widgetName, widgetId, openModal) {
  var eventData = {
    element: 'Instant ePrice button',
    elementCTA: buttonLabel,
    result: openModal ? 'Opened dialog' : 'ePrice diplayed',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = ReactBootstrap;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _utility = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DisclaimerContent = function DisclaimerContent(_ref) {
  var dealershipName = _ref.dealershipName,
      disclaimerLabel = _ref.disclaimerLabel,
      placeholderValuesObj = _ref.placeholderValuesObj;
  return _react.default.createElement(_common.Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;
      var introParagraph = labels.get(_labels.FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE);
      var dealershipText = dealershipName === _labels.THE_DEALERSHIP ? labels.get(_labels.THE_DEALERSHIP) : dealershipName;
      var disclaimerHtml = (0, _utility.replacePlaceholders)(labels.get(disclaimerLabel), _objectSpread({}, placeholderValuesObj, {
        '<%=dealershipName%>': dealershipText
      }));
      /* eslint react/no-danger: 0 */

      return [_react.default.createElement("div", {
        key: "introHtml",
        dangerouslySetInnerHTML: {
          __html: introParagraph
        }
      }), _react.default.createElement("div", {
        key: "disclaimerHtml",
        dangerouslySetInnerHTML: {
          __html: disclaimerHtml
        }
      })];
    }
  });
};

DisclaimerContent.propTypes = {
  dealershipName: _propTypes.default.string.isRequired,
  disclaimerLabel: _propTypes.default.string.isRequired,
  placeholderValuesObj: _propTypes.default.shape().isRequired
};
var _default = DisclaimerContent;
exports.default = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _DisclaimersModal = _interopRequireDefault(__webpack_require__(17));

var _labels = __webpack_require__(4);

var _constants = __webpack_require__(6);

var _analytics = __webpack_require__(10);

var _utility = __webpack_require__(2);

var _PricingSummaryFinalPrice = _interopRequireDefault(__webpack_require__(24));

var _PricingSummaryPayments = _interopRequireDefault(__webpack_require__(28));

var _PricingSummaryLink = _interopRequireDefault(__webpack_require__(27));

var _CanadaDisclaimerContent = __webpack_require__(8);

__webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var getFormattedValue = function getFormattedValue(formatted) {
  var formattedValue = formatted;

  if (formattedValue === _labels.PLEASE_CALL) {
    formattedValue = _react.default.createElement(_common.Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(_labels.PLEASE_CALL);
      }
    });
  }

  return formattedValue;
};

var PricingSummary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummary, _React$Component);

  function PricingSummary(props) {
    var _this;

    _classCallCheck(this, PricingSummary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummary).call(this, props));
    _this.state = {
      isModalVisible: false,
      paymentInfo: null
    };
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummary, [{
    key: "closeModal",
    value: function closeModal() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, false);
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "handleHelpCircleIcon",
    value: function handleHelpCircleIcon(paymentInfo) {
      var _this$props$widgetInf2 = this.props.widgetInfo,
          widgetName = _this$props$widgetInf2.widgetName,
          windowId = _this$props$widgetInf2.windowId;
      (0, _analytics.disclaimerDetailsModalEvents)(widgetName, windowId, true);
      this.setState({
        isModalVisible: true,
        paymentInfo: paymentInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$summary = _this$props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary,
          isMobile = _this$props.isMobile,
          viewPriceDetail = _this$props.viewPriceDetail;
      var showStickySidebarLoanLease = this.props.prefs.showStickySidebarLoanLease;
      var finalLabelSize = isMobile ? 'ddc-font-size-base' : 'ddc-font-size-small';
      var finalPriceSize = isMobile ? 'ddc-font-size-xxlarge' : 'ddc-font-size-xlarge';
      var paymentLabelSize = isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall';
      var paymentPriceSize = isMobile ? 'ddc-font-size-xlarge' : 'ddc-font-size-large';
      var summaryLength = summary.length;
      var pricingSummary;

      if (summaryLength === 0) {
        return null;
      } else if (summaryLength > 1 && showStickySidebarLoanLease === 'true') {
        var finalPriceSummary = (0, _utility.filterFinal)(summary);
        var paymentsSummary = (0, _utility.filterLoanLease)(summary);
        pricingSummary = _react.default.createElement("div", null, _react.default.createElement(_DisclaimersModal.default, {
          isModalVisible: this.state.isModalVisible,
          handleClose: this.closeModal,
          paymentInfo: this.state.paymentInfo
        }), _react.default.createElement("ul", {
          className: "pricing-summary list-unstyled d-flex align-items-end justify-items-between mb-4"
        }, _react.default.createElement("li", {
          className: (0, _utility.setClassNames)(summaryLength <= 2 ? 'half-width' : 'third-width', ' d-flex', 'flex-wrap', 'mr-4', 'summary-price')
        }, finalPriceSummary.map(function (price) {
          return _react.default.createElement(_PricingSummaryFinalPrice.default, _extends({
            price: price,
            viewPriceDetail: viewPriceDetail,
            finalLabelSize: finalLabelSize,
            finalPriceSize: finalPriceSize,
            paymentLabelSize: paymentLabelSize
          }, {
            key: price._type,
            buttonResetClasses: _constants.BUTTON_RESET_CLASSES,
            finalPrice: getFormattedValue(price.formatted)
          }));
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.DETAILED_PRICING,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: false,
          viewPriceDetail: viewPriceDetail
        })), _react.default.createElement("li", {
          className: "d-flex flex-wrap flex-grow-1"
        }, paymentsSummary.map(function (price) {
          return _react.default.createElement(_PricingSummaryPayments.default, _extends({
            price: price,
            paymentLabelSize: paymentLabelSize,
            paymentPriceSize: paymentPriceSize
          }, {
            key: price._type,
            paymentPrice: getFormattedValue(price.formatted),
            handleHelpCircleIcon: function handleHelpCircleIcon() {
              return _this2.handleHelpCircleIcon(price);
            }
          }));
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.CUSTOMIZE_PAYMENTS,
          labelFontSize: paymentLabelSize,
          isCalculatePayment: true
        }))));
      } else {
        // single item (final price) will get detailed pricing markup
        // summary[0] will always be final price - ref: VCDApricing.js
        var _summary$ = summary[0],
            label = _summary$.label,
            formatted = _summary$.formatted;
        var dealerAddress = this.props.dealerAddress;
        pricingSummary = _react.default.createElement("dl", {
          className: "pricing-detail final-price line-height-condensed mb-4"
        }, _react.default.createElement("dt", null, _react.default.createElement("button", {
          className: _constants.BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail
        }, _react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: label
          }
        }), _react.default.createElement(_PricingSummaryLink.default, {
          label: _labels.DETAILED_PRICING,
          labelFontSize: paymentLabelSize
        }))), _react.default.createElement("dd", {
          className: (0, _utility.setClassNames)('font-weight-bold', finalPriceSize)
        }, _react.default.createElement("button", {
          className: _constants.BUTTON_RESET_CLASSES,
          onClick: viewPriceDetail
        }, getFormattedValue(formatted))), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
          dealerAddress: dealerAddress
        }));
      }

      return pricingSummary;
    }
  }]);

  return PricingSummary;
}(_react.default.Component);

exports.default = PricingSummary;
PricingSummary.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isMobile: _propTypes.default.bool
};
PricingSummary.defaultProps = {
  dealerAddress: {},
  isMobile: false
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.7.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseGet = __webpack_require__(52),
    toPath = __webpack_require__(53);

/**
 * Gets the property value of `path` on `object`. If the resolved value is
 * `undefined` the `defaultValue` is used in its place.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(7);

var _reactHotLoader = __webpack_require__(56);

var _Widget = _interopRequireDefault(__webpack_require__(31));

var _store = __webpack_require__(47);

var _widgetComponents = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React hydrate bound to the redux store
 * - Set up hot reloading
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		WS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getFlag = function getFlag(name, defaultValue) {
  if (!window.DDC || !window.DDC.Flags) {
    return defaultValue;
  }

  return window.DDC.Flags[name];
};

var serveBundleFromClientSite = getFlag('serve-osiris-bundle-from-clientsite', false) === true;
var stateParentKey = serveBundleFromClientSite ? 'WS' : 'OSIRIS';

var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC[stateParentKey] || !window.DDC[stateParentKey].state || !window.DDC[stateParentKey].state[widgetName]) {
    return {};
  }

  return window.DDC[stateParentKey].state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-detailed-pricing');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId); // We've initialized. We don't need to keep this data around anymore.
    // Deleting it ensures that we don't accidentally reinitialize later.

    if (serveBundleFromClientSite) {
      delete widgetStates[widgetId];
    }
  });
};

if (serveBundleFromClientSite) {
  initializeWidgets();
} else if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(11);

var _common = __webpack_require__(3);

var _DisclaimerContent = _interopRequireDefault(__webpack_require__(12));

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisclaimersModal = function DisclaimersModal(props) {
  var isModalVisible = props.isModalVisible,
      handleClose = props.handleClose,
      paymentInfo = props.paymentInfo;

  if (!paymentInfo) {
    return null;
  }

  var modalBody = '';
  var title = '';
  var _type = paymentInfo._type,
      dealershipName = paymentInfo.dealershipName;
  var placeholderValuesObj = (0, _utility.getDisclaimerPlaceholderObj)(paymentInfo);

  if (_type === 'LOAN') {
    title = _react.default.createElement(_common.Common, {
      render: function render(_ref) {
        var labels = _ref.labels;
        return labels.get(_labels.EST_FINANCE_DISCLAIMER_HEADING);
      }
    });
    modalBody = _react.default.createElement(_DisclaimerContent.default, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: _labels.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  if (_type === 'LEASE') {
    title = _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(_labels.EST_LEASE_DISCLAIMER_HEADING);
      }
    });
    modalBody = _react.default.createElement(_DisclaimerContent.default, {
      placeholderValuesObj: placeholderValuesObj,
      disclaimerLabel: _labels.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE,
      dealershipName: dealershipName
    });
  }

  return _react.default.createElement(_reactBootstrap.Modal, {
    show: isModalVisible,
    onHide: handleClose
  }, _react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: true
  }, _react.default.createElement(_reactBootstrap.Modal.Title, {
    className: "text-center"
  }, _react.default.createElement("span", {
    className: "h3 font-weight-bold"
  }, title))), _react.default.createElement(_reactBootstrap.Modal.Body, null, modalBody));
};

DisclaimersModal.defaultProps = {
  paymentInfo: null
};
DisclaimersModal.propTypes = {
  isModalVisible: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  paymentInfo: _propTypes.default.shape()
};
var _default = DisclaimersModal;
exports.default = _default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(11);

var _common = __webpack_require__(3);

var _utility = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstantEPriceButton = function InstantEPriceButton(props) {
  var isModalVisible = props.isModalVisible,
      loadingUserProfile = props.loadingUserProfile,
      userLoggedIn = props.userLoggedIn,
      handleClick = props.handleClick,
      buttonLabel = props.buttonLabel,
      pendingLabel = props.pendingLabel,
      vehicleId = props.vehicleId,
      vehicleCategory = props.vehicleCategory,
      pageAlias = props.pageAlias,
      buttonStyle = props.buttonStyle,
      buttonMobileClass = props.buttonMobileClass,
      disabled = props.disabled,
      preventMultipleEpriceLeads = props.preventMultipleEpriceLeads;
  var formUrl = "/instant-eprice-form.htm?itemId=".concat(vehicleId, "&vehicleId=").concat(vehicleId, "&category=").concat(vehicleCategory) + "&parentPageAlias=".concat(pageAlias, "&vcdaInstantEPrice");

  var allowLeadSubmission = function allowLeadSubmission() {
    // Don't submit a lead if preventMultipleEpriceLeads preference is set and user
    // has already submitted one
    return !(preventMultipleEpriceLeads && window.DDC.userProfile.ePriceVehicles && window.DDC.userProfileController.hasUserContactData());
  };

  var submitLeadConditionally = function submitLeadConditionally() {
    if (allowLeadSubmission()) {
      window.DDC.userProfileController.sendLeadForm(formUrl);
    }
  };

  var openModalOrSubmitLead = function openModalOrSubmitLead() {
    try {
      handleClick();
    } catch (error) {
      throw new Error('Unable to handle click.');
    } finally {
      submitLeadConditionally();
    }
  };

  var nonModalLogIn = userLoggedIn && !isModalVisible;
  var dataHrefAttr = nonModalLogIn ? null : formUrl; // if the user is logged in, we don't want to trigger a dialog in mobile (slide-in) or desktop (modal)

  var dialogClass = nonModalLogIn ? 'slidein-disabled' : 'dialog';
  var buttonDisplayClass = isModalVisible ? 'd-none' : '';
  var modalDisplayClass = isModalVisible ? '' : 'd-none';
  var spinningGears = loadingUserProfile ? _react.default.createElement("i", {
    className: "mr-3 ddc-icon ddc-icon-loading ddc-icon-animate-spin"
  }) : null;
  var buttonAllClassNames = (0, _utility.setClassNames)('btn-block', 'btn', "btn-".concat(buttonStyle), 'instant-eprice', "".concat(dialogClass), "".concat(buttonDisplayClass));
  var pendingLabelClassNames = (0, _utility.setClassNames)('instanteprice-pending', 'font-weight-bold', 'text-success', 'text-center', "".concat(modalDisplayClass));

  var tooltip = _react.default.createElement(_reactBootstrap.Tooltip, {
    className: "tooltip",
    id: "tooltip",
    style: {
      color: 'red'
    }
  }, _react.default.createElement(_common.Common, {
    render: function render(_ref) {
      var labels = _ref.labels;
      return labels.get(_labels.INSTANT_EPRICE_DISABLED_POPOVER);
    }
  }));

  var disabledButton = _react.default.createElement("div", {
    className: "disabled"
  }, _react.default.createElement(_reactBootstrap.OverlayTrigger, {
    placement: "left",
    overlay: tooltip,
    trigger: ['hover', 'click']
  }, _react.default.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4 ".concat(buttonMobileClass)
  }, _react.default.createElement("button", {
    className: buttonAllClassNames,
    "data-width": "600px",
    disabled: true
  }, buttonLabel))));

  var regularButton = _react.default.createElement("div", null, _react.default.createElement("div", {
    key: "epriceButtonContainer",
    className: "instantEPriceButton mb-sm-4 ".concat(buttonMobileClass)
  }, _react.default.createElement("button", {
    className: buttonAllClassNames,
    onClick: openModalOrSubmitLead,
    rel: "nofollow",
    "data-vehicle-uuid": vehicleId,
    "data-href": dataHrefAttr,
    "data-width": "600px"
  }, spinningGears, buttonLabel), _react.default.createElement("div", {
    key: "label",
    className: pendingLabelClassNames
  }, pendingLabel)));

  return disabled ? disabledButton : regularButton;
};

InstantEPriceButton.propTypes = {
  isModalVisible: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  loadingUserProfile: _propTypes.default.bool.isRequired,
  userLoggedIn: _propTypes.default.bool.isRequired,
  buttonLabel: _propTypes.default.string.isRequired,
  pendingLabel: _propTypes.default.string.isRequired,
  handleClick: _propTypes.default.func.isRequired,
  vehicleId: _propTypes.default.string.isRequired,
  vehicleCategory: _propTypes.default.string.isRequired,
  pageAlias: _propTypes.default.string.isRequired,
  buttonStyle: _propTypes.default.string.isRequired,
  buttonMobileClass: _propTypes.default.string.isRequired,
  preventMultipleEpriceLeads: _propTypes.default.bool.isRequired
};
var _default = InstantEPriceButton;
exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoanLeaseModal = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactBootstrap = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LoanLeaseModal = function LoanLeaseModal(_ref) {
  var options = _extends({}, _ref);

  var showState = options.showState,
      closeMethod = options.closeMethod,
      title = options.title,
      body = options.body,
      isMobile = options.isMobile;
  return _react.default.createElement(_reactBootstrap.Modal, {
    show: showState,
    onHide: function onHide() {
      return closeMethod();
    },
    className: "m-1 ".concat(isMobile ? 'dock-right' : null),
    animation: !isMobile
  }, _react.default.createElement("div", {
    className: "m-1"
  }, _react.default.createElement(_reactBootstrap.Modal.Header, null, _react.default.createElement(_reactBootstrap.Modal.Title, {
    className: "text-center"
  }, _react.default.createElement("button", {
    type: "button",
    "aria-label": "Close",
    className: "close text-muted",
    onClick: function onClick() {
      return closeMethod();
    }
  }, _react.default.createElement("i", {
    className: "ddc-icon ddc-icon-close",
    "aria-hidden": "true"
  })), _react.default.createElement("h3", {
    className: "my-0 px-5"
  }, title))), _react.default.createElement(_reactBootstrap.Modal.Body, null, body)));
};

exports.LoanLeaseModal = LoanLeaseModal;
LoanLeaseModal.propTypes = {
  showState: _propTypes.default.bool.isRequired,
  closeMethod: _propTypes.default.func.isRequired,
  title: _propTypes.default.element.isRequired,
  body: _propTypes.default.element.isRequired
};
var _default = LoanLeaseModal;
exports.default = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentCalculatorButton = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _lodash = _interopRequireDefault(__webpack_require__(14));

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentCalculatorButton = function PaymentCalculatorButton(_ref) {
  var isLoanLeaseAvailable = _ref.isLoanLeaseAvailable,
      isScrollingSidebar = _ref.isScrollingSidebar,
      isMobile = _ref.isMobile,
      prefs = _ref.prefs,
      labels = _ref.labels;

  var handleButtonClick = function handleButtonClick() {
    if (isMobile) {
      var pubsub = (0, _lodash.default)(window, 'pubsub', undefined);

      if (pubsub) {
        pubsub.publish('openDRTools', 'payment');
        return;
      }
    }

    var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
    var scrollToSelector = '[data-widget-id="digital-retailing-1"]';
    var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;
    /* eslint no-undef: 0 */

    if (DDC && DDC.scrollToAnchor) {
      DDC.scrollToAnchor($(scrollToSelector), {
        heightAdj: pageHeaderHeight + _constants.OFFSET_INTEGRATED_DR_HEIGHT
      });
    }
  };

  var renderButton = function renderButton() {
    var paymentCalculatorButtonLabel = prefs.paymentCalculatorButtonLabel,
        paymentCalculatorButtonClasses = prefs.paymentCalculatorButtonClasses,
        paymentCalculatorButtonIcon = prefs.paymentCalculatorButtonIcon,
        paymentCalculatorButtonIconClasses = prefs.paymentCalculatorButtonIconClasses,
        paymentBoxBackground = prefs.paymentBoxBackground,
        paymentBoxPadding = prefs.paymentBoxPadding;
    var buttonWrapperClasses = ["py-".concat(paymentBoxPadding)];

    if (!isScrollingSidebar) {
      var applyBoxPadding;
      var applyBoxBackground;
      var bottomPaddingClasses = "pb-".concat(paymentBoxPadding);

      if (isLoanLeaseAvailable) {
        applyBoxPadding = "px-".concat(paymentBoxPadding);
        applyBoxBackground = paymentBoxBackground;
      }

      buttonWrapperClasses = ['payment-calculator-wrapper', applyBoxBackground, applyBoxPadding, bottomPaddingClasses];
    }

    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: buttonWrapperClasses.filter(Boolean).join(' ')
    }, _react.default.createElement("button", {
      className: "btn btn-".concat(paymentCalculatorButtonClasses, " w-100"),
      onClick: handleButtonClick
    }, _react.default.createElement("i", {
      className: "ddc-icon ddc-icon-".concat(paymentCalculatorButtonIcon, " ").concat(paymentCalculatorButtonIconClasses)
    }), labels.get(paymentCalculatorButtonLabel))));
  };

  return renderButton();
};

exports.PaymentCalculatorButton = PaymentCalculatorButton;
PaymentCalculatorButton.propTypes = {
  isLoanLeaseAvailable: _propTypes.default.bool.isRequired,
  isScrollingSidebar: _propTypes.default.bool.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  prefs: _propTypes.default.shape({
    paymentCalculatorButtonLabel: _propTypes.default.string,
    paymentCalculatorButtonClasses: _propTypes.default.string,
    paymentCalculatorButtonIcon: _propTypes.default.string,
    paymentCalculatorButtonIconClasses: _propTypes.default.string,
    paymentBoxBackground: _propTypes.default.string,
    paymentBoxPadding: _propTypes.default.string
  }).isRequired,
  labels: _propTypes.default.shape({
    get: _propTypes.default.func.isRequired
  }).isRequired
};
var _default = PaymentCalculatorButton;
exports.default = _default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _utility = __webpack_require__(2);

var _CanadaDisclaimerContent = __webpack_require__(8);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingDetail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingDetail, _React$Component);

  function PricingDetail() {
    _classCallCheck(this, PricingDetail);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingDetail).apply(this, arguments));
  }

  _createClass(PricingDetail, [{
    key: "linkToModal",
    value: function linkToModal(isIncentive, incentiveId) {
      return isIncentive ? this.props.showModal(this.props.incentiveData.find(function (incentive) {
        return incentive.key === incentiveId;
      })) : false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          detail = _this$props.detail,
          detailType = _this$props.detailType,
          _this$props$prefs = _this$props.prefs,
          priceDiscountColor = _this$props$prefs.priceDiscountColor,
          finalPriceSize = _this$props$prefs.finalPriceSize,
          finalPriceColor = _this$props$prefs.finalPriceColor,
          locale = _this$props.locale,
          dealerAddress = _this$props.dealerAddress,
          isFinalPriceFlagEnabled = _this$props.isFinalPriceFlagEnabled;
      var _this$props$widgetInf = this.props.widgetInfo,
          deviceType = _this$props$widgetInf.deviceType,
          vehicleType = _this$props$widgetInf.vehicleType;
      var isMobile = deviceType === 'MOBILE';
      var adjustmentDetected = false;
      var vehicleTypeClass = vehicleType ? "inv-type-".concat(vehicleType.toLowerCase()) : ''; // TODO: remove when VCDA is fixed
      // Hack to get around VCDA error where the final ePrice has _type="MIDDLE" instead of "TOTAL"

      var lastPriceType;
      return _react.default.createElement("dl", {
        className: (0, _utility.setClassNames)('pricing-detail', 'line-height-condensed', 'mb-4', vehicleTypeClass)
      }, detail.map(function (price) {
        var _type = price._type,
            incentiveId = price.incentiveId,
            formatted = price.formatted,
            isFinalPrice = price.isFinalPrice;
        var typeClass = price.typeClass;
        var formattedValue = formatted;
        var valueClass = '';

        if (formattedValue === _labels.PLEASE_CALL) {
          valueClass = 'no-value';
          formattedValue = _react.default.createElement(_common.Common, {
            render: function render(_ref) {
              var labels = _ref.labels;
              return labels.get(_labels.PLEASE_CALL);
            }
          });
        }

        var isStackedFinal = _type === 'SICF' || _type === 'SIF';
        var isPlusMinus = _type === '-' || _type === '+';
        var isSubtractedTypes = ['-', // Discount
        'EPRICE', // Now indicates "ePrice difference"
        'SICI', // Stack Itemized Cash Incentive
        'SICCI', // Stack Itemized Conditional Cash Incentive
        'SICNI', // Stack non-Itemized Cash Incentives
        'SICCNI', // Stack non-Itemized Conditional Cash Incentive
        'CCIC' // Conditional Category Incentive Cash
        ];
        var isSubtracted = isSubtractedTypes.includes(_type);
        var isTotal = _type === 'TOTAL' || // Represents the last price in the rule
        _type === 'SICF' || // Final price including conditional incentives
        _type === 'SIF' || // Final price including stack incentives
        isFinalPrice;
        var isEpriceFinal; // Remove when removing flag

        if (isFinalPriceFlagEnabled) {
          // Keep the next line when removing flag and make isEpriceFinal a const
          isEpriceFinal = detailType === 'ePrice' && _type === 'TOTAL'; // TODO: remove when VCDA is fixed
          // Hack to get around VCDA error where the final ePrice has _type="MIDDLE" instead of "TOTAL"

          isEpriceFinal = isEpriceFinal || detailType === 'ePrice' && lastPriceType === 'EPRICE';
        } else {
          isEpriceFinal = detailType === 'ePrice' && isFinalPrice;
        }

        var isIncentive = !!incentiveId;

        var incentiveLinkMarkup = _react.default.createElement("button", {
          className: (0, _utility.setClassNames)('text-link', 'd-block', isMobile ? 'ddc-font-size-small' : 'ddc-font-size-xsmall')
        }, _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var labels = _ref2.labels;
            return labels.get(_labels.DETAILS);
          }
        }));

        var lineBreakMarkup = _react.default.createElement("dd", {
          className: "pricing-divider my-3",
          key: "".concat(_type, "-divider")
        });

        var hasLineBreak = false;
        var subtractedValueClass = '';
        var totalValueClass = '';
        var ePriceClass = '';
        var formattedPrice = formattedValue;
        var canadaDisclaimerMarkup = null;

        if (isStackedFinal) {
          hasLineBreak = true;
        }

        if (isPlusMinus) {
          adjustmentDetected = true;
          hasLineBreak = false;
        } else {
          if (adjustmentDetected === true) {
            hasLineBreak = true;
          }

          adjustmentDetected = false;
        }

        if (isSubtracted) {
          if (formatted === _labels.PLEASE_CALL) {
            formattedPrice = formattedValue;
          } else {
            formattedPrice = isMobile ? "- ".concat(formattedValue) : "-".concat(formattedValue);
            subtractedValueClass = "".concat(priceDiscountColor);
          }
        }

        if (isTotal) {
          totalValueClass = 'font-weight-bold';
        }

        if (isEpriceFinal) {
          ePriceClass = 'eprice';
        }

        if (isFinalPrice) {
          typeClass = 'final-price';
          totalValueClass = "".concat(totalValueClass, " ").concat(finalPriceColor); // suppressing finalPriceSize for final pricing that contains PLEASE_CALL value

          if (formatted !== _labels.PLEASE_CALL) {
            totalValueClass = "".concat(totalValueClass, " ").concat(finalPriceSize);
            canadaDisclaimerMarkup = _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
              dealerAddress: dealerAddress
            });
          }
        }

        var isStyleEditable = vehicleTypeClass !== '' && typeClass !== ''; // TODO: remove when VCDA is fixed
        // Hack to get around VCDA error where the final ePrice has _type="MIDDLE" instead of "TOTAL"

        lastPriceType = _type;
        return [hasLineBreak ? lineBreakMarkup : '', _react.default.createElement("dt", {
          "data-style-editor-price": isStyleEditable ? 'true' : null,
          className: (0, _utility.setClassNames)(isIncentive ? 'pointer' : '', isStyleEditable ? typeClass : ''),
          onClick: function onClick() {
            _this.linkToModal(isIncentive, incentiveId);
          },
          key: "".concat(_type, "-dt")
        }, _react.default.createElement(_common.Common, {
          render: function render(_ref3) {
            var prefs = _ref3.prefs,
                labels = _ref3.labels;
            var label = PricingDetail.getLabel({
              price: price,
              prefs: prefs,
              labels: labels,
              locale: locale
            });
            return _react.default.createElement(_LabelAsHTML.default, {
              label: label,
              isStyleEditable: isStyleEditable,
              typeClass: typeClass,
              vehicleTypeClass: vehicleTypeClass
            });
          }
        }), isIncentive ? incentiveLinkMarkup : ''), _react.default.createElement("dd", {
          "data-style-editor-price": isStyleEditable ? 'true' : null,
          onClick: function onClick() {
            _this.linkToModal(isIncentive, incentiveId);
          },
          className: (0, _utility.setClassNames)(subtractedValueClass, totalValueClass, ePriceClass, isIncentive ? 'pointer' : '', isStyleEditable ? typeClass : ''),
          key: "".concat(_type, "-dd")
        }, _react.default.createElement("span", {
          className: (0, _utility.setClassNames)('price-value', valueClass),
          "data-style-editor-id": isStyleEditable ? "vdp-".concat(typeClass, "-price-value") : null,
          "data-style-editor-text": isStyleEditable ? ".vdp .".concat(vehicleTypeClass, ".pricing-detail .").concat(typeClass, " .price-value") : null
        }, formattedPrice)), canadaDisclaimerMarkup];
      }));
    }
  }], [{
    key: "getLabel",
    value: function getLabel(_ref4) {
      var price = _ref4.price,
          prefs = _ref4.prefs,
          labels = _ref4.labels,
          locale = _ref4.locale;
      var title = price.title,
          shortTitle = price.shortTitle,
          typeClass = price.typeClass,
          isFinalPrice = price.isFinalPrice,
          incentiveId = price.incentiveId;
      var label = price.label; // Conditional final price label is coming from BE as a label ID and not a translated label.
      // TODO remove this logic once CONDITIONAL_FINAL_PRICE label is being properly translated from BE.

      if (label === 'CONDITIONAL_FINAL_PRICE') {
        label = labels.get('CONDITIONAL_FINAL_PRICE');
      }

      var titlePref = prefs.incentiveTitleDisplay;
      var incentiveLabel = label;

      if (incentiveId) {
        if (title && title[locale] && titlePref === 'regular') {
          incentiveLabel = title[locale];
        }

        if (shortTitle && shortTitle[locale] && titlePref === 'descriptive') {
          incentiveLabel = shortTitle[locale];
        }

        if (titlePref === 'custom' && typeClass === 'discount' && !isFinalPrice) {
          incentiveLabel = labels.get(prefs.incentiveTitleCustom);
        }
      }

      return incentiveLabel;
    }
  }]);

  return PricingDetail;
}(_react.default.Component);

exports.default = PricingDetail;
PricingDetail.propTypes = {
  detail: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    typeClass: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool,
    incentives: _propTypes.default.arrayOf(_propTypes.default.string)
  })).isRequired,
  detailType: _propTypes.default.string,
  incentiveData: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    error: _propTypes.default.string
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    vehicleType: _propTypes.default.string.isRequired
  }).isRequired,
  showModal: _propTypes.default.func.isRequired,
  prefs: _propTypes.default.shape({
    priceDiscountColor: _propTypes.default.string,
    finalPriceSize: _propTypes.default.string,
    finalPriceColor: _propTypes.default.string
  }).isRequired,
  locale: _propTypes.default.string,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isFinalPriceFlagEnabled: _propTypes.default.bool.isRequired
};
PricingDetail.defaultProps = {
  detailType: '',
  locale: 'en_US',
  dealerAddress: {}
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _LoanLeaseModal = __webpack_require__(19);

var _DisclaimerContent = _interopRequireDefault(__webpack_require__(12));

var _constants = __webpack_require__(6);

var _utility = __webpack_require__(2);

var _labels = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var PricingLoanLease =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingLoanLease, _React$Component);

  function PricingLoanLease() {
    var _this;

    _classCallCheck(this, PricingLoanLease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingLoanLease).call(this));
    _this.state = {
      showDisclaimer: false,
      disclaimerTitle: _react.default.createElement("span", null),
      disclaimerContent: _react.default.createElement("span", null)
    };
    _this.renderLayout = _this.renderLayout.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getLoanLeaseModalOptions = _this.getLoanLeaseModalOptions.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.toggleDisclaimer = _this.toggleDisclaimer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderList = _this.renderList.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingLoanLease, [{
    key: "getLoanLeaseModalOptions",
    value: function getLoanLeaseModalOptions(isMobile) {
      var _this$state = this.state,
          showDisclaimer = _this$state.showDisclaimer,
          disclaimerTitle = _this$state.disclaimerTitle,
          disclaimerContent = _this$state.disclaimerContent;
      return {
        isMobile: isMobile,
        showState: showDisclaimer,
        closeMethod: this.toggleDisclaimer,
        title: disclaimerTitle,
        body: disclaimerContent
      };
    }
  }, {
    key: "toggleDisclaimer",
    value: function toggleDisclaimer() {
      var disclaimerTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.default.createElement("span", null);
      var disclaimerContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _react.default.createElement("span", null);
      this.setState({
        showDisclaimer: !this.state.showDisclaimer,
        disclaimerTitle: disclaimerTitle,
        disclaimerContent: disclaimerContent
      });
    }
  }, {
    key: "renderList",
    value: function renderList(item, index, listSize, labels) {
      var toggleDisclaimer = this.toggleDisclaimer;
      var _type = item._type,
          label = item.label,
          formatted = item.formatted,
          dealershipName = item.dealershipName;
      var isLeasePayment = _type === _constants.LEASE;
      var SECOND_ITEM = 2;
      var disclaimer = isLeasePayment ? _labels.FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE : _labels.FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE;
      var disclaimerPlaceholder = (0, _utility.getDisclaimerPlaceholderObj)(item);
      var disclaimerTitle = isLeasePayment ? _labels.EST_LEASE_DISCLAIMER_HEADING : _labels.EST_FINANCE_DISCLAIMER_HEADING;
      var listPosition = listSize === SECOND_ITEM ? 'two-item' : 'one-item';
      var border = index === SECOND_ITEM ? 'border-left' : null;
      var listClass = [listPosition, border];

      var DynamicDisclaimerContent = _react.default.createElement(_DisclaimerContent.default, {
        placeholderValuesObj: disclaimerPlaceholder,
        disclaimerLabel: disclaimer,
        dealershipName: dealershipName
      });

      var iconHtml = _react.default.createElement("i", {
        className: "ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1"
      });

      var labelHtml = _react.default.createElement("span", {
        className: "text-muted d-block text-nowrap"
      }, labels.get(label), _react.default.createElement("button", {
        className: "btn-link p-0",
        onClick: function onClick() {
          return toggleDisclaimer(labels.get(disclaimerTitle), DynamicDisclaimerContent);
        }
      }, iconHtml));

      var priceHtml = _react.default.createElement("strong", {
        className: "line-height-reset font-weight-bold ddc-font-size-large"
      }, formatted);

      var termHtml = _react.default.createElement("span", {
        className: "ddc-font-size-small text-muted"
      }, labels.get('SLASH_MO'));

      return _react.default.createElement("li", {
        className: "".concat(listClass.filter(Boolean).join(' ')),
        key: "".concat(label)
      }, labelHtml, _react.default.createElement("span", null, priceHtml, termHtml));
    }
  }, {
    key: "renderLayout",
    value: function renderLayout(_ref) {
      var labels = _ref.labels,
          prefs = _ref.prefs;
      var summary = this.props.summary;
      var renderList = this.renderList;
      var paymentBoxPadding = prefs.paymentBoxPadding,
          paymentBoxBackground = prefs.paymentBoxBackground;
      var layoutClasses = 'pricing-loan-lease list-unstyled d-flex mb-0';
      var paddingClasses = "px-".concat(paymentBoxPadding, " py-").concat(paymentBoxPadding);
      var componentClasses = [layoutClasses, paddingClasses, paymentBoxBackground];
      return _react.default.createElement("ul", {
        className: componentClasses.join(' ')
      }, summary.map(function (item, index) {
        return renderList(item, index + 1, summary.length, labels);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          isScrollingSidebar = _this$props.isScrollingSidebar;
      var renderLoanLease = null;

      if (!isScrollingSidebar) {
        /* props for the LoanLeaseModal component */
        var options = this.getLoanLeaseModalOptions(isMobile);
        renderLoanLease = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_common.Common, {
          render: this.renderLayout
        }), _react.default.createElement(_LoanLeaseModal.LoanLeaseModal, options));
      }

      return renderLoanLease;
    }
  }]);

  return PricingLoanLease;
}(_react.default.Component);

PricingLoanLease.propTypes = {
  isMobile: _propTypes.default.bool.isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    key: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  isScrollingSidebar: _propTypes.default.bool.isRequired
};
var _default = PricingLoanLease;
exports.default = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _PricingSummary = _interopRequireDefault(__webpack_require__(13));

var _PricingSummaryPortal = _interopRequireDefault(__webpack_require__(29));

var _PricingSummaryFooterPortal = _interopRequireDefault(__webpack_require__(26));

var _analytics = __webpack_require__(10);

var _constants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isBrowser = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';

var PricingSummaryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryContainer, _React$Component);

  function PricingSummaryContainer(props) {
    var _this;

    _classCallCheck(this, PricingSummaryContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryContainer).call(this, props));
    _this.viewPriceDetail = _this.viewPriceDetail.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.scrollToAnchor = _this.scrollToAnchor.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(PricingSummaryContainer, [{
    key: "viewPriceDetail",
    value: function viewPriceDetail() {
      var _this$props$widgetInf = this.props.widgetInfo,
          widgetName = _this$props$widgetInf.widgetName,
          windowId = _this$props$widgetInf.windowId;
      (0, _analytics.priceDetailsScrollEvent)(widgetName, windowId);
      this.scrollToAnchor();
    }
  }, {
    key: "scrollToAnchor",
    value: function scrollToAnchor() {
      var deviceType = this.props.widgetInfo.deviceType;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';
      var headerSelector = document && document.querySelector('[data-widget-id="template-navigation1"]');
      var scrollToSelector = '[data-widget-id="vehicle-title1"]';

      if (isMobile) {
        headerSelector = document && document.querySelector('[data-widget-id="template-navbar1"]');
        scrollToSelector = '[data-widget-id="detailed-pricing1"]';
      }

      var pageHeaderHeight = headerSelector && headerSelector.clientHeight || 0;

      if (DDC && DDC.scrollToAnchor) {
        /* eslint no-undef: 0 */
        DDC.scrollToAnchor($(scrollToSelector), {
          heightAdj: pageHeaderHeight + _constants.OFFSET_HEIGHT
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var deviceType = this.props.widgetInfo.deviceType;
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          prefs = _this$props.prefs,
          summary = _this$props.summary,
          widgetInfo = _this$props.widgetInfo;
      var isMobile = deviceType.toUpperCase() === 'MOBILE';

      if (isMobile) {
        if (isBrowser) {
          return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_PricingSummaryPortal.default, {
            prefs: prefs,
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            widgetInfo: widgetInfo,
            dealerAddress: dealerAddress,
            isMobile: isMobile
          }), _react.default.createElement(_PricingSummaryFooterPortal.default, {
            summary: summary,
            viewPriceDetail: this.viewPriceDetail,
            dealerAddress: dealerAddress
          }));
        }

        return null;
      }

      return _react.default.createElement(_PricingSummary.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: this.viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      });
    }
  }]);

  return PricingSummaryContainer;
}(_react.default.Component);

exports.default = PricingSummaryContainer;
PricingSummaryContainer.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  })
};
PricingSummaryContainer.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryFinalPrice = function PricingSummaryFinalPrice(_ref) {
  var price = _ref.price,
      buttonResetClasses = _ref.buttonResetClasses,
      viewPriceDetail = _ref.viewPriceDetail,
      finalLabelSize = _ref.finalLabelSize,
      finalPrice = _ref.finalPrice,
      finalPriceSize = _ref.finalPriceSize;

  if (price && price.isFinalPrice && finalPrice && viewPriceDetail) {
    return _react.default.createElement("button", {
      className: "".concat(buttonResetClasses, " w-100"),
      onClick: viewPriceDetail
    }, _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('text-muted', 'd-block', finalLabelSize)
    }, _react.default.createElement(_LabelAsHTML.default, {
      label: price.label
    }), ' '), _react.default.createElement("strong", {
      className: (0, _utility.setClassNames)('line-height-reset', finalPriceSize)
    }, finalPrice));
  }

  return null;
};

PricingSummaryFinalPrice.propTypes = {
  price: _propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool.isRequired
  }).isRequired,
  buttonResetClasses: _propTypes.default.string,
  viewPriceDetail: _propTypes.default.func.isRequired,
  finalLabelSize: _propTypes.default.string,
  finalPrice: _propTypes.default.string.isRequired,
  finalPriceSize: _propTypes.default.string
};
PricingSummaryFinalPrice.defaultProps = {
  buttonResetClasses: '',
  finalLabelSize: '',
  finalPriceSize: ''
};
var _default = PricingSummaryFinalPrice;
exports.default = _default;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(2);

__webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryFooter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooter, _React$Component);

  function PricingSummaryFooter() {
    _classCallCheck(this, PricingSummaryFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooter).apply(this, arguments));
  }

  _createClass(PricingSummaryFooter, [{
    key: "render",
    value: function render() {
      var _this = this;

      var summary = this.props.summary;
      var displayPrice = summary.find(function (price) {
        return price.isFinalPrice;
      });

      if (!displayPrice) {
        return null;
      }

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          var dealershipNamePriceText = (0, _utility.replacePlaceholders)(labels.get(_labels.DEALERSHIP_NAME_PRICE), {
            '<%=dealershipName%>': displayPrice.dealershipName
          });
          var formattedValue = displayPrice.formatted;

          if (formattedValue === _labels.PLEASE_CALL) {
            formattedValue = labels.get(_labels.PLEASE_CALL);
          }

          return (// using aria-hidden based on conversation with Rachael Arnold
            // and Jon Ferry. The data in the footer section is redundant
            // and comes after the detailed pricing data in the DOM
            _react.default.createElement("div", {
              onClick: _this.props.viewPriceDetail,
              role: "button",
              "aria-hidden": true
            }, _react.default.createElement("ul", {
              className: "pricing-summary list-unstyled line-height-condensed mb-2"
            }, _react.default.createElement("li", {
              className: "text-muted"
            }, _react.default.createElement("span", {
              className: "d-block text-truncate"
            }, dealershipNamePriceText)), _react.default.createElement("li", null, _react.default.createElement("strong", {
              className: "pr-3"
            }, formattedValue), _react.default.createElement("span", {
              className: "text-link"
            }, labels.get(_labels.DETAILS)))))
          );
        }
      });
    }
  }]);

  return PricingSummaryFooter;
}(_react.default.Component);

exports.default = PricingSummaryFooter;
PricingSummaryFooter.propTypes = {
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(7));

var _PricingSummaryFooter = _interopRequireDefault(__webpack_require__(25));

var _utility = __webpack_require__(2);

var _CanadaDisclaimerContent = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryFooterPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryFooterPortal, _React$Component);

  function PricingSummaryFooterPortal(props) {
    var _this;

    _classCallCheck(this, PricingSummaryFooterPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryFooterPortal).call(this, props));
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(PricingSummaryFooterPortal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerEl) {
        this.containerEl.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.containerEl = (0, _utility.getDOMContainer)(document, '.ddc-detailed-pricing-footer');

      if (this.containerEl) {
        this.containerEl.appendChild(this.el);
      }

      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary;

      var summaryComp = _react.default.createElement("div", null, _react.default.createElement(_PricingSummaryFooter.default, {
        summary: summary,
        viewPriceDetail: viewPriceDetail
      }), _react.default.createElement(_CanadaDisclaimerContent.CaDisclaimer, {
        dealerAddress: dealerAddress,
        isFooter: true
      })); // if there is a pricing footer, render in portal


      if (this.containerEl) {
        return _reactDom.default.createPortal(summaryComp, this.el);
      }

      return summaryComp;
    }
  }]);

  return PricingSummaryFooterPortal;
}(_react.default.Component);

exports.default = PricingSummaryFooterPortal;
PricingSummaryFooterPortal.propTypes = {
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  viewPriceDetail: _propTypes.default.func.isRequired
};
PricingSummaryFooterPortal.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryLink = function PricingSummaryLink(_ref) {
  var label = _ref.label,
      labelFontSize = _ref.labelFontSize,
      isCalculatePayment = _ref.isCalculatePayment,
      viewPriceDetail = _ref.viewPriceDetail;
  var calcPaymentClasses = isCalculatePayment ? ['calculate-payment-integrated', 'calculate-payment-scroll-up'] : [];

  if (label) {
    return _react.default.createElement("button", {
      onClick: !isCalculatePayment ? viewPriceDetail : null,
      className: _utility.setClassNames.apply(void 0, ['text-link', 'text-left', 'd-block', 'line-height-reset', labelFontSize].concat(calcPaymentClasses))
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return labels.get(label);
      }
    }));
  }

  return null;
};

PricingSummaryLink.propTypes = {
  label: _propTypes.default.string.isRequired,
  labelFontSize: _propTypes.default.string,
  isCalculatePayment: _propTypes.default.bool,
  viewPriceDetail: _propTypes.default.func
};
PricingSummaryLink.defaultProps = {
  labelFontSize: '',
  isCalculatePayment: false,
  viewPriceDetail: function viewPriceDetail() {}
};
var _default = PricingSummaryLink;
exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _LabelAsHTML = _interopRequireDefault(__webpack_require__(9));

var _labels = __webpack_require__(4);

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingSummaryPayments = function PricingSummaryPayments(_ref) {
  var price = _ref.price,
      paymentLabelSize = _ref.paymentLabelSize,
      paymentPrice = _ref.paymentPrice,
      paymentPriceSize = _ref.paymentPriceSize,
      handleHelpCircleIcon = _ref.handleHelpCircleIcon;

  if (price && !price.isFinalPrice && paymentPrice) {
    return _react.default.createElement("span", {
      className: "flex-grow-1"
    }, _react.default.createElement("span", {
      className: (0, _utility.setClassNames)('text-muted', 'text-nowrap', 'd-block', paymentLabelSize)
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref2) {
        var labels = _ref2.labels;
        return _react.default.createElement(_LabelAsHTML.default, {
          label: labels.get(price.label)
        });
      }
    }), _react.default.createElement("button", {
      className: "text-link line-height-reset help-icon",
      onClick: handleHelpCircleIcon
    }, _react.default.createElement("i", {
      className: "ddc-icon ddc-icon-help-circle text-muted d-inline-block pl-1"
    }))), _react.default.createElement("strong", {
      className: (0, _utility.setClassNames)('line-height-reset', paymentPriceSize)
    }, paymentPrice), _react.default.createElement("span", {
      className: "ddc-font-size-small text-muted d-inline line-height-reset"
    }, _react.default.createElement(_common.Common, {
      render: function render(_ref3) {
        var labels = _ref3.labels;
        return labels.get(_labels.SLASH_MO);
      }
    })));
  }

  return null;
};

PricingSummaryPayments.propTypes = {
  price: _propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool.isRequired
  }).isRequired,
  paymentLabelSize: _propTypes.default.string,
  paymentPrice: _propTypes.default.string.isRequired,
  paymentPriceSize: _propTypes.default.string,
  handleHelpCircleIcon: _propTypes.default.func.isRequired
};
PricingSummaryPayments.defaultProps = {
  paymentLabelSize: '',
  paymentPriceSize: ''
};
var _default = PricingSummaryPayments;
exports.default = _default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(7));

var _PricingSummary = _interopRequireDefault(__webpack_require__(13));

var _utility = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PricingSummaryPortal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PricingSummaryPortal, _React$Component);

  function PricingSummaryPortal() {
    _classCallCheck(this, PricingSummaryPortal);

    return _possibleConstructorReturn(this, _getPrototypeOf(PricingSummaryPortal).apply(this, arguments));
  }

  _createClass(PricingSummaryPortal, [{
    key: "render",
    value: function render() {
      this.containerEl = (0, _utility.getDOMContainer)(document, '.ddc-vehicle-pricing-summary');
      var _this$props = this.props,
          dealerAddress = _this$props.dealerAddress,
          viewPriceDetail = _this$props.viewPriceDetail,
          summary = _this$props.summary,
          prefs = _this$props.prefs,
          widgetInfo = _this$props.widgetInfo,
          isMobile = _this$props.isMobile;

      var summaryComp = _react.default.createElement(_PricingSummary.default, {
        prefs: prefs,
        summary: summary,
        viewPriceDetail: viewPriceDetail,
        widgetInfo: widgetInfo,
        dealerAddress: dealerAddress,
        isMobile: isMobile
      }); // if there is a pricing summary, render in portal


      if (this.containerEl) {
        return _reactDom.default.createPortal(summaryComp, this.containerEl);
      }

      return null;
    }
  }]);

  return PricingSummaryPortal;
}(_react.default.Component);

exports.default = PricingSummaryPortal;
PricingSummaryPortal.propTypes = {
  prefs: _propTypes.default.shape({
    showStickySidebarLoanLease: _propTypes.default.string
  }).isRequired,
  summary: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired
  })).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired
  }).isRequired,
  viewPriceDetail: _propTypes.default.func.isRequired,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  isMobile: _propTypes.default.bool.isRequired
};
PricingSummaryPortal.defaultProps = {
  dealerAddress: {}
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _lodash = _interopRequireDefault(__webpack_require__(14));

var _melankeWatchjs = _interopRequireDefault(__webpack_require__(55));

var _InstantEPriceButton = _interopRequireDefault(__webpack_require__(18));

var _utility = __webpack_require__(2);

var _analytics = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var InstantEPriceContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InstantEPriceContainer, _React$Component);

  function InstantEPriceContainer(props) {
    var _this;

    _classCallCheck(this, InstantEPriceContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InstantEPriceContainer).call(this, props));
    _this.state = {
      isModalVisible: false,
      loadingUserProfile: true,
      userLoggedIn: false
    };
    _this.modalOpen = _this.modalOpen.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.modalClose = _this.modalClose.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.internalShowEprice = _this.internalShowEprice.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.checkUserProfile = _this.checkUserProfile.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(InstantEPriceContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _window = window,
          pubsub = _window.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.complete', function () {
          _this2.internalShowEprice();
        });
      } // if userProfile is loaded (!== undefined)


      if (window.DDC && window.DDC.userProfile) {
        this.checkUserProfile();
      } // if userProfile is not loaded yet (=== undefined) OR userProfile change its value


      _melankeWatchjs.default.watch(window.DDC, 'userProfile', this.checkUserProfile); // required to make instant eprice work on mobile


      var ddcSlideIn = (0, _lodash.default)(window, 'DDC.mobile.slidein', undefined);

      if (this.props.isMobile && ddcSlideIn) {
        ddcSlideIn.init();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _melankeWatchjs.default.noMore = true;
    }
  }, {
    key: "checkUserProfile",
    value: function checkUserProfile() {
      var _this3 = this;

      var userProfile = (0, _lodash.default)(window, 'DDC.userProfile', undefined);

      if (userProfile) {
        this.setState({
          loadingUserProfile: false
        });

        if (this.props.instantEpriceShowAllAfterLeadSubmit === 'true' && userProfile && Object.entries(userProfile).length !== 0 && !this.state.isModalVisible) {
          this.internalShowEprice();
        } else {
          var ePriceVehicles = userProfile.ePriceVehicles;

          if (ePriceVehicles) {
            var found = ePriceVehicles.find(function (vehicle) {
              return vehicle.itemUUID === _this3.props.widgetInfo.vehicleId;
            }); // when user has the vehicle in their profile

            if (found && !this.state.isModalVisible) {
              this.internalShowEprice();
            } // when user does not have the vehicle in their profile but logs into MyCars
            else if (userProfile.profileId) {
                this.setState({
                  userLoggedIn: true
                });
              }
          }
        }
      }
    }
  }, {
    key: "internalShowEprice",
    value: function internalShowEprice(e) {
      var _window2 = window,
          pubsub = _window2.pubsub;
      var ePriceDetail = this.props.ePriceDetail; // vcda does not always return an eprice detail

      if (ePriceDetail && pubsub) {
        var _extractEPriceData = (0, _utility.extractEPriceData)(ePriceDetail),
            ePriceValue = _extractEPriceData.ePriceValue,
            ePriceDifference = _extractEPriceData.ePriceDifference;

        pubsub.publish('instant-eprice.show', {
          ePriceDifference: ePriceDifference,
          yourEPrice: ePriceValue
        });
      }

      this.props.showEPrice();
      _melankeWatchjs.default.noMore = true;

      if (e) {
        (0, _analytics.ePriceButtonTrackEvent)(this.props.buttonLabel, this.props.widgetInfo.widgetName, this.props.widgetInfo.windowId, false);
      }
    }
  }, {
    key: "modalClose",
    value: function modalClose() {
      this.setState({
        isModalVisible: false
      });
      var _window3 = window,
          pubsub = _window3.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.open', this.modalOpen);
      }
    }
  }, {
    key: "modalOpen",
    value: function modalOpen() {
      this.setState({
        isModalVisible: true
      });
      var _window4 = window,
          pubsub = _window4.pubsub;

      if (pubsub) {
        pubsub.subscribe('instant-eprice.cancel', this.modalClose);
      }

      (0, _analytics.ePriceButtonTrackEvent)(this.props.buttonLabel, this.props.widgetInfo.widgetName, this.props.widgetInfo.windowId, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isDisplayingEprice = _this$props.isDisplayingEprice,
          buttonLabel = _this$props.buttonLabel,
          pendingLabel = _this$props.pendingLabel,
          _this$props$widgetInf = _this$props.widgetInfo,
          vehicleId = _this$props$widgetInf.vehicleId,
          vehicleCategory = _this$props$widgetInf.vehicleCategory,
          pageAlias = _this$props$widgetInf.pageAlias,
          buttonStyle = _this$props.buttonStyle,
          buttonMobileClass = _this$props.buttonMobileClass,
          disabled = _this$props.disabled,
          preventMultipleEpriceLeads = _this$props.preventMultipleEpriceLeads;
      var clickAction = this.modalOpen;

      if (isDisplayingEprice) {
        return null;
      }

      if (this.state.userLoggedIn) {
        clickAction = this.internalShowEprice;
      }

      return _react.default.createElement(_InstantEPriceButton.default, {
        key: "button",
        userLoggedIn: this.state.userLoggedIn,
        loadingUserProfile: this.state.loadingUserProfile,
        isModalVisible: this.state.isModalVisible,
        buttonLabel: buttonLabel,
        pendingLabel: pendingLabel,
        handleClick: clickAction,
        vehicleId: vehicleId,
        vehicleCategory: vehicleCategory,
        pageAlias: pageAlias,
        buttonStyle: buttonStyle,
        buttonMobileClass: buttonMobileClass,
        disabled: disabled,
        preventMultipleEpriceLeads: preventMultipleEpriceLeads
      });
    }
  }]);

  return InstantEPriceContainer;
}(_react.default.Component);

InstantEPriceContainer.propTypes = {
  showEPrice: _propTypes.default.func.isRequired,
  isDisplayingEprice: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  ePriceDetail: _propTypes.default.arrayOf(_propTypes.default.shape({
    _type: _propTypes.default.string.isRequired,
    formatted: _propTypes.default.string.isRequired,
    key: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.number.isRequired,
    isFinalPrice: _propTypes.default.bool,
    incentives: _propTypes.default.arrayOf(_propTypes.default.string)
  })),
  buttonLabel: _propTypes.default.string.isRequired,
  pendingLabel: _propTypes.default.string.isRequired,
  widgetInfo: _propTypes.default.shape({
    vehicleId: _propTypes.default.string.isRequired,
    vehicleCategory: _propTypes.default.string.isRequired,
    pageAlias: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired
  }).isRequired,
  buttonStyle: _propTypes.default.string,
  buttonMobileClass: _propTypes.default.string.isRequired,
  instantEpriceShowAllAfterLeadSubmit: _propTypes.default.string,
  isMobile: _propTypes.default.bool.isRequired,
  preventMultipleEpriceLeads: _propTypes.default.bool.isRequired
};
InstantEPriceContainer.defaultProps = {
  ePriceDetail: [],
  buttonStyle: 'primary',
  instantEpriceShowAllAfterLeadSubmit: 'false'
};
var _default = InstantEPriceContainer;
exports.default = _default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidgetContainer = void 0;

var _reactRedux = __webpack_require__(15);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

var _wsmIncentiveModal = __webpack_require__(63);

var _utility = __webpack_require__(2);

var _PricingDetail = _interopRequireDefault(__webpack_require__(21));

var _PricingLoanLease = _interopRequireDefault(__webpack_require__(22));

var _PricingSummaryContainer = _interopRequireDefault(__webpack_require__(23));

var _InstantEPrice = _interopRequireDefault(__webpack_require__(30));

var _PaymentCalculatorButton = __webpack_require__(20);

var _labels = __webpack_require__(4);

__webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer(props) {
    var _this;

    _classCallCheck(this, WidgetContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).call(this, props));
    _this.state = {
      incentive: {},
      isModalVisible: false,
      isDisplayingEprice: false,
      isScrollingSidebar: false
    };
    _this.showEPrice = _this.showEPrice.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.trackScrollingSidebar = _this.trackScrollingSidebar.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.showModal = _this.showModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hideModal = _this.hideModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.deviceType === 'DESKTOP') {
        window.addEventListener('scroll', this.trackScrollingSidebar);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.deviceType === 'DESKTOP') {
        window.removeEventListener('scroll', this.trackScrollingSidebar);
      }
    }
  }, {
    key: "showModal",
    value: function showModal(incentive) {
      this.setState({
        incentive: incentive,
        isModalVisible: true
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      // deliberately do not reset the incentive so that
      // that data doesn't disappear as it slides off the screen,
      // esp. for mobile modal
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "showEPrice",
    value: function showEPrice() {
      this.setState({
        isDisplayingEprice: true
      });
    }
  }, {
    key: "trackScrollingSidebar",
    value: function trackScrollingSidebar() {
      // Tracks whether the sidebar is scrolling or not based on the height set
      this.setState({
        isScrollingSidebar: document.querySelector('.vdp-sidebar').style.top.length > 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pricing = _this$props.pricing,
          _this$props$widgetInf = _this$props.widgetInfo,
          widgetInfo = _this$props$widgetInf === void 0 ? {
        windowId: ''
      } : _this$props$widgetInf,
          incentiveData = _this$props.incentiveData,
          windowId = _this$props.windowId,
          widgetName = _this$props.widgetName,
          deviceType = _this$props.deviceType,
          locale = _this$props.locale,
          dealerAddress = _this$props.dealerAddress,
          _this$props$account = _this$props.account,
          account = _this$props$account === void 0 ? {
        name: ''
      } : _this$props$account;
      var accountId = widgetInfo.accountId,
          vehicleAccountId = widgetInfo.vehicleAccountId,
          vehicleType = widgetInfo.vehicleType;
      var isMobile = deviceType === 'MOBILE';
      var rootComponent;

      if (pricing) {
        var ePriceStatus = pricing.ePriceStatus;
        var disableInstantEpriceButton = false; // {epriceStatus : { status : <<enum>> }} where <<enum>> is one of the values below
        // ENABLED -> E-price is enabled/avaialble for the account, uuid combination.
        // DISABLED -> E-price is disabled/not available for the account, uuid combination. Reason for non availabilty is given in the reason string
        // NON_APPLICABLE -> E-price is not applicable for the account and uuid combination.

        if (ePriceStatus && ePriceStatus === 'DISABLED') {
          disableInstantEpriceButton = true;
        } // TODO: remove after VCDA release
        else if (!ePriceStatus && pricing.summary) {
            var eprice = pricing.summary.filter(function (x) {
              return x.priceType === 'EPRICE';
            })[0];
            var dprice = pricing.summary.filter(function (x) {
              return x.priceType === 'DPRICE';
            })[0];

            if (eprice && dprice) {
              disableInstantEpriceButton = !(eprice.value < dprice.value);
            }
          }

        var detailType = pricing.detail.ePrice && this.state.isDisplayingEprice ? 'ePrice' : 'dPrice';
        var summary = (0, _utility.filterSummary)(pricing.summary, detailType);
        var loanLeaseSummary = (0, _utility.filterLoanLease)(pricing.summary);
        var incentiveModal;

        if (Object.keys(incentiveData).length) {
          incentiveModal = _react.default.createElement(_common.Common, {
            render: function render(_ref) {
              var prefs = _ref.prefs,
                  sitemap = _ref.sitemap;
              return _react.default.createElement(_wsmIncentiveModal.IncentiveModal, {
                incentive: _this2.state.incentive,
                isOpen: _this2.state.isModalVisible,
                isMobile: isMobile,
                onModalClose: _this2.hideModal,
                widgetInfo: {
                  windowId: windowId,
                  widgetName: widgetName,
                  deviceType: deviceType
                },
                account: {
                  name: account.name,
                  id: account.id
                },
                newListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW'),
                usedListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_USED') // remove locale when when <Common /> is added to module
                ,
                locale: locale,
                prefs: prefs
              });
            }
          });
        }

        rootComponent = _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var flags = _ref2.flags,
                prefs = _ref2.prefs,
                labels = _ref2.labels;
            var ePricePendingLabel = labels.get(_labels.EPRICE_PENDING);
            var buttonMobileClass = prefs.showLoanLeasePricing === 'true' ? 'mb-4' : 'mb-0';
            var instantEpricePreventMultipleEpriceLeads = prefs.instantEpricePreventMultipleEpriceLeads === 'true';
            var instantEPriceContainer = (pricing.detail.ePrice || // TODO: remove once vcda flag for epricestatus is removed
            // and undefined ePriceStatus may denote that IEP is enabled but not configured
            // this check is the one place we can prevent the unconfigured IEP button from showing
            ePriceStatus && ePriceStatus !== 'NON_APPLICABLE') && ( // compare request account and vehicle account equality to determine
            // whether a vehicle is off-site
            prefs.showInstantEpriceForSharedInventory !== 'false' || accountId === vehicleAccountId) ? _react.default.createElement(_InstantEPrice.default, {
              showEPrice: _this2.showEPrice,
              isDisplayingEprice: _this2.state.isDisplayingEprice,
              instantEpriceShowAllAfterLeadSubmit: prefs.instantEpriceShowAllAfterLeadSubmit,
              ePriceDetail: pricing.detail.ePrice,
              buttonLabel: pricing.ePriceButtonLabel,
              pendingLabel: ePricePendingLabel,
              widgetInfo: _objectSpread({}, widgetInfo, {
                windowId: windowId,
                widgetName: widgetName
              }),
              buttonStyle: prefs.buttonStyleEPrice,
              buttonMobileClass: buttonMobileClass,
              preventMultipleEpriceLeads: instantEpricePreventMultipleEpriceLeads,
              isMobile: isMobile,
              disabled: disableInstantEpriceButton
            }) : null;
            var isFinalPriceFlagEnabled = flags['ws-detailed-pricing.use-final-price-for-instant-eprice'] === true;
            var DDCExists = typeof window !== 'undefined' && typeof window.DDC !== 'undefined';
            var drEnable = false;
            /* eslint no-undef: 0 */

            if (DDCExists && DDC.getSiteProperty) {
              drEnable = DDC.getSiteProperty(prefs.paymentCalculatorButtonDisplayCondition);
            }

            return _react.default.createElement("div", null, _react.default.createElement(_PricingDetail.default, {
              detail: pricing.detail[detailType],
              detailType: detailType,
              widgetInfo: {
                windowId: windowId,
                widgetName: widgetName,
                deviceType: deviceType,
                vehicleType: vehicleType
              },
              prefs: prefs,
              showModal: _this2.showModal,
              incentiveData: incentiveData,
              locale: locale,
              dealerAddress: dealerAddress,
              isFinalPriceFlagEnabled: isFinalPriceFlagEnabled
            }), _react.default.createElement(_PricingSummaryContainer.default, {
              summary: summary,
              prefs: prefs,
              dealerAddress: dealerAddress,
              widgetInfo: {
                windowId: windowId,
                widgetName: widgetName,
                deviceType: deviceType
              }
            }), instantEPriceContainer, loanLeaseSummary.length > 0 && prefs.showLoanLeasePricing === 'true' && _react.default.createElement(_PricingLoanLease.default, {
              summary: loanLeaseSummary,
              isMobile: isMobile,
              isScrollingSidebar: _this2.state.isScrollingSidebar
            }), drEnable && _react.default.createElement(_PaymentCalculatorButton.PaymentCalculatorButton, {
              isLoanLeaseAvailable: loanLeaseSummary.length > 0 && prefs.showLoanLeasePricing === 'true',
              isScrollingSidebar: _this2.state.isScrollingSidebar,
              isMobile: isMobile,
              prefs: prefs,
              labels: labels
            }), incentiveModal);
          }
        }) // Common
        ;
      }

      return rootComponent;
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

exports.WidgetContainer = WidgetContainer;
WidgetContainer.propTypes = {
  pricing: _propTypes.default.shape({
    detail: _propTypes.default.shape({
      dPrice: _propTypes.default.arrayOf(_propTypes.default.shape({
        _type: _propTypes.default.string.isRequired,
        formatted: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        value: _propTypes.default.number.isRequired,
        incentives: _propTypes.default.arrayOf(_propTypes.default.string)
      })).isRequired,
      ePrice: _propTypes.default.arrayOf(_propTypes.default.shape({
        _type: _propTypes.default.string.isRequired,
        formatted: _propTypes.default.string.isRequired,
        label: _propTypes.default.string.isRequired,
        value: _propTypes.default.number.isRequired,
        incentives: _propTypes.default.arrayOf(_propTypes.default.string)
      }))
    }),
    summary: _propTypes.default.arrayOf(_propTypes.default.shape({
      _type: _propTypes.default.string.isRequired,
      formatted: _propTypes.default.string.isRequired,
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.number.isRequired
    })),
    ePriceButtonLabel: _propTypes.default.string.isRequired,
    ePriceStatus: _propTypes.default.string
  }),
  incentiveData: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    disclaimer: _propTypes.default.string,
    make: _propTypes.default.string,
    condition: _propTypes.default.string,
    manufacturerOffer: _propTypes.default.bool,
    specific: _propTypes.default.object,
    error: _propTypes.default.string
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    vehicleId: _propTypes.default.string.isRequired,
    vehicleCategory: _propTypes.default.string.isRequired,
    vehicleType: _propTypes.default.string.isRequired,
    pageAlias: _propTypes.default.string.isRequired,
    accountId: _propTypes.default.string.isRequired,
    vehicleAccountId: _propTypes.default.string.isRequired
  }).isRequired,
  windowId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string.isRequired,
  deviceType: _propTypes.default.string.isRequired,
  locale: _propTypes.default.string,
  dealerAddress: _propTypes.default.shape({
    address1: _propTypes.default.string,
    address2: _propTypes.default.string,
    address3: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  account: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired
};
WidgetContainer.defaultProps = {
  pricing: [],
  locale: 'en_US',
  dealerAddress: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricing: state.pricing,
    widgetInfo: state.widgetInfo,
    incentiveData: state.incentive.incentiveData,
    windowId: state.requestData.windowId,
    widgetName: state.requestData.widgetName,
    deviceType: state.requestData.deviceType,
    locale: state.requestData.locale,
    dealerAddress: state.dealerAddress,
    account: state.account
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = account;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  name: ''
};

function account() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_ACCOUNT:
        return _objectSpread({}, state, action.payload);

      default:
    }
  }

  return state;
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dealerAddress;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  address1: '',
  address2: '',
  address3: '',
  city: '',
  state: '',
  postalCode: '',
  country: ''
};

function dealerAddress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_DEALER_ADDRESS:
        return _objectSpread({}, state, action.payload);

      default:
    }
  }

  return state;
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = incentive;

var _types = __webpack_require__(5);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  incentiveData: [{
    key: '',
    title: '',
    shortTitle: '',
    label: '',
    offerDetails: '',
    effectiveDate: '',
    expirationDate: '',
    conditional: false,
    disclaimer: '',
    make: '',
    condition: '',
    manufacturerOffer: false,
    specific: {},
    error: ''
  }]
};

function incentive() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error) {
    switch (action.type) {
      case _types.SET_INCENTIVE:
        return _objectSpread({}, state, {
          incentiveData: _toConsumableArray(state.incentiveData).concat(_toConsumableArray(action.payload))
        });

      default:
    }
  }

  return state;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dealerAddress = _interopRequireDefault(__webpack_require__(34));

var _pricing = _interopRequireDefault(__webpack_require__(38));

var _incentive = _interopRequireDefault(__webpack_require__(35));

var _modal = _interopRequireDefault(__webpack_require__(37));

var _widgetInfo = _interopRequireDefault(__webpack_require__(39));

var _account = _interopRequireDefault(__webpack_require__(33));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  dealerAddress: _dealerAddress.default,
  pricing: _pricing.default,
  incentive: _incentive.default,
  modal: _modal.default,
  widgetInfo: _widgetInfo.default,
  account: _account.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modal;

var _types = __webpack_require__(5);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialModalState = {
  show: false,
  incentiveKey: ' '
};

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialModalState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_MODAL:
        return _objectSpread({}, state, {
          show: action.payload.show,
          incentiveKey: action.payload.incentiveKey
        });

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pricing;

var _types = __webpack_require__(5);

function pricing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_PRICING:
        return action.payload;

      default:
    }
  }

  return state;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetInfo;

var _types = __webpack_require__(5);

function widgetInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    if (action.type && action.type === _types.SET_WIDGET_INFO) {
      var _action$payload = action.payload,
          accountId = _action$payload.accountId,
          pageAlias = _action$payload.pageAlias,
          vehicleAccountId = _action$payload.vehicleAccountId,
          vehicleCategory = _action$payload.vehicleCategory,
          vehicleType = _action$payload.vehicleType,
          vehicleId = _action$payload.vehicleId;
      return {
        accountId: accountId,
        pageAlias: pageAlias,
        vehicleAccountId: vehicleAccountId,
        vehicleCategory: vehicleCategory,
        vehicleType: vehicleType,
        vehicleId: vehicleId
      };
    }
  }

  return state;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(65);

var _reduxThunk = _interopRequireDefault(__webpack_require__(66));

var _reducers = _interopRequireDefault(__webpack_require__(36));

var _requestData = _interopRequireDefault(__webpack_require__(45));

var _prefs = _interopRequireDefault(__webpack_require__(44));

var _labels = _interopRequireDefault(__webpack_require__(43));

var _sitemap = _interopRequireDefault(__webpack_require__(46));

var _flags = _interopRequireDefault(__webpack_require__(42));

var _middleware = _interopRequireDefault(__webpack_require__(32));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-detailed-pricing - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(61),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(15);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(41));

var _Collapse = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = baseGet;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(54);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * DEVELOPED BY
 * GIL LOPES BUENO
 * gilbueno.mail@gmail.com
 *
 * WORKS WITH:
 * IE8*, IE 9+, FF 4+, SF 5+, WebKit, CH 7+, OP 12+, BESEN, Rhino 1.7+
 * For IE8 (and other legacy browsers) WatchJS will use dirty checking  
 *
 * FORK:
 * https://github.com/melanke/Watch.JS
 *
 * LICENSE: MIT
 */


(function (factory) {
    if (true) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else {
        // Browser globals
        window.WatchJS = factory();
        window.watch = window.WatchJS.watch;
        window.unwatch = window.WatchJS.unwatch;
        window.callWatchers = window.WatchJS.callWatchers;
    }
}(function () {

    var WatchJS = {
        noMore: false,        // use WatchJS.suspend(obj) instead
        useDirtyCheck: false, // use only dirty checking to track changes.
        preserveExistingSetters: false
    },
    lengthsubjects = [];
    
    var dirtyChecklist = [];
    var pendingChanges = []; // used coalesce changes from defineProperty and __defineSetter__
    
    var supportDefineProperty = false;
    try {
        supportDefineProperty = Object.defineProperty && Object.defineProperty({},'x', {});
    } catch(ex) {  /* not supported */  }

    var isFunction = function (functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) == '[object Function]';
    };

    var isInt = function (x) {
        return x % 1 === 0;
    };

    var isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };

    var isObject = function(obj) {
        return {}.toString.apply(obj) === '[object Object]';
    };
    
    var getObjDiff = function(a, b){
        var aplus = [],
        bplus = [];

        if(!(typeof a == "string") && !(typeof b == "string")){

            if (isArray(a) && b) {
                for (var i=0; i<a.length; i++) {
                    if (b[i] === undefined) aplus.push(i);
                }
            } else {
                for(var i in a){
                    if (a.hasOwnProperty(i)) {
                        if(b && !b.hasOwnProperty(i)) {
                            aplus.push(i);
                        }
                    }
                }
            }

            if (isArray(b) && a) {
                for (var j=0; j<b.length; j++) {
                    if (a[j] === undefined) bplus.push(j);
                }
            } else {
                for(var j in b){
                    if (b.hasOwnProperty(j)) {
                        if(a && !a.hasOwnProperty(j)) {
                            bplus.push(j);
                        }
                    }
                }
            }
        }

        return {
            added: aplus,
            removed: bplus
        }
    };

    var clone = function(obj){

        if (null == obj || "object" != typeof obj) {
            return obj;
        }

        var copy = obj.constructor();

        for (var attr in obj) {
            copy[attr] = obj[attr];
        }

        return copy;        

    }

    var getExistingSetter = function (obj, propName) {
        if (WatchJS.preserveExistingSetters) {
            var existing = Object.getOwnPropertyDescriptor(obj, propName);
            return existing.set;
        }

        return undefined;
    }

    var defineGetAndSet = function (obj, propName, getter, setter) {
        try {
            var existingSetter = getExistingSetter(obj, propName);
            Object.defineProperty(obj, propName, {
                get: getter,
                set: function(value) {
                    setter.call(this, value, true); // coalesce changes
                    if (existingSetter) {
                        existingSetter(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
        }
        catch(e1) {
            try{
                Object.prototype.__defineGetter__.call(obj, propName, getter);
                Object.prototype.__defineSetter__.call(obj, propName, function(value) {
                    setter.call(this,value,true); // coalesce changes
                });
            }
            catch(e2) {
                observeDirtyChanges(obj,propName,setter);
                //throw new Error("watchJS error: browser not supported :/")
            }
        }

    };

    var defineProp = function (obj, propName, value) {
        try {
            Object.defineProperty(obj, propName, {
                enumerable: false,
                configurable: true,
                writable: false,
                value: value
            });
        } catch(error) {
            obj[propName] = value;
        }
    };

    var observeDirtyChanges = function(obj,propName,setter) {
        dirtyChecklist[dirtyChecklist.length] = {
            prop:       propName,
            object:     obj,
            orig:       clone(obj[propName]),
            callback:   setter
        }        
    }
    
    var watch = function () {

        if (isFunction(arguments[1])) {
            watchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            watchMany.apply(this, arguments);
        } else {
            watchOne.apply(this, arguments);
        }

    };


    var watchAll = function (obj, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isArray(obj)) {
            defineWatcher(obj, "__watchall__", watcher, level); // watch all changes on the array
            if (level===undefined||level > 0) {
                for (var prop = 0; prop < obj.length; prop++) { // watch objects in array
                   watchAll(obj[prop],watcher,level, addNRemove);
                }
            }
        } 
        else {
            var prop,props = [];
            for (prop in obj) { //for each attribute if obj is an object
                if (prop == "$val" || (!supportDefineProperty && prop === 'watchers')) {
                    continue;
                }

                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    props.push(prop); //put in the props
                }
            }
            watchMany(obj, props, watcher, level, addNRemove); //watch all items of the props
        }


        if (addNRemove) {
            pushToLengthSubjects(obj, "$$watchlengthsubjectroot", watcher, level);
        }
    };


    var watchMany = function (obj, props, watcher, level, addNRemove) {

        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        for (var i=0; i<props.length; i++) { //watch each property
            var prop = props[i];
            watchOne(obj, prop, watcher, level, addNRemove);
        }

    };

    var watchOne = function (obj, prop, watcher, level, addNRemove) {
        if ((typeof obj == "string") || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if(isFunction(obj[prop])) { //dont watch if it is a function
            return;
        }
        if(obj[prop] != null && (level === undefined || level > 0)){
            watchAll(obj[prop], watcher, level!==undefined? level-1 : level); //recursively watch all attributes of this
        }

        defineWatcher(obj, prop, watcher, level);

        if(addNRemove && (level === undefined || level > 0)){
            pushToLengthSubjects(obj, prop, watcher, level);
        }

    };

    var unwatch = function () {

        if (isFunction(arguments[1])) {
            unwatchAll.apply(this, arguments);
        } else if (isArray(arguments[1])) {
            unwatchMany.apply(this, arguments);
        } else {
            unwatchOne.apply(this, arguments);
        }

    };

    var unwatchAll = function (obj, watcher) {

        if (obj instanceof String || (!(obj instanceof Object) && !isArray(obj))) { //accepts only objects and array (not string)
            return;
        }

        if (isArray(obj)) {
            var props = ['__watchall__'];
            for (var prop = 0; prop < obj.length; prop++) { //for each item if obj is an array
                props.push(prop); //put in the props
            }
            unwatchMany(obj, props, watcher); //watch all itens of the props
        } else {
            var unwatchPropsInObject = function (obj2) {
                var props = [];
                for (var prop2 in obj2) { //for each attribute if obj is an object
                    if (obj2.hasOwnProperty(prop2)) {
                        if (obj2[prop2] instanceof Object) {
                            unwatchPropsInObject(obj2[prop2]); //recurs into object props
                        } else {
                            props.push(prop2); //put in the props
                        }
                    }
                }
                unwatchMany(obj2, props, watcher); //unwatch all of the props
            };
            unwatchPropsInObject(obj);
        }
    };


    var unwatchMany = function (obj, props, watcher) {

        for (var prop2 in props) { //watch each attribute of "props" if is an object
            if (props.hasOwnProperty(prop2)) {
                unwatchOne(obj, props[prop2], watcher);
            }
        }
    };

    var timeouts = [],
        timerID = null;
    function clearTimerID() {
        timerID = null;
        for(var i=0; i< timeouts.length; i++) {
            timeouts[i]();
        }
        timeouts.length = 0;
    }
    var getTimerID= function () {
        if (!timerID)  {
            timerID = setTimeout(clearTimerID);
        }
        return timerID;
    }
    var registerTimeout = function(fn) { // register function to be called on timeout
        if (timerID==null) getTimerID();
        timeouts[timeouts.length] = fn;
    }
    
    // Track changes made to an array, object or an object's property 
    // and invoke callback with a single change object containing type, value, oldvalue and array splices
    // Syntax: 
    //      trackChange(obj, callback, recursive, addNRemove)
    //      trackChange(obj, prop, callback, recursive, addNRemove)
    var trackChange = function() {
        var fn = (isFunction(arguments[2])) ? trackProperty : trackObject ;
        fn.apply(this,arguments);
    }

    // track changes made to an object and invoke callback with a single change object containing type, value and array splices
    var trackObject= function(obj, callback, recursive, addNRemove) {
        var change = null,lastTimerID = -1;
        var isArr = isArray(obj);
        var level,fn = function(prop, action, newValue, oldValue) {
            var timerID = getTimerID();
            if (lastTimerID!==timerID) { // check if timer has changed since last update
                lastTimerID = timerID;
                change = {
                    type: 'update'
                }
                change['value'] = obj;
                change['splices'] = null;
                registerTimeout(function() {
                    callback.call(this,change);
                    change = null;
                });
            }
            // create splices for array changes
            if (isArr && obj === this && change !== null)  {                
                if (action==='pop'||action==='shift') {
                    newValue = [];
                    oldValue = [oldValue];
                }
                else if (action==='push'||action==='unshift') {
                    newValue = [newValue];
                    oldValue = [];
                }
                else if (action!=='splice') { 
                    return; // return here - for reverse and sort operations we don't need to return splices. a simple update will do
                }
                if (!change.splices) change.splices = [];
                change.splices[change.splices.length] = {
                    index: prop,
                    deleteCount: oldValue ? oldValue.length : 0,
                    addedCount: newValue ? newValue.length : 0,
                    added: newValue,
                    deleted: oldValue
                };
            }

        }  
        level = (recursive==true) ? undefined : 0;        
        watchAll(obj,fn, level, addNRemove);
    }
    
    // track changes made to the property of an object and invoke callback with a single change object containing type, value, oldvalue and splices
    var trackProperty = function(obj,prop,callback,recursive, addNRemove) { 
        if (obj && prop) {
            watchOne(obj,prop,function(prop, action, newvalue, oldvalue) {
                var change = {
                    type: 'update'
                }
                change['value'] = newvalue;
                change['oldvalue'] = oldvalue;
                if (recursive && isObject(newvalue)||isArray(newvalue)) {
                    trackObject(newvalue,callback,recursive, addNRemove);
                }               
                callback.call(this,change);
            },0)
            
            if (recursive && isObject(obj[prop])||isArray(obj[prop])) {
                trackObject(obj[prop],callback,recursive, addNRemove);
            }                           
        }
    }
    
    
    var defineWatcher = function (obj, prop, watcher, level) {
        var newWatcher = false;
        var isArr = isArray(obj);
        
        if (!obj.watchers) {
            defineProp(obj, "watchers", {});
            if (isArr) {
                // watch array functions
                watchFunctions(obj, function(index,action,newValue, oldValue) {
                    addPendingChange(obj, index, action,newValue, oldValue);
                    if (level !== 0 && newValue && (isObject(newValue) || isArray(newValue))) {
                        var i,n, ln, wAll, watchList = obj.watchers[prop];
                        if ((wAll = obj.watchers['__watchall__'])) {
                            watchList = watchList ? watchList.concat(wAll) : wAll;
                        }
                        ln = watchList ?  watchList.length : 0;
                        for (i = 0; i<ln; i++) {
                            if (action!=='splice') {
                                watchAll(newValue, watchList[i], (level===undefined)?level:level-1);
                            }
                            else {
                                // watch spliced values
                                for(n=0; n < newValue.length; n++) {
                                    watchAll(newValue[n], watchList[i], (level===undefined)?level:level-1);
                                }
                            }
                        }
                    }
                });
            }
        }

        if (!obj.watchers[prop]) {
            obj.watchers[prop] = [];
            if (!isArr) newWatcher = true;
        }

        for (var i=0; i<obj.watchers[prop].length; i++) {
            if(obj.watchers[prop][i] === watcher){
                return;
            }
        }

        obj.watchers[prop].push(watcher); //add the new watcher to the watchers array

        if (newWatcher) {
            var val = obj[prop];            
            var getter = function () {
                return val;                        
            };

            var setter = function (newval, delayWatcher) {
                var oldval = val;
                val = newval;                
                if (level !== 0 
                    && obj[prop] && (isObject(obj[prop]) || isArray(obj[prop]))
                    && !obj[prop].watchers) {
                    // watch sub properties
                    var i,ln = obj.watchers[prop].length; 
                    for(i=0; i<ln; i++) {
                        watchAll(obj[prop], obj.watchers[prop][i], (level===undefined)?level:level-1);
                    }
                }

                //watchFunctions(obj, prop);
                
                if (isSuspended(obj, prop)) {
                    resume(obj, prop);
                    return;
                }

                if (!WatchJS.noMore){ // this does not work with Object.observe
                    //if (JSON.stringify(oldval) !== JSON.stringify(newval)) {
                    if (oldval !== newval) {
                        if (!delayWatcher) {
                            callWatchers(obj, prop, "set", newval, oldval);
                        }
                        else {
                            addPendingChange(obj, prop, "set", newval, oldval);
                        }
                        WatchJS.noMore = false;
                    }
                }
            };

            if (WatchJS.useDirtyCheck) {
                observeDirtyChanges(obj,prop,setter);
            }
            else {
                defineGetAndSet(obj, prop, getter, setter);
            }
        }

    };

    var callWatchers = function (obj, prop, action, newval, oldval) {
        if (prop !== undefined) {
            var ln, wl, watchList = obj.watchers[prop];
            if ((wl = obj.watchers['__watchall__'])) {
                watchList = watchList ? watchList.concat(wl) : wl;
            }
            ln = watchList ? watchList.length : 0;
            for (var wr=0; wr< ln; wr++) {
                watchList[wr].call(obj, prop, action, newval, oldval);
            }
        } else {
            for (var prop in obj) {//call all
                if (obj.hasOwnProperty(prop)) {
                    callWatchers(obj, prop, action, newval, oldval);
                }
            }
        }
    };

    var methodNames = ['pop', 'push', 'reverse', 'shift', 'sort', 'slice', 'unshift', 'splice'];
    var defineArrayMethodWatcher = function (obj, original, methodName, callback) {
        defineProp(obj, methodName, function () {
            var index = 0;
            var i,newValue, oldValue, response;                        
            // get values before splicing array 
            if (methodName === 'splice') {
               var start = arguments[0];
               var end = start + arguments[1];
               oldValue = obj.slice(start,end);
               newValue = [];
               for(i=2;i<arguments.length;i++) {
                   newValue[i-2] = arguments[i];
               }
               index = start;
            } 
            else {
                newValue = arguments.length > 0 ? arguments[0] : undefined;
            } 

            response = original.apply(obj, arguments);
            if (methodName !== 'slice') {
                if (methodName === 'pop') {
                    oldValue = response;
                    index = obj.length;
                }
                else if (methodName === 'push') {
                    index = obj.length-1;
                }
                else if (methodName === 'shift') {
                    oldValue = response;
                }
                else if (methodName !== 'unshift' && newValue===undefined) {
                    newValue = response;
                }
                callback.call(obj, index, methodName,newValue, oldValue)
            }
            return response;
        });
    };

    var watchFunctions = function(obj, callback) {

        if (!isFunction(callback) || !obj || (obj instanceof String) || (!isArray(obj))) {
            return;
        }

        for (var i = methodNames.length, methodName; i--;) {
            methodName = methodNames[i];
            defineArrayMethodWatcher(obj, obj[methodName], methodName, callback);
        }

    };

    var unwatchOne = function (obj, prop, watcher) {
        if (prop) {
            if (obj.watchers && obj.watchers[prop]) {
                if (watcher === undefined) {
                    delete obj.watchers[prop]; // remove all property watchers
                }
                else {
                    for (var i = 0; i < obj.watchers[prop].length; i++) {
                        var w = obj.watchers[prop][i];
                        if (w == watcher) {
                            obj.watchers[prop].splice(i, 1);
                        }
                    }
                }
            }
        } else {
            delete obj.watchers;
        }

        removeFromLengthSubjects(obj, prop, watcher);
        removeFromDirtyChecklist(obj, prop);
    };
    
    // suspend watchers until next update cycle
    var suspend = function(obj, prop) {
        if (obj.watchers) {
            var name = '__wjs_suspend__'+(prop!==undefined ? prop : '');
            obj.watchers[name] = true;
        }
    }
    
    var isSuspended = function(obj, prop) {
        return obj.watchers 
               && (obj.watchers['__wjs_suspend__'] || 
                   obj.watchers['__wjs_suspend__'+prop]);
    }
    
    // resumes preivously suspended watchers
    var resume = function(obj, prop) {
        registerTimeout(function() {
            delete obj.watchers['__wjs_suspend__'];
            delete obj.watchers['__wjs_suspend__'+prop];
        })
    }

    var pendingTimerID = null;
    var addPendingChange = function(obj,prop, mode, newval, oldval) {
        pendingChanges[pendingChanges.length] = {
            obj:obj,
            prop: prop,
            mode: mode,
            newval: newval,
            oldval: oldval
        };
        if (pendingTimerID===null) {
            pendingTimerID = setTimeout(applyPendingChanges);
        }
    };
    
    
    var applyPendingChanges = function()  {
        // apply pending changes
        var change = null;
        pendingTimerID = null;
        for(var i=0;i < pendingChanges.length;i++) {
            change = pendingChanges[i];
            callWatchers(change.obj, change.prop, change.mode, change.newval, change.oldval);
        }
        if (change) {
            pendingChanges = [];
            change = null;
        }        
    }

    var loop = function(){

        // check for new or deleted props
        for(var i=0; i<lengthsubjects.length; i++) {

            var subj = lengthsubjects[i];

            if (subj.prop === "$$watchlengthsubjectroot") {

                var difference = getObjDiff(subj.obj, subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        watchMany(subj.obj, difference.added, subj.watcher, subj.level - 1, true);
                    }

                    subj.watcher.call(subj.obj, "root", "differentattr", difference, subj.actual);
                }
                subj.actual = clone(subj.obj);


            } else {

                var difference = getObjDiff(subj.obj[subj.prop], subj.actual);

                if(difference.added.length || difference.removed.length){
                    if(difference.added.length){
                        for (var j=0; j<subj.obj.watchers[subj.prop].length; j++) {
                            watchMany(subj.obj[subj.prop], difference.added, subj.obj.watchers[subj.prop][j], subj.level - 1, true);
                        }
                    }

                    callWatchers(subj.obj, subj.prop, "differentattr", difference, subj.actual);
                }

                subj.actual = clone(subj.obj[subj.prop]);

            }

        }
        
        // start dirty check
        var n, value;
        if (dirtyChecklist.length > 0) {
            for (var i = 0; i < dirtyChecklist.length; i++) {
                n = dirtyChecklist[i];
                value = n.object[n.prop];
                if (!compareValues(n.orig, value)) {
                    n.orig = clone(value);
                    n.callback(value);
                }
            }
        }

    };

    var compareValues =  function(a,b) {
        var i, state = true;
        if (a!==b)  {
            if (isObject(a)) {
                for(i in a) {
                    if (!supportDefineProperty && i==='watchers') continue;
                    if (a[i]!==b[i]) {
                        state = false;
                        break;
                    };
                }
            }
            else {
                state = false;
            }
        }
        return state;
    }
    
    var pushToLengthSubjects = function(obj, prop, watcher, level){

        var actual;

        if (prop === "$$watchlengthsubjectroot") {
            actual =  clone(obj);
        } else {
            actual = clone(obj[prop]);
        }

        lengthsubjects.push({
            obj: obj,
            prop: prop,
            actual: actual,
            watcher: watcher,
            level: level
        });
    };

    var removeFromLengthSubjects = function(obj, prop, watcher){
        for (var i=0; i<lengthsubjects.length; i++) {
            var subj = lengthsubjects[i];

            if (subj.obj == obj) {
                if (!prop || subj.prop == prop) {
                    if (!watcher || subj.watcher == watcher) {
                        // if we splice off one item at position i
                        // we need to decrement i as the array is one item shorter
                        // so when we increment i in the loop statement we
                        // will land at the correct index.
                        // if it's not decremented, you won't delete all length subjects
                        lengthsubjects.splice(i--, 1);
                    }
                }
            }
        }

    };
    
    var removeFromDirtyChecklist = function(obj, prop){
        var notInUse;
        for (var i=0; i<dirtyChecklist.length; i++) {
            var n = dirtyChecklist[i];
            var watchers = n.object.watchers;
            notInUse = (
                n.object == obj 
                && (!prop || n.prop == prop)
                && watchers
                && (!prop || !watchers[prop] || watchers[prop].length == 0 )
            );
            if (notInUse)  {
                // we use the same syntax as in removeFromLengthSubjects
                dirtyChecklist.splice(i--, 1);
            }
        }

    };    

    setInterval(loop, 50);

    WatchJS.watch = watch;
    WatchJS.unwatch = unwatch;
    WatchJS.callWatchers = callWatchers;
    WatchJS.suspend = suspend; // suspend watchers    
    WatchJS.onChange = trackChange;  // track changes made to object or  it's property and return a single change object

    return WatchJS;

}));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(59)


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(58);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(60);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(57);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 62 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(0),__webpack_require__(1),__webpack_require__(7)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","react-dom"],t):t((e=e||self).wsmIncentiveModal={},e.React,e.PropTypes,e.ReactDom)}(this,function(e,_,T,S){"use strict";var P="default"in _?_.default:_;function t(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function n(e,t){return e(t={exports:{}},t.exports),t.exports}T=T&&T.hasOwnProperty("default")?T.default:T,S=S&&S.hasOwnProperty("default")?S.default:S;var o=n(function(e){var t=function(i){var l,e=Object.prototype,c=e.hasOwnProperty,t="function"==typeof Symbol?Symbol:{},r=t.iterator||"@@iterator",n=t.asyncIterator||"@@asyncIterator",o=t.toStringTag||"@@toStringTag";function a(e,t,n,o){var r=t&&t.prototype instanceof s?t:s,i=Object.create(r.prototype),a=new T(o||[]);return i._invoke=function(i,a,s){var l=p;return function(e,t){if(l===f)throw new Error("Generator is already running");if(l===h){if("throw"===e)throw t;return P()}for(s.method=e,s.arg=t;;){var n=s.delegate;if(n){var o=w(n,s);if(o){if(o===m)continue;return o}}if("next"===s.method)s.sent=s._sent=s.arg;else if("throw"===s.method){if(l===p)throw l=h,s.arg;s.dispatchException(s.arg)}else"return"===s.method&&s.abrupt("return",s.arg);l=f;var r=u(i,a,s);if("normal"===r.type){if(l=s.done?h:d,r.arg===m)continue;return{value:r.arg,done:s.done}}"throw"===r.type&&(l=h,s.method="throw",s.arg=r.arg)}}}(e,n,a),i}function u(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}i.wrap=a;var p="suspendedStart",d="suspendedYield",f="executing",h="completed",m={};function s(){}function v(){}function y(){}var b={};b[r]=function(){return this};var g=Object.getPrototypeOf,E=g&&g(g(S([])));E&&E!==e&&c.call(E,r)&&(b=E);var C=y.prototype=s.prototype=Object.create(b);function N(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function O(l){var t;this._invoke=function(n,o){function e(){return new Promise(function(e,t){!function t(e,n,o,r){var i=u(l[e],l,n);if("throw"!==i.type){var a=i.arg,s=a.value;return s&&"object"==typeof s&&c.call(s,"__await")?Promise.resolve(s.__await).then(function(e){t("next",e,o,r)},function(e){t("throw",e,o,r)}):Promise.resolve(s).then(function(e){a.value=e,o(a)},function(e){return t("throw",e,o,r)})}r(i.arg)}(n,o,e,t)})}return t=t?t.then(e,e):e()}}function w(e,t){var n=e.iterator[t.method];if(n===l){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=l,w(e,t),"throw"===t.method))return m;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return m}var o=u(n,e.iterator,t.arg);if("throw"===o.type)return t.method="throw",t.arg=o.arg,t.delegate=null,m;var r=o.arg;return r?r.done?(t[e.resultName]=r.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=l),t.delegate=null,m):r:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,m)}function x(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function _(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function T(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(x,this),this.reset(!0)}function S(t){if(t){var e=t[r];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,o=function e(){for(;++n<t.length;)if(c.call(t,n))return e.value=t[n],e.done=!1,e;return e.value=l,e.done=!0,e};return o.next=o}}return{next:P}}function P(){return{value:l,done:!0}}return v.prototype=C.constructor=y,y.constructor=v,y[o]=v.displayName="GeneratorFunction",i.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===v||"GeneratorFunction"===(t.displayName||t.name))},i.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,y):(e.__proto__=y,o in e||(e[o]="GeneratorFunction")),e.prototype=Object.create(C),e},i.awrap=function(e){return{__await:e}},N(O.prototype),O.prototype[n]=function(){return this},i.AsyncIterator=O,i.async=function(e,t,n,o){var r=new O(a(e,t,n,o));return i.isGeneratorFunction(t)?r:r.next().then(function(e){return e.done?e.value:r.next()})},N(C),C[o]="Generator",C[r]=function(){return this},C.toString=function(){return"[object Generator]"},i.keys=function(n){var o=[];for(var e in n)o.push(e);return o.reverse(),function e(){for(;o.length;){var t=o.pop();if(t in n)return e.value=t,e.done=!1,e}return e.done=!0,e}},i.values=S,T.prototype={constructor:T,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=l,this.done=!1,this.delegate=null,this.method="next",this.arg=l,this.tryEntries.forEach(_),!e)for(var t in this)"t"===t.charAt(0)&&c.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=l)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(n){if(this.done)throw n;var o=this;function e(e,t){return i.type="throw",i.arg=n,o.next=e,t&&(o.method="next",o.arg=l),!!t}for(var t=this.tryEntries.length-1;0<=t;--t){var r=this.tryEntries[t],i=r.completion;if("root"===r.tryLoc)return e("end");if(r.tryLoc<=this.prev){var a=c.call(r,"catchLoc"),s=c.call(r,"finallyLoc");if(a&&s){if(this.prev<r.catchLoc)return e(r.catchLoc,!0);if(this.prev<r.finallyLoc)return e(r.finallyLoc)}else if(a){if(this.prev<r.catchLoc)return e(r.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<r.finallyLoc)return e(r.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;0<=n;--n){var o=this.tryEntries[n];if(o.tryLoc<=this.prev&&c.call(o,"finallyLoc")&&this.prev<o.finallyLoc){var r=o;break}}r&&("break"===e||"continue"===e)&&r.tryLoc<=t&&t<=r.finallyLoc&&(r=null);var i=r?r.completion:{};return i.type=e,i.arg=t,r?(this.method="next",this.next=r.finallyLoc,m):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),m},finish:function(e){for(var t=this.tryEntries.length-1;0<=t;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),_(n),m}},catch:function(e){for(var t=this.tryEntries.length-1;0<=t;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var o=n.completion;if("throw"===o.type){var r=o.arg;_(n)}return r}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:S(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=l),m}},i}(e.exports);try{regeneratorRuntime=t}catch(e){Function("r","regeneratorRuntime = r")(t)}});function l(e,t,n,o,r,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(o,r)}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function a(e,t,n){return t&&i(e.prototype,t),n&&i(e,n),e}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t)}function c(e){return(c=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function u(e,t){return(u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function p(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function d(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?p(e):t}function m(o,r,e){if(function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!")}(o),void 0===r)return o;switch(e){case 1:return function(e){return o.call(r,e)};case 2:return function(e,t){return o.call(r,e,t)};case 3:return function(e,t,n){return o.call(r,e,t,n)}}return function(){return o.apply(r,arguments)}}function f(e){return"object"==typeof e?null!==e:"function"==typeof e}function h(e){if(!f(e))throw TypeError(e+" is not an object!");return e}function v(e){try{return!!e()}catch(e){return!0}}function y(e){return x?w.createElement(e):{}}function b(e,t){if(!f(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!f(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!f(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!f(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}function g(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}function E(e,t){return I.call(e,t)}var C=n(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),N=n(function(e){var t=e.exports={version:"2.6.9"};"number"==typeof __e&&(__e=t)}),O=(N.version,!v(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})),w=C.document,x=f(w)&&f(w.createElement),k=!O&&!v(function(){return 7!=Object.defineProperty(y("div"),"a",{get:function(){return 7}}).a}),M=Object.defineProperty,R={f:O?Object.defineProperty:function(e,t,n){if(h(e),t=b(t,!0),h(n),k)try{return M(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},A=O?function(e,t,n){return R.f(e,t,g(1,n))}:function(e,t,n){return e[t]=n,e},I={}.hasOwnProperty,D="prototype",L=function(e,t,n){var o,r,i,a=e&L.F,s=e&L.G,l=e&L.S,c=e&L.P,u=e&L.B,p=e&L.W,d=s?N:N[t]||(N[t]={}),f=d[D],h=s?C:l?C[t]:(C[t]||{})[D];for(o in s&&(n=t),n)(r=!a&&h&&void 0!==h[o])&&E(d,o)||(i=r?h[o]:n[o],d[o]=s&&"function"!=typeof h[o]?n[o]:u&&r?m(i,C):p&&h[o]==i?function(o){function e(e,t,n){if(this instanceof o){switch(arguments.length){case 0:return new o;case 1:return new o(e);case 2:return new o(e,t)}return new o(e,t,n)}return o.apply(this,arguments)}return e[D]=o[D],e}(i):c&&"function"==typeof i?m(Function.call,i):i,c&&((d.virtual||(d.virtual={}))[o]=i,e&L.R&&f&&!f[o]&&A(f,o,i)))};L.F=1,L.G=2,L.S=4,L.P=8,L.B=16,L.W=32,L.U=64,L.R=128;function F(e){return G.call(e).slice(8,-1)}function j(e){if(null==e)throw TypeError("Can't call method on  "+e);return e}function K(e){return Y(j(e))}function H(e){return isNaN(e=+e)?0:(0<e?J:X)(e)}function U(e){return 0<e?Z(H(e),9007199254740991):0}function $(e){return"Symbol(".concat(void 0===e?"":e,")_",(++ne+oe).toString(36))}function B(e){return re[e]||(re[e]=$(e))}function V(e,t){var n,o=K(e),r=0,i=[];for(n in o)n!=ae&&E(o,n)&&i.push(n);for(;t.length>r;)E(o,n=t[r++])&&(~ie(i,n)||i.push(n));return i}function W(e){return Object(j(e))}var q,z=L,G={}.toString,Y=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==F(e)?e.split(""):Object(e)},X=Math.ceil,J=Math.floor,Z=Math.min,Q=Math.max,ee=Math.min,te=n(function(e){var t="__core-js_shared__",n=C[t]||(C[t]={});(e.exports=function(e,t){return n[e]||(n[e]=void 0!==t?t:{})})("versions",[]).push({version:N.version,mode:"pure",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})}),ne=0,oe=Math.random(),re=te("keys"),ie=(q=!1,function(e,t,n){var o,r=K(e),i=U(r.length),a=function(e,t){return(e=H(e))<0?Q(e+t,0):ee(e,t)}(n,i);if(q&&t!=t){for(;a<i;)if((o=r[a++])!=o)return!0}else for(;a<i;a++)if((q||a in r)&&r[a]===t)return q||a||0;return!q&&-1}),ae=B("IE_PROTO"),se="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),le=Object.keys||function(e){return V(e,se)},ce={f:Object.getOwnPropertySymbols},ue={f:{}.propertyIsEnumerable},pe=Object.assign,de=!pe||v(function(){var e={},t={},n=Symbol(),o="abcdefghijklmnopqrst";return e[n]=7,o.split("").forEach(function(e){t[e]=e}),7!=pe({},e)[n]||Object.keys(pe({},t)).join("")!=o})?function(e,t){for(var n=W(e),o=arguments.length,r=1,i=ce.f,a=ue.f;r<o;)for(var s,l=Y(arguments[r++]),c=i?le(l).concat(i(l)):le(l),u=c.length,p=0;p<u;)s=c[p++],O&&!a.call(l,s)||(n[s]=l[s]);return n}:pe;z(z.S+z.F,"Object",{assign:de});function fe(){}function he(e,t,n){e&&!E(e=n?e:e.prototype,Me)&&ke(e,Me,{configurable:!0,value:t})}var me=N.Object.assign,ve=n(function(e){e.exports={default:me,__esModule:!0}}),ye=t(ve),be=t(n(function(e,t){t.__esModule=!0;var n,o=(n=ve)&&n.__esModule?n:{default:n};t.default=o.default||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e}})),ge=t(n(function(e,t){t.__esModule=!0,t.default=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}})),Ee=A,Ce={},Ne=O?Object.defineProperties:function(e,t){h(e);for(var n,o=le(t),r=o.length,i=0;i<r;)R.f(e,n=o[i++],t[n]);return e},Oe=C.document,we=Oe&&Oe.documentElement,xe=B("IE_PROTO"),_e="prototype",Te=function(){var e,t=y("iframe"),n=se.length;for(t.style.display="none",we.appendChild(t),t.src="javascript:",(e=t.contentWindow.document).open(),e.write("<script>document.F=Object<\/script>"),e.close(),Te=e.F;n--;)delete Te[_e][se[n]];return Te()},Se=Object.create||function(e,t){var n;return null!==e?(fe[_e]=h(e),n=new fe,fe[_e]=null,n[xe]=e):n=Te(),void 0===t?n:Ne(n,t)},Pe=n(function(e){var t=te("wks"),n=C.Symbol,o="function"==typeof n;(e.exports=function(e){return t[e]||(t[e]=o&&n[e]||(o?n:$)("Symbol."+e))}).store=t}),ke=R.f,Me=Pe("toStringTag"),Re={};A(Re,Pe("iterator"),function(){return this});function Ae(){return this}function Ie(e,t,n,o,r,i,a){function s(e){if(!He&&e in h)return h[e];switch(e){case"keys":case Ue:return function(){return new n(this,e)}}return function(){return new n(this,e)}}!function(e,t,n){e.prototype=Se(Re,{next:g(1,n)}),he(e,t+" Iterator")}(n,t,o);var l,c,u,p=t+" Iterator",d=r==Ue,f=!1,h=e.prototype,m=h[Ke]||h["@@iterator"]||r&&h[r],v=m||s(r),y=r?d?s("entries"):v:void 0,b="Array"==t&&h.entries||m;if(b&&(u=je(b.call(new e)))!==Object.prototype&&u.next&&he(u,p,!0),d&&m&&m.name!==Ue&&(f=!0,v=function(){return m.call(this)}),a&&(He||f||!h[Ke])&&A(h,Ke,v),Ce[t]=v,Ce[p]=Ae,r)if(l={values:d?v:s(Ue),keys:i?v:s("keys"),entries:y},a)for(c in l)c in h||Ee(h,c,l[c]);else z(z.P+z.F*(He||f),t,l);return l}var De,Le=B("IE_PROTO"),Fe=Object.prototype,je=Object.getPrototypeOf||function(e){return e=W(e),E(e,Le)?e[Le]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?Fe:null},Ke=Pe("iterator"),He=!([].keys&&"next"in[].keys()),Ue="values",$e=(De=!0,function(e,t){var n,o,r=String(j(e)),i=H(t),a=r.length;return i<0||a<=i?De?"":void 0:(n=r.charCodeAt(i))<55296||56319<n||i+1===a||(o=r.charCodeAt(i+1))<56320||57343<o?De?r.charAt(i):n:De?r.slice(i,i+2):o-56320+(n-55296<<10)+65536});Ie(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=$e(t,n),this._i+=e.length,{value:e,done:!1})});function Be(e,t){return{value:t,done:!!e}}Ie(Array,"Array",function(e,t){this._t=K(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,Be(1)):Be(0,"keys"==t?n:"values"==t?e[n]:[n,e[n]])},"values");Ce.Arguments=Ce.Array;for(var Ve=Pe("toStringTag"),We="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),qe=0;qe<We.length;qe++){var ze=We[qe],Ge=C[ze],Ye=Ge&&Ge.prototype;Ye&&!Ye[Ve]&&A(Ye,Ve,ze),Ce[ze]=Ce.Array}var Xe={f:Pe},Je=Xe.f("iterator"),Ze=n(function(e){e.exports={default:Je,__esModule:!0}});t(Ze);function Qe(e){var t=N.Symbol||(N.Symbol={});"_"==e.charAt(0)||e in t||st(t,e,{value:Xe.f(e)})}function et(e){var t=Pt[e]=Se(Ct[wt]);return t._k=e,t}function tt(e,t){h(e);for(var n,o=function(e){var t=le(e),n=ce.f;if(n)for(var o,r=n(e),i=ue.f,a=0;r.length>a;)i.call(e,o=r[a++])&&t.push(o);return t}(t=K(t)),r=0,i=o.length;r<i;)Ft(e,n=o[r++],t[n]);return e}function nt(e){var t=Tt.call(this,e=b(e,!0));return!(this===Mt&&E(Pt,e)&&!E(kt,e))&&(!(t||!E(this,e)||!E(Pt,e)||E(this,xt)&&this[xt][e])||t)}function ot(e,t){if(e=K(e),t=b(t,!0),e!==Mt||!E(Pt,t)||E(kt,t)){var n=bt(e,t);return!n||!E(Pt,t)||E(e,xt)&&e[xt][t]||(n.enumerable=!0),n}}function rt(e){for(var t,n=Et(K(e)),o=[],r=0;n.length>r;)E(Pt,t=n[r++])||t==xt||t==yt||o.push(t);return o}function it(e){for(var t,n=e===Mt,o=Et(n?kt:K(e)),r=[],i=0;o.length>i;)!E(Pt,t=o[i++])||n&&!E(Mt,t)||r.push(Pt[t]);return r}var at=n(function(e){function n(e){t(e,o,{value:{i:"O"+ ++r,w:{}}})}var o=$("meta"),t=R.f,r=0,i=Object.isExtensible||function(){return!0},a=!v(function(){return i(Object.preventExtensions({}))}),s=e.exports={KEY:o,NEED:!1,fastKey:function(e,t){if(!f(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!E(e,o)){if(!i(e))return"F";if(!t)return"E";n(e)}return e[o].i},getWeak:function(e,t){if(!E(e,o)){if(!i(e))return!0;if(!t)return!1;n(e)}return e[o].w},onFreeze:function(e){return a&&s.NEED&&i(e)&&!E(e,o)&&n(e),e}}}),st=(at.KEY,at.NEED,at.fastKey,at.getWeak,at.onFreeze,R.f),lt=Array.isArray||function(e){return"Array"==F(e)},ct=se.concat("length","prototype"),ut={f:Object.getOwnPropertyNames||function(e){return V(e,ct)}},pt=ut.f,dt={}.toString,ft="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],ht={f:function(e){return ft&&"[object Window]"==dt.call(e)?function(e){try{return pt(e)}catch(e){return ft.slice()}}(e):pt(K(e))}},mt=Object.getOwnPropertyDescriptor,vt={f:O?mt:function(e,t){if(e=K(e),t=b(t,!0),k)try{return mt(e,t)}catch(e){}if(E(e,t))return g(!ue.f.call(e,t),e[t])}},yt=at.KEY,bt=vt.f,gt=R.f,Et=ht.f,Ct=C.Symbol,Nt=C.JSON,Ot=Nt&&Nt.stringify,wt="prototype",xt=Pe("_hidden"),_t=Pe("toPrimitive"),Tt={}.propertyIsEnumerable,St=te("symbol-registry"),Pt=te("symbols"),kt=te("op-symbols"),Mt=Object[wt],Rt="function"==typeof Ct&&!!ce.f,At=C.QObject,It=!At||!At[wt]||!At[wt].findChild,Dt=O&&v(function(){return 7!=Se(gt({},"a",{get:function(){return gt(this,"a",{value:7}).a}})).a})?function(e,t,n){var o=bt(Mt,t);o&&delete Mt[t],gt(e,t,n),o&&e!==Mt&&gt(Mt,t,o)}:gt,Lt=Rt&&"symbol"==typeof Ct.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof Ct},Ft=function(e,t,n){return e===Mt&&Ft(kt,t,n),h(e),t=b(t,!0),h(n),E(Pt,t)?(n.enumerable?(E(e,xt)&&e[xt][t]&&(e[xt][t]=!1),n=Se(n,{enumerable:g(0,!1)})):(E(e,xt)||gt(e,xt,g(1,{})),e[xt][t]=!0),Dt(e,t,n)):gt(e,t,n)};Rt||(Ee((Ct=function(e){if(this instanceof Ct)throw TypeError("Symbol is not a constructor!");var t=$(0<arguments.length?e:void 0),n=function(e){this===Mt&&n.call(kt,e),E(this,xt)&&E(this[xt],t)&&(this[xt][t]=!1),Dt(this,t,g(1,e))};return O&&It&&Dt(Mt,t,{configurable:!0,set:n}),et(t)})[wt],"toString",function(){return this._k}),vt.f=ot,R.f=Ft,ut.f=ht.f=rt,ue.f=nt,ce.f=it,Xe.f=function(e){return et(Pe(e))}),z(z.G+z.W+z.F*!Rt,{Symbol:Ct});for(var jt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),Kt=0;jt.length>Kt;)Pe(jt[Kt++]);for(var Ht=le(Pe.store),Ut=0;Ht.length>Ut;)Qe(Ht[Ut++]);z(z.S+z.F*!Rt,"Symbol",{for:function(e){return E(St,e+="")?St[e]:St[e]=Ct(e)},keyFor:function(e){if(!Lt(e))throw TypeError(e+" is not a symbol!");for(var t in St)if(St[t]===e)return t},useSetter:function(){It=!0},useSimple:function(){It=!1}}),z(z.S+z.F*!Rt,"Object",{create:function(e,t){return void 0===t?Se(e):tt(Se(e),t)},defineProperty:Ft,defineProperties:tt,getOwnPropertyDescriptor:ot,getOwnPropertyNames:rt,getOwnPropertySymbols:it});var $t=v(function(){ce.f(1)});z(z.S+z.F*$t,"Object",{getOwnPropertySymbols:function(e){return ce.f(W(e))}}),Nt&&z(z.S+z.F*(!Rt||v(function(){var e=Ct();return"[null]"!=Ot([e])||"{}"!=Ot({a:e})||"{}"!=Ot(Object(e))})),"JSON",{stringify:function(e){for(var t,n,o=[e],r=1;r<arguments.length;)o.push(arguments[r++]);if(n=t=o[1],(f(t)||void 0!==e)&&!Lt(e))return lt(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!Lt(t))return t}),o[1]=t,Ot.apply(Nt,o)}}),Ct[wt][_t]||A(Ct[wt],_t,Ct[wt].valueOf),he(Ct,"Symbol"),he(Math,"Math",!0),he(C.JSON,"JSON",!0),Qe("asyncIterator"),Qe("observable");var Bt=N.Symbol,Vt=n(function(e){e.exports={default:Bt,__esModule:!0}});t(Vt);function Wt(e,t){if(h(e),!f(t)&&null!==t)throw TypeError(t+": can't set as prototype!")}var qt=n(function(e,t){t.__esModule=!0;var n=i(Ze),o=i(Vt),r="function"==typeof o.default&&"symbol"==typeof n.default?function(e){return typeof e}:function(e){return e&&"function"==typeof o.default&&e.constructor===o.default&&e!==o.default.prototype?"symbol":typeof e};function i(e){return e&&e.__esModule?e:{default:e}}t.default="function"==typeof o.default&&"symbol"===r(n.default)?function(e){return void 0===e?"undefined":r(e)}:function(e){return e&&"function"==typeof o.default&&e.constructor===o.default&&e!==o.default.prototype?"symbol":void 0===e?"undefined":r(e)}}),zt=t(qt),Gt=t(n(function(e,t){t.__esModule=!0;var n,o=(n=qt)&&n.__esModule?n:{default:n};t.default=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,o.default)(t))&&"function"!=typeof t?e:t}})),Yt={set:Object.setPrototypeOf||("__proto__"in{}?function(e,n,o){try{(o=m(Function.call,vt.f(Object.prototype,"__proto__").set,2))(e,[]),n=!(e instanceof Array)}catch(e){n=!0}return function(e,t){return Wt(e,t),n?e.__proto__=t:o(e,t),e}}({},!1):void 0),check:Wt};z(z.S,"Object",{setPrototypeOf:Yt.set});var Xt=N.Object.setPrototypeOf,Jt=n(function(e){e.exports={default:Xt,__esModule:!0}});t(Jt),z(z.S,"Object",{create:Se});function Zt(e,t){return Qt.create(e,t)}var Qt=N.Object,en=n(function(e){e.exports={default:Zt,__esModule:!0}});t(en);function tn(s){return function(e){for(var t,n=K(e),o=le(n),r=o.length,i=0,a=[];i<r;)t=o[i++],O&&!an.call(n,t)||a.push(s?[t,n[t]]:n[t]);return a}}var nn=t(n(function(e,t){t.__esModule=!0;var n=i(Jt),o=i(en),r=i(qt);function i(e){return e&&e.__esModule?e:{default:e}}t.default=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,r.default)(t)));e.prototype=(0,o.default)(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(n.default?(0,n.default)(e,t):e.__proto__=t)}})),on=t(n(function(e,t){t.__esModule=!0,t.default=function(e,t){var n={};for(var o in e)0<=t.indexOf(o)||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}})),rn=n(function(e){function a(){for(var e=[],t=0;t<arguments.length;t++){var n=arguments[t];if(n){var o=typeof n;if("string"==o||"number"==o)e.push(n);else if(Array.isArray(n)&&n.length){var r=a.apply(null,n);r&&e.push(r)}else if("object"==o)for(var i in n)s.call(n,i)&&n[i]&&e.push(i)}}return e.join(" ")}var s;s={}.hasOwnProperty,e.exports?(a.default=a,e.exports=a):window.classNames=a}),an=ue.f,sn=tn(!0);z(z.S,"Object",{entries:function(e){return sn(e)}});var ln=N.Object.entries,cn=t(n(function(e){e.exports={default:ln,__esModule:!0}})),un="production",pn=function(e,t,n,o,r,i,a,s){if("production"!==un&&void 0===t)throw new Error("invariant requires an error message argument");if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,o,r,i,a,s],u=0;(l=new Error(t.replace(/%s/g,function(){return c[u++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},dn="large",fn="small",hn="xsmall",mn={large:"lg",medium:"md",small:"sm",xsmall:"xs",lg:"lg",md:"md",sm:"sm",xs:"xs"},vn=["lg","md","sm","xs"],yn={SUCCESS:"success",WARNING:"warning",DANGER:"danger",INFO:"info"},bn="default",gn="primary",En="link",Cn="inverse";function Nn(o){return function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return"function"==typeof t[t.length-1]?o.apply(void 0,t):function(e){return o.apply(void 0,t.concat([e]))}}}function On(e,t){return null==e.bsClass&&( false?pn(!1,"A `bsClass` prop is required for this component"):pn(!1)),e.bsClass+(t?"-"+t:"")}var wn=Nn(function(e,t){var n=t.propTypes||(t.propTypes={}),o=t.defaultProps||(t.defaultProps={});return n.bsClass=T.string,o.bsClass=e,t}),xn=Nn(function(e,t,n){"string"!=typeof t&&(n=t,t=void 0);var o=n.STYLES||[],r=n.propTypes||{};e.forEach(function(e){-1===o.indexOf(e)&&o.push(e)});var i=T.oneOf(o);n.STYLES=o,i._values=o,n.propTypes=be({},r,{bsStyle:i}),void 0!==t&&((n.defaultProps||(n.defaultProps={})).bsStyle=t);return n}),_n=Nn(function(e,t,n){"string"!=typeof t&&(n=t,t=void 0);var o=n.SIZES||[],r=n.propTypes||{};e.forEach(function(e){-1===o.indexOf(e)&&o.push(e)});var i=[];o.forEach(function(e){var t=mn[e];t&&t!==e&&i.push(t),i.push(e)});var a=T.oneOf(i);return a._values=i,n.SIZES=o,n.propTypes=be({},r,{bsSize:a}),void 0!==t&&(n.defaultProps||(n.defaultProps={}),n.defaultProps.bsSize=t),n});function Tn(e){var t,n=((t={})[On(e)]=!0,t);e.bsSize&&(n[On(e,mn[e.bsSize]||e.bsSize)]=!0);return e.bsStyle&&(n[On(e,e.bsStyle)]=!0),n}function Sn(e){return{bsClass:e.bsClass,bsSize:e.bsSize,bsStyle:e.bsStyle,bsRole:e.bsRole}}function Pn(e){return"bsClass"===e||"bsSize"===e||"bsStyle"===e||"bsRole"===e}function kn(e){var o={};return cn(e).forEach(function(e){var t=e[0],n=e[1];Pn(t)||(o[t]=n)}),[Sn(e),o]}function Mn(e,t){var o={};t.forEach(function(e){o[e]=!0});var r={};return cn(e).forEach(function(e){var t=e[0],n=e[1];Pn(t)||o[t]||(r[t]=n)}),[Sn(e),r]}function Rn(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.filter(function(e){return null!=e}).reduce(function(o,r){if("function"!=typeof r)throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");return null===o?r:function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];o.apply(this,t),r.apply(this,t)}},null)}var An,In={map:function(e,t,n){var o=0;return P.Children.map(e,function(e){return P.isValidElement(e)?t.call(n,e,o++):e})},forEach:function(e,t,n){var o=0;P.Children.forEach(e,function(e){P.isValidElement(e)&&t.call(n,e,o++)})},count:function(e){var t=0;return P.Children.forEach(e,function(e){P.isValidElement(e)&&++t}),t},find:function(e,t,n){var o=0,r=void 0;return P.Children.forEach(e,function(e){r||P.isValidElement(e)&&t.call(n,e,o++)&&(r=e)}),r},filter:function(e,t,n){var o=0,r=[];return P.Children.forEach(e,function(e){P.isValidElement(e)&&t.call(n,e,o++)&&r.push(e)}),r},every:function(e,t,n){var o=0,r=!0;return P.Children.forEach(e,function(e){r&&P.isValidElement(e)&&(t.call(n,e,o++)||(r=!1))}),r},some:function(e,t,n){var o=0,r=!1;return P.Children.forEach(e,function(e){r||P.isValidElement(e)&&t.call(n,e,o++)&&(r=!0)}),r},toArray:function(e){var t=[];return P.Children.forEach(e,function(e){P.isValidElement(e)&&t.push(e)}),t}},Dn={accordion:T.bool,activeKey:T.any,defaultActiveKey:T.any,onSelect:T.func,role:T.string},Ln=(An=P.Component,nn(Fn,An),Fn.prototype.handleSelect=function(e,t){t.preventDefault(),this.props.onSelect&&this.props.onSelect(e,t),this.state.activeKey===e&&(e=null),this.setState({activeKey:e})},Fn.prototype.render=function(){var n=this,e=this.props,o=e.accordion,t=e.activeKey,r=e.className,i=e.children,a=Mn(on(e,["accordion","activeKey","className","children"]),["defaultActiveKey","onSelect"]),s=a[0],l=a[1],c=void 0;o&&(c=null!=t?t:this.state.activeKey,l.role=l.role||"tablist");var u=Tn(s);return P.createElement("div",be({},l,{className:rn(r,u)}),In.map(i,function(e){var t={bsStyle:e.props.bsStyle||s.bsStyle};return o&&ye(t,{headerRole:"tab",panelRole:"tabpanel",collapsible:!0,expanded:e.props.eventKey===c,onSelect:Rn(n.handleSelect,e.props.onSelect)}),_.cloneElement(e,t)}))},Fn);function Fn(e,t){ge(this,Fn);var n=Gt(this,An.call(this,e,t));return n.handleSelect=n.handleSelect.bind(n),n.state={activeKey:e.defaultActiveKey},n}Ln.propTypes=Dn,Ln.defaultProps={accordion:!1};var jn,Kn=wn("panel-group",Ln);jn=P.Component,nn(Hn,jn),Hn.prototype.render=function(){return P.createElement(Kn,be({},this.props,{accordion:!0}),this.props.children)};function Hn(){return ge(this,Hn),Gt(this,jn.apply(this,arguments))}var Un=tn(!1);z(z.S,"Object",{values:function(e){return Un(e)}});var $n,Bn=N.Object.values,Vn=t(n(function(e){e.exports={default:Bn,__esModule:!0}})),Wn={label:T.string.isRequired,onClick:T.func},qn=($n=P.Component,nn(zn,$n),zn.prototype.render=function(){var e=this.props,t=e.label,n=e.onClick;return P.createElement("button",{type:"button",className:"close",onClick:n},P.createElement("span",{"aria-hidden":"true"},"×"),P.createElement("span",{className:"sr-only"},t))},zn);function zn(){return ge(this,zn),Gt(this,$n.apply(this,arguments))}qn.propTypes=Wn,qn.defaultProps={label:"Close"};var Gn,Yn={onDismiss:T.func,closeLabel:T.string},Xn=(Gn=P.Component,nn(Jn,Gn),Jn.prototype.render=function(){var e,t=this.props,n=t.onDismiss,o=t.closeLabel,r=t.className,i=t.children,a=kn(on(t,["onDismiss","closeLabel","className","children"])),s=a[0],l=a[1],c=!!n,u=be({},Tn(s),((e={})[On(s,"dismissable")]=c,e));return P.createElement("div",be({},l,{role:"alert",className:rn(r,u)}),c&&P.createElement(qn,{onClick:n,label:o}),i)},Jn);function Jn(){return ge(this,Jn),Gt(this,Gn.apply(this,arguments))}Xn.propTypes=Yn,Xn.defaultProps={closeLabel:"Close alert"},xn(Vn(yn),yn.INFO,wn("alert",Xn));var Zn,Qn={pullRight:T.bool},eo=(Zn=P.Component,nn(to,Zn),to.prototype.hasContent=function(e){var t=!1;return P.Children.forEach(e,function(e){t||!e&&0!==e||(t=!0)}),t},to.prototype.render=function(){var e=this.props,t=e.pullRight,n=e.className,o=e.children,r=kn(on(e,["pullRight","className","children"])),i=r[0],a=r[1],s=be({},Tn(i),{"pull-right":t,hidden:!this.hasContent(o)});return P.createElement("span",be({},a,{className:rn(n,s)}),o)},to);function to(){return ge(this,to),Gt(this,Zn.apply(this,arguments))}eo.propTypes=Qn,eo.defaultProps={pullRight:!1},wn("badge",eo);var no=n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var n="function"==typeof Symbol&&Symbol.for,o=n?Symbol.for("react.element"):60103,r=n?Symbol.for("react.portal"):60106,i=n?Symbol.for("react.fragment"):60107,a=n?Symbol.for("react.strict_mode"):60108,s=n?Symbol.for("react.profiler"):60114,l=n?Symbol.for("react.provider"):60109,c=n?Symbol.for("react.context"):60110,u=n?Symbol.for("react.async_mode"):60111,p=n?Symbol.for("react.concurrent_mode"):60111,d=n?Symbol.for("react.forward_ref"):60112,f=n?Symbol.for("react.suspense"):60113,h=n?Symbol.for("react.memo"):60115,m=n?Symbol.for("react.lazy"):60116;function v(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case o:switch(e=e.type){case u:case p:case i:case s:case a:case f:return e;default:switch(e=e&&e.$$typeof){case c:case d:case l:return e;default:return t}}case m:case h:case r:return t}}}function y(e){return v(e)===p}t.typeOf=v,t.AsyncMode=u,t.ConcurrentMode=p,t.ContextConsumer=c,t.ContextProvider=l,t.Element=o,t.ForwardRef=d,t.Fragment=i,t.Lazy=m,t.Memo=h,t.Portal=r,t.Profiler=s,t.StrictMode=a,t.Suspense=f,t.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===i||e===p||e===s||e===a||e===f||"object"==typeof e&&null!==e&&(e.$$typeof===m||e.$$typeof===h||e.$$typeof===l||e.$$typeof===c||e.$$typeof===d)},t.isAsyncMode=function(e){return y(e)||v(e)===u},t.isConcurrentMode=y,t.isContextConsumer=function(e){return v(e)===c},t.isContextProvider=function(e){return v(e)===l},t.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===o},t.isForwardRef=function(e){return v(e)===d},t.isFragment=function(e){return v(e)===i},t.isLazy=function(e){return v(e)===m},t.isMemo=function(e){return v(e)===h},t.isPortal=function(e){return v(e)===r},t.isProfiler=function(e){return v(e)===s},t.isStrictMode=function(e){return v(e)===a},t.isSuspense=function(e){return v(e)===f}});t(no);no.typeOf,no.AsyncMode,no.ConcurrentMode,no.ContextConsumer,no.ContextProvider,no.Element,no.ForwardRef,no.Fragment,no.Lazy,no.Memo,no.Portal,no.Profiler,no.StrictMode,no.Suspense,no.isValidElementType,no.isAsyncMode,no.isConcurrentMode,no.isContextConsumer,no.isContextProvider,no.isElement,no.isForwardRef,no.isFragment,no.isLazy,no.isMemo,no.isPortal,no.isProfiler,no.isStrictMode,no.isSuspense;var oo=n(function(e,M){"production"!=="production"&&function(){Object.defineProperty(M,"__esModule",{value:!0});var e="function"==typeof Symbol&&Symbol.for,r=e?Symbol.for("react.element"):60103,i=e?Symbol.for("react.portal"):60106,a=e?Symbol.for("react.fragment"):60107,s=e?Symbol.for("react.strict_mode"):60108,l=e?Symbol.for("react.profiler"):60114,c=e?Symbol.for("react.provider"):60109,u=e?Symbol.for("react.context"):60110,p=e?Symbol.for("react.async_mode"):60111,d=e?Symbol.for("react.concurrent_mode"):60111,f=e?Symbol.for("react.forward_ref"):60112,h=e?Symbol.for("react.suspense"):60113,m=e?Symbol.for("react.memo"):60115,v=e?Symbol.for("react.lazy"):60116;var t=function(e,t){if(void 0===t)throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");if(!e){for(var n=arguments.length,o=Array(2<n?n-2:0),r=2;r<n;r++)o[r-2]=arguments[r];(function(e){for(var t=arguments.length,n=Array(1<t?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var r=0,i="Warning: "+e.replace(/%s/g,function(){return n[r++]});"undefined"!=typeof console&&console.warn(i);try{throw new Error(i)}catch(e){}}).apply(void 0,[t].concat(o))}};function n(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case r:var n=e.type;switch(n){case p:case d:case a:case l:case s:case h:return n;default:var o=n&&n.$$typeof;switch(o){case u:case f:case c:return o;default:return t}}case v:case m:case i:return t}}}var o=p,y=d,b=u,g=c,E=r,C=f,N=a,O=v,w=m,x=i,_=l,T=s,S=h,P=!1;function k(e){return n(e)===d}M.typeOf=n,M.AsyncMode=o,M.ConcurrentMode=y,M.ContextConsumer=b,M.ContextProvider=g,M.Element=E,M.ForwardRef=C,M.Fragment=N,M.Lazy=O,M.Memo=w,M.Portal=x,M.Profiler=_,M.StrictMode=T,M.Suspense=S,M.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===a||e===d||e===l||e===s||e===h||"object"==typeof e&&null!==e&&(e.$$typeof===v||e.$$typeof===m||e.$$typeof===c||e.$$typeof===u||e.$$typeof===f)},M.isAsyncMode=function(e){return P||t(!(P=!0),"The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API."),k(e)||n(e)===p},M.isConcurrentMode=k,M.isContextConsumer=function(e){return n(e)===u},M.isContextProvider=function(e){return n(e)===c},M.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},M.isForwardRef=function(e){return n(e)===f},M.isFragment=function(e){return n(e)===a},M.isLazy=function(e){return n(e)===v},M.isMemo=function(e){return n(e)===m},M.isPortal=function(e){return n(e)===i},M.isProfiler=function(e){return n(e)===l},M.isStrictMode=function(e){return n(e)===s},M.isSuspense=function(e){return n(e)===h}}()});t(oo);oo.typeOf,oo.AsyncMode,oo.ConcurrentMode,oo.ContextConsumer,oo.ContextProvider,oo.Element,oo.ForwardRef,oo.Fragment,oo.Lazy,oo.Memo,oo.Portal,oo.Profiler,oo.StrictMode,oo.Suspense,oo.isValidElementType,oo.isAsyncMode,oo.isConcurrentMode,oo.isContextConsumer,oo.isContextProvider,oo.isElement,oo.isForwardRef,oo.isFragment,oo.isLazy,oo.isMemo,oo.isPortal,oo.isProfiler,oo.isStrictMode,oo.isSuspense;var ro=n(function(e){ true?e.exports=no:e.exports=oo}),io=(ro.isValidElementType,n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(p){function e(e,t,n,o,r,i){var a=o||"<<anonymous>>",s=i||n;if(null==t[n])return e?new Error("Required "+r+" `"+s+"` was not specified in `"+a+"`."):null;for(var l=arguments.length,c=Array(6<l?l-6:0),u=6;u<l;u++)c[u-6]=arguments[u];return p.apply(void 0,[t,n,a,r,s].concat(c))}var t=e.bind(null,!1);return t.isRequired=e.bind(null,!0),t},e.exports=t.default})),ao=t(io),so=n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var a=o(P),n=o(io);function o(e){return e&&e.__esModule?e:{default:e}}t.default=(0,n.default)(function(e,t,n,o,r){var i=e[t];return a.default.isValidElement(i)?new Error("Invalid "+o+" `"+r+"` of type ReactElement supplied to `"+n+"`,expected an element type (a string , component class, or function component)."):(0,ro.isValidElementType)(i)?null:new Error("Invalid "+o+" `"+r+"` of value `"+i+"` supplied to `"+n+"`, expected an element type (a string , component class, or function component).")}),e.exports=t.default}),lo=t(so),co={href:T.string,onClick:T.func,onKeyDown:T.func,disabled:T.bool,role:T.string,tabIndex:T.oneOfType([T.number,T.string]),componentClass:lo};function uo(e){return!e||"#"===e.trim()}var po,fo=(po=P.Component,nn(ho,po),ho.prototype.handleClick=function(e){var t=this.props,n=t.disabled,o=t.href,r=t.onClick;(n||uo(o))&&e.preventDefault(),n?e.stopPropagation():r&&r(e)},ho.prototype.handleKeyDown=function(e){" "===e.key&&(e.preventDefault(),this.handleClick(e))},ho.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.disabled,o=e.onKeyDown,r=on(e,["componentClass","disabled","onKeyDown"]);return uo(r.href)&&(r.role=r.role||"button",r.href=r.href||"#"),n&&(r.tabIndex=-1,r.style=be({pointerEvents:"none"},r.style)),P.createElement(t,be({},r,{onClick:this.handleClick,onKeyDown:Rn(this.handleKeyDown,o)}))},ho);function ho(e,t){ge(this,ho);var n=Gt(this,po.call(this,e,t));return n.handleClick=n.handleClick.bind(n),n.handleKeyDown=n.handleKeyDown.bind(n),n}fo.propTypes=co,fo.defaultProps={componentClass:"a"};var mo,vo={active:T.bool,href:T.string,title:T.node,target:T.string},yo=(mo=P.Component,nn(bo,mo),bo.prototype.render=function(){var e=this.props,t=e.active,n=e.href,o=e.title,r=e.target,i=e.className,a=on(e,["active","href","title","target","className"]),s={href:n,title:o,target:r};return P.createElement("li",{className:rn(i,{active:t})},t?P.createElement("span",a):P.createElement(fo,be({},a,s)))},bo);function bo(){return ge(this,bo),Gt(this,mo.apply(this,arguments))}yo.propTypes=vo,yo.defaultProps={active:!1};var go,Eo=(go=P.Component,nn(Co,go),Co.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("ol",be({},r,{role:"navigation","aria-label":"breadcrumbs",className:rn(t,i)}))},Co);function Co(){return ge(this,Co),Gt(this,go.apply(this,arguments))}Eo.Item=yo,wn("breadcrumb",Eo);var No,Oo={active:T.bool,disabled:T.bool,block:T.bool,onClick:T.func,componentClass:lo,href:T.string,type:T.oneOf(["button","reset","submit"])},wo=(No=P.Component,nn(xo,No),xo.prototype.renderAnchor=function(e,t){return P.createElement(fo,be({},e,{className:rn(t,e.disabled&&"disabled")}))},xo.prototype.renderButton=function(e,t){var n=e.componentClass,o=on(e,["componentClass"]),r=n||"button";return P.createElement(r,be({},o,{type:o.type||"button",className:t}))},xo.prototype.render=function(){var e,t=this.props,n=t.active,o=t.block,r=t.className,i=kn(on(t,["active","block","className"])),a=i[0],s=i[1],l=be({},Tn(a),((e={active:n})[On(a,"block")]=o,e)),c=rn(r,l);return s.href?this.renderAnchor(s,c):this.renderButton(s,c)},xo);function xo(){return ge(this,xo),Gt(this,No.apply(this,arguments))}wo.propTypes=Oo,wo.defaultProps={active:!1,block:!1,disabled:!1};var _o,To=wn("btn",_n([dn,fn,hn],xn([].concat(Vn(yn),[bn,gn,En]),bn,wo))),So=t(n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){for(var e=arguments.length,r=Array(e),t=0;t<e;t++)r[t]=arguments[t];return(0,o.default)(function(){for(var e=arguments.length,n=Array(e),t=0;t<e;t++)n[t]=arguments[t];var o=null;return r.forEach(function(e){if(null==o){var t=e.apply(void 0,n);null!=t&&(o=t)}}),o})};var n,o=(n=io)&&n.__esModule?n:{default:n};e.exports=t.default})),Po={vertical:T.bool,justified:T.bool,block:So(T.bool,function(e){var t=e.block,n=e.vertical;return t&&!n?new Error("`block` requires `vertical` to be set to have any effect"):null})},ko=(_o=P.Component,nn(Mo,_o),Mo.prototype.render=function(){var e,t=this.props,n=t.block,o=t.justified,r=t.vertical,i=t.className,a=kn(on(t,["block","justified","vertical","className"])),s=a[0],l=a[1],c=be({},Tn(s),((e={})[On(s)]=!r,e[On(s,"vertical")]=r,e[On(s,"justified")]=o,e[On(To.defaultProps,"block")]=n,e));return P.createElement("div",be({},l,{className:rn(i,c)}))},Mo);function Mo(){return ge(this,Mo),Gt(this,_o.apply(this,arguments))}ko.propTypes=Po,ko.defaultProps={block:!1,justified:!1,vertical:!1};var Ro,Ao=wn("btn-group",ko);function Io(){return ge(this,Io),Gt(this,Ro.apply(this,arguments))}wn("btn-toolbar",(Ro=P.Component,nn(Io,Ro),Io.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("div",be({},r,{role:"toolbar",className:rn(t,i)}))},Io));var Do,Lo={componentClass:lo},Fo=(Do=P.Component,nn(jo,Do),jo.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},jo);function jo(){return ge(this,jo),Gt(this,Do.apply(this,arguments))}Fo.propTypes=Lo,Fo.defaultProps={componentClass:"div"};var Ko=wn("carousel-caption",Fo),Ho=!("undefined"==typeof window||!window.document||!window.document.createElement),Uo={transitionend:{transition:"transitionend",WebkitTransition:"webkitTransitionEnd",MozTransition:"mozTransitionEnd",OTransition:"oTransitionEnd",msTransition:"MSTransitionEnd"},animationend:{animation:"animationend",WebkitAnimation:"webkitAnimationEnd",MozAnimation:"mozAnimationEnd",OAnimation:"oAnimationEnd",msAnimation:"MSAnimationEnd"}},$o=[];Ho&&function(){var e=document.createElement("div").style;for(var t in"AnimationEvent"in window||delete Uo.animationend.animation,"TransitionEvent"in window||delete Uo.transitionend.transition,Uo){var n=Uo[t];for(var o in n)if(o in e){$o.push(n[o]);break}}}();var Bo,Vo=function(t,n){0!==$o.length?$o.forEach(function(e){!function(e,t,n){e.addEventListener(t,n,!1)}(t,e,n)}):window.setTimeout(n,0)},Wo={direction:T.oneOf(["prev","next"]),onAnimateOutEnd:T.func,active:T.bool,animateIn:T.bool,animateOut:T.bool,index:T.number},qo=(Bo=P.Component,nn(zo,Bo),zo.prototype.componentWillReceiveProps=function(e){this.props.active!==e.active&&this.setState({direction:null})},zo.prototype.componentDidUpdate=function(e){var t=this,n=this.props.active,o=e.active;!n&&o&&Vo(S.findDOMNode(this),this.handleAnimateOutEnd),n!==o&&setTimeout(function(){return t.startAnimation()},20)},zo.prototype.componentWillUnmount=function(){this.isUnmounted=!0},zo.prototype.handleAnimateOutEnd=function(){this.isUnmounted||this.props.onAnimateOutEnd&&this.props.onAnimateOutEnd(this.props.index)},zo.prototype.startAnimation=function(){this.isUnmounted||this.setState({direction:"prev"===this.props.direction?"right":"left"})},zo.prototype.render=function(){var e=this.props,t=e.direction,n=e.active,o=e.animateIn,r=e.animateOut,i=e.className,a=on(e,["direction","active","animateIn","animateOut","className"]);delete a.onAnimateOutEnd,delete a.index;var s={item:!0,active:n&&!o||r};return t&&n&&o&&(s[t]=!0),this.state.direction&&(o||r)&&(s[this.state.direction]=!0),P.createElement("div",be({},a,{className:rn(i,s)}))},zo);function zo(e,t){ge(this,zo);var n=Gt(this,Bo.call(this,e,t));return n.handleAnimateOutEnd=n.handleAnimateOutEnd.bind(n),n.state={direction:null},n.isUnmounted=!1,n}qo.propTypes=Wo,qo.defaultProps={active:!1,animateIn:!1,animateOut:!1};var Go,Yo={glyph:T.string.isRequired},Xo=(Go=P.Component,nn(Jo,Go),Jo.prototype.render=function(){var e,t=this.props,n=t.glyph,o=t.className,r=kn(on(t,["glyph","className"])),i=r[0],a=r[1],s=be({},Tn(i),((e={})[On(i,n)]=!0,e));return P.createElement("span",be({},a,{className:rn(o,s)}))},Jo);function Jo(){return ge(this,Jo),Gt(this,Go.apply(this,arguments))}Xo.propTypes=Yo;var Zo,Qo=wn("glyphicon",Xo),er={slide:T.bool,indicators:T.bool,interval:T.number,controls:T.bool,pauseOnHover:T.bool,wrap:T.bool,onSelect:T.func,onSlideEnd:T.func,activeIndex:T.number,defaultActiveIndex:T.number,direction:T.oneOf(["prev","next"]),prevIcon:T.node,prevLabel:T.string,nextIcon:T.node,nextLabel:T.string},tr={slide:!0,interval:5e3,pauseOnHover:!0,wrap:!0,indicators:!0,controls:!0,prevIcon:P.createElement(Qo,{glyph:"chevron-left"}),prevLabel:"Previous",nextIcon:P.createElement(Qo,{glyph:"chevron-right"}),nextLabel:"Next"},nr=(Zo=P.Component,nn(or,Zo),or.prototype.componentDidMount=function(){this.waitForNext()},or.prototype.componentWillReceiveProps=function(e){var t=this.getActiveIndex();null!=e.activeIndex&&e.activeIndex!==t&&(clearTimeout(this.timeout),this.setState({previousActiveIndex:t,direction:null!=e.direction?e.direction:this.getDirection(t,e.activeIndex)})),null==e.activeIndex&&this.state.activeIndex>=e.children.length&&this.setState({activeIndex:0,previousActiveIndex:null,direction:null})},or.prototype.componentWillUnmount=function(){clearTimeout(this.timeout),this.isUnmounted=!0},or.prototype.getActiveIndex=function(){var e=this.props.activeIndex;return null!=e?e:this.state.activeIndex},or.prototype.getDirection=function(e,t){return e===t?null:t<e?"prev":"next"},or.prototype.handleItemAnimateOutEnd=function(){var e=this;this.setState({previousActiveIndex:null,direction:null},function(){e.waitForNext(),e.props.onSlideEnd&&e.props.onSlideEnd()})},or.prototype.handleMouseOut=function(){this.isPaused&&this.play()},or.prototype.handleMouseOver=function(){this.props.pauseOnHover&&this.pause()},or.prototype.handleNext=function(e){var t=this.getActiveIndex()+1;if(In.count(this.props.children)-1<t){if(!this.props.wrap)return;t=0}this.select(t,e,"next")},or.prototype.handlePrev=function(e){var t=this.getActiveIndex()-1;if(t<0){if(!this.props.wrap)return;t=In.count(this.props.children)-1}this.select(t,e,"prev")},or.prototype.pause=function(){this.isPaused=!0,clearTimeout(this.timeout)},or.prototype.play=function(){this.isPaused=!1,this.waitForNext()},or.prototype.select=function(e,t,n){if(clearTimeout(this.timeout),!this.isUnmounted){var o=this.props.slide?this.getActiveIndex():null;n=n||this.getDirection(o,e);var r=this.props.onSelect;if(r&&(1<r.length?(t?(t.persist(),t.direction=n):t={direction:n},r(e,t)):r(e)),null==this.props.activeIndex&&e!==o){if(null!=this.state.previousActiveIndex)return;this.setState({activeIndex:e,previousActiveIndex:o,direction:n})}}},or.prototype.waitForNext=function(){var e=this.props,t=e.slide,n=e.interval,o=e.activeIndex;!this.isPaused&&t&&n&&null==o&&(this.timeout=setTimeout(this.handleNext,n))},or.prototype.renderControls=function(e){var t=e.wrap,n=e.children,o=e.activeIndex,r=e.prevIcon,i=e.nextIcon,a=e.bsProps,s=e.prevLabel,l=e.nextLabel,c=On(a,"control"),u=In.count(n);return[(t||0!==o)&&P.createElement(fo,{key:"prev",className:rn(c,"left"),onClick:this.handlePrev},r,s&&P.createElement("span",{className:"sr-only"},s)),(t||o!==u-1)&&P.createElement(fo,{key:"next",className:rn(c,"right"),onClick:this.handleNext},i,l&&P.createElement("span",{className:"sr-only"},l))]},or.prototype.renderIndicators=function(e,n,t){var o=this,r=[];return In.forEach(e,function(e,t){r.push(P.createElement("li",{key:t,className:t===n?"active":null,onClick:function(e){return o.select(t,e)}})," ")}),P.createElement("ol",{className:On(t,"indicators")},r)},or.prototype.render=function(){var r=this,e=this.props,i=e.slide,t=e.indicators,n=e.controls,o=e.wrap,a=e.prevIcon,s=e.prevLabel,l=e.nextIcon,c=e.nextLabel,u=e.className,p=e.children,d=on(e,["slide","indicators","controls","wrap","prevIcon","prevLabel","nextIcon","nextLabel","className","children"]),f=this.state,h=f.previousActiveIndex,m=f.direction,v=Mn(d,["interval","pauseOnHover","onSelect","onSlideEnd","activeIndex","defaultActiveIndex","direction"]),y=v[0],b=v[1],g=this.getActiveIndex(),E=be({},Tn(y),{slide:i});return P.createElement("div",be({},b,{className:rn(u,E),onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut}),t&&this.renderIndicators(p,g,y),P.createElement("div",{className:On(y,"inner")},In.map(p,function(e,t){var n=t===g,o=i&&t===h;return _.cloneElement(e,{active:n,index:t,animateOut:o,animateIn:n&&null!=h&&i,direction:m,onAnimateOutEnd:o?r.handleItemAnimateOutEnd:null})})),n&&this.renderControls({wrap:o,children:p,activeIndex:g,prevIcon:a,prevLabel:s,nextIcon:l,nextLabel:c,bsProps:y}))},or);function or(e,t){ge(this,or);var n=Gt(this,Zo.call(this,e,t));n.handleMouseOver=n.handleMouseOver.bind(n),n.handleMouseOut=n.handleMouseOut.bind(n),n.handlePrev=n.handlePrev.bind(n),n.handleNext=n.handleNext.bind(n),n.handleItemAnimateOutEnd=n.handleItemAnimateOutEnd.bind(n);var o=e.defaultActiveIndex;return n.state={activeIndex:null!=o?o:0,previousActiveIndex:null,direction:null},n.isUnmounted=!1,n}nr.propTypes=er,nr.defaultProps=tr,nr.Caption=Ko,nr.Item=qo,wn("carousel",nr);var rr=function(){};"production"!=="production"&&(rr=function(e,t,n){var o=arguments.length;n=new Array(2<o?o-2:0);for(var r=2;r<o;r++)n[r-2]=arguments[r];if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(t.length<10||/^[s\W]*$/.test(t))throw new Error("The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: "+t);if(!e){var i=0,a="Warning: "+t.replace(/%s/g,function(){return n[i++]});"undefined"!=typeof console&&console.error(a);try{throw new Error(a)}catch(e){}}});var ir,ar=rr,sr={inline:T.bool,disabled:T.bool,title:T.string,validationState:T.oneOf(["success","warning","error",null]),inputRef:T.func},lr=(ir=P.Component,nn(cr,ir),cr.prototype.render=function(){var e=this.props,t=e.inline,n=e.disabled,o=e.validationState,r=e.inputRef,i=e.className,a=e.style,s=e.title,l=e.children,c=kn(on(e,["inline","disabled","validationState","inputRef","className","style","title","children"])),u=c[0],p=c[1],d=P.createElement("input",be({},p,{ref:r,type:"checkbox",disabled:n}));if(t){var f,h=((f={})[On(u,"inline")]=!0,f.disabled=n,f);return"production"!=="production"&&ar(!o,"`validationState` is ignored on `<Checkbox inline>`. To display validation state on an inline checkbox, set `validationState` on a parent `<FormGroup>` or other element instead."),P.createElement("label",{className:rn(i,h),style:a,title:s},d,l)}var m=be({},Tn(u),{disabled:n});return o&&(m["has-"+o]=!0),P.createElement("div",{className:rn(i,m),style:a},P.createElement("label",{title:s},d,l))},cr);function cr(){return ge(this,cr),Gt(this,ir.apply(this,arguments))}function ur(e){return""+e.charAt(0).toUpperCase()+e.slice(1)}lr.propTypes=sr,lr.defaultProps={inline:!1,disabled:!1,title:""},wn("checkbox",lr);var pr,dr={componentClass:lo,visibleXsBlock:T.bool,visibleSmBlock:T.bool,visibleMdBlock:T.bool,visibleLgBlock:T.bool},fr=(pr=P.Component,nn(hr,pr),hr.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return vn.forEach(function(e){var t="visible"+ur(e)+"Block";i[t]&&(a["visible-"+e+"-block"]=!0),delete i[t]}),P.createElement(t,be({},i,{className:rn(n,a)}))},hr);function hr(){return ge(this,hr),Gt(this,pr.apply(this,arguments))}fr.propTypes=dr,fr.defaultProps={componentClass:"div"},wn("clearfix",fr);var mr,vr={htmlFor:T.string,srOnly:T.bool},yr={$bs_formGroup:T.object},br=(mr=P.Component,nn(gr,mr),gr.prototype.render=function(){var e=this.context.$bs_formGroup,t=e&&e.controlId,n=this.props,o=n.htmlFor,r=void 0===o?t:o,i=n.srOnly,a=n.className,s=kn(on(n,["htmlFor","srOnly","className"])),l=s[0],c=s[1];"production"!=="production"&&ar(null==t||r===t,"`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.");var u=be({},Tn(l),{"sr-only":i});return P.createElement("label",be({},c,{htmlFor:r,className:rn(a,u)}))},gr);function gr(){return ge(this,gr),Gt(this,mr.apply(this,arguments))}br.propTypes=vr,br.defaultProps={srOnly:!1},br.contextTypes=yr,wn("control-label",br);var Er,Cr={componentClass:lo,xs:T.number,sm:T.number,md:T.number,lg:T.number,xsHidden:T.bool,smHidden:T.bool,mdHidden:T.bool,lgHidden:T.bool,xsOffset:T.number,smOffset:T.number,mdOffset:T.number,lgOffset:T.number,xsPush:T.number,smPush:T.number,mdPush:T.number,lgPush:T.number,xsPull:T.number,smPull:T.number,mdPull:T.number,lgPull:T.number},Nr=(Er=P.Component,nn(Or,Er),Or.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),i=o[0],a=o[1],s=[];return vn.forEach(function(r){function e(e,t){var n=""+r+e,o=a[n];null!=o&&s.push(On(i,""+r+t+"-"+o)),delete a[n]}e("",""),e("Offset","-offset"),e("Push","-push"),e("Pull","-pull");var t=r+"Hidden";a[t]&&s.push("hidden-"+r),delete a[t]}),P.createElement(t,be({},a,{className:rn(n,s)}))},Or);function Or(){return ge(this,Or),Gt(this,Er.apply(this,arguments))}Nr.propTypes=Cr,Nr.defaultProps={componentClass:"div"},wn("col",Nr);var wr=n(function(e){e.exports=function(e){return e&&e.__esModule?e:{default:e}}});t(wr);var xr=n(function(e,t){t.__esModule=!0,t.default=function(e){return e.replace(n,function(e,t){return t.toUpperCase()})};var n=/-(.)/g;e.exports=t.default});t(xr);var _r=n(function(e,t){t.__esModule=!0,t.default=function(e){return(0,n.default)(e.replace(o,"ms-"))};var n=wr(xr),o=/^-ms-/;e.exports=t.default});t(_r);var Tr=n(function(e,t){t.__esModule=!0,t.default=function(e){return e.replace(n,"-$1").toLowerCase()};var n=/([A-Z])/g;e.exports=t.default});t(Tr);var Sr=n(function(e,t){t.__esModule=!0,t.default=function(e){return(0,n.default)(e).replace(o,"-ms-")};var n=wr(Tr),o=/^ms-/;e.exports=t.default});t(Sr);var Pr=n(function(e,t){t.__esModule=!0,t.default=function(a){if(!a)throw new TypeError("No Element passed to `getComputedStyle()`");var e=a.ownerDocument;return"defaultView"in e?e.defaultView.opener?a.ownerDocument.defaultView.getComputedStyle(a,null):window.getComputedStyle(a,null):{getPropertyValue:function(e){var t=a.style;"float"==(e=(0,s.default)(e))&&(e="styleFloat");var n=a.currentStyle[e]||null;if(null==n&&t&&t[e]&&(n=t[e]),c.test(n)&&!l.test(e)){var o=t.left,r=a.runtimeStyle,i=r&&r.left;i&&(r.left=a.currentStyle.left),t.left="fontSize"===e?"1em":n,n=t.pixelLeft+"px",t.left=o,i&&(r.left=i)}return n}}};var s=wr(_r),l=/^(top|right|bottom|left)$/,c=/^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;e.exports=t.default});t(Pr);var kr=n(function(e,t){t.__esModule=!0,t.default=function(e,t){return"removeProperty"in e.style?e.style.removeProperty(t):e.style.removeAttribute(t)},e.exports=t.default});t(kr);var Mr=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=!("undefined"==typeof window||!window.document||!window.document.createElement);t.default=n,e.exports=t.default}),Rr=t(Mr),Ar=n(function(e,t){t.__esModule=!0,t.default=t.animationEnd=t.animationDelay=t.animationTiming=t.animationDuration=t.animationName=t.transitionEnd=t.transitionDuration=t.transitionDelay=t.transitionTiming=t.transitionProperty=t.transform=void 0;var n,o,r,i,a,s,l,c,u,p,d,f=wr(Mr),h="transform";if(t.transform=h,t.animationEnd=r,t.transitionEnd=o,t.transitionDelay=l,t.transitionTiming=s,t.transitionDuration=a,t.transitionProperty=i,t.animationDelay=d,t.animationTiming=p,t.animationDuration=u,t.animationName=c,f.default){var m=function(){for(var e,t,n=document.createElement("div").style,o={O:function(e){return"o"+e.toLowerCase()},Moz:function(e){return e.toLowerCase()},Webkit:function(e){return"webkit"+e},ms:function(e){return"MS"+e}},r=Object.keys(o),i="",a=0;a<r.length;a++){var s=r[a];if(s+"TransitionProperty"in n){i="-"+s.toLowerCase(),e=o[s]("TransitionEnd"),t=o[s]("AnimationEnd");break}}!e&&"transitionProperty"in n&&(e="transitionend");!t&&"animationName"in n&&(t="animationend");return n=null,{animationEnd:t,transitionEnd:e,prefix:i}}();n=m.prefix,t.transitionEnd=o=m.transitionEnd,t.animationEnd=r=m.animationEnd,t.transform=h=n+"-"+h,t.transitionProperty=i=n+"-transition-property",t.transitionDuration=a=n+"-transition-duration",t.transitionDelay=l=n+"-transition-delay",t.transitionTiming=s=n+"-transition-timing-function",t.animationName=c=n+"-animation-name",t.animationDuration=u=n+"-animation-duration",t.animationTiming=p=n+"-animation-delay",t.animationDelay=d=n+"-animation-timing-function"}var v={transform:h,end:o,property:i,timing:s,delay:l,duration:a};t.default=v});t(Ar);Ar.animationEnd,Ar.animationDelay,Ar.animationTiming,Ar.animationDuration,Ar.animationName,Ar.transitionEnd,Ar.transitionDuration,Ar.transitionDelay,Ar.transitionTiming,Ar.transitionProperty,Ar.transform;var Ir=n(function(e,t){t.__esModule=!0,t.default=function(e){return!(!e||!n.test(e))};var n=/^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;e.exports=t.default});t(Ir);var Dr=n(function(e,t){t.__esModule=!0,t.default=function(n,e,t){var o="",r="",i=e;if("string"==typeof e){if(void 0===t)return n.style[(0,a.default)(e)]||(0,l.default)(n).getPropertyValue((0,s.default)(e));(i={})[e]=t}Object.keys(i).forEach(function(e){var t=i[e];t||0===t?(0,u.default)(e)?r+=e+"("+t+") ":o+=(0,s.default)(e)+": "+t+";":(0,c.default)(n,(0,s.default)(e))}),r&&(o+=Ar.transform+": "+r+";");n.style.cssText+=";"+o};var a=wr(_r),s=wr(Sr),l=wr(Pr),c=wr(kr),u=wr(Ir);e.exports=t.default}),Lr=t(Dr),Fr=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=function(){};wr(Mr).default&&(n=document.addEventListener?function(e,t,n,o){return e.addEventListener(t,n,o||!1)}:document.attachEvent?function(t,e,n){return t.attachEvent("on"+e,function(e){(e=e||window.event).target=e.target||e.srcElement,e.currentTarget=t,n.call(t,e)})}:void 0);var o=n;t.default=o,e.exports=t.default});t(Fr);var jr=n(function(e,t){t.__esModule=!0,t.EXITING=t.ENTERED=t.ENTERING=t.EXITED=t.UNMOUNTED=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},l=a(rn),r=a(Fr),n=a(Ar),o=a(T),c=a(P),i=a(S);function a(e){return e&&e.__esModule?e:{default:e}}var u,p=n.default.end,d=t.UNMOUNTED=0,f=t.EXITED=1,h=t.ENTERING=2,m=t.ENTERED=3,v=t.EXITING=4,y=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(b,u=c.default.Component),b.prototype.componentDidMount=function(){this.updateStatus()},b.prototype.componentWillReceiveProps=function(e){var t=this.state.status;e.in?(t===d&&this.setState({status:f}),t!==h&&t!==m&&(this.nextStatus=h)):t!==h&&t!==m||(this.nextStatus=v)},b.prototype.componentDidUpdate=function(){this.updateStatus()},b.prototype.componentWillUnmount=function(){this.cancelNextCallback()},b.prototype.render=function(){var e=this.state.status;if(e===d)return null;var t=this.props,n=t.children,o=t.className,r=function(e,t){var n={};for(var o in e)0<=t.indexOf(o)||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}(t,["children","className"]);Object.keys(b.propTypes).forEach(function(e){return delete r[e]});var i=void 0;e===f?i=this.props.exitedClassName:e===h?i=this.props.enteringClassName:e===m?i=this.props.enteredClassName:e===v&&(i=this.props.exitingClassName);var a=c.default.Children.only(n);return c.default.cloneElement(a,s({},r,{className:(0,l.default)(a.props.className,o,i)}))},b);function b(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,b);var o=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,u.call(this,e,t));o.updateStatus=function(){if(null!==o.nextStatus){o.cancelNextCallback();var e=i.default.findDOMNode(o);o.nextStatus===h?(o.props.onEnter(e),o.safeSetState({status:h},function(){o.props.onEntering(e),o.onTransitionEnd(e,function(){o.safeSetState({status:m},function(){o.props.onEntered(e)})})})):(o.props.onExit(e),o.safeSetState({status:v},function(){o.props.onExiting(e),o.onTransitionEnd(e,function(){o.safeSetState({status:f},function(){o.props.onExited(e)})})})),o.nextStatus=null}else o.props.unmountOnExit&&o.state.status===f&&o.setState({status:d})},o.cancelNextCallback=function(){null!==o.nextCallback&&(o.nextCallback.cancel(),o.nextCallback=null)},o.safeSetState=function(e,t){o.setState(e,o.setNextCallback(t))},o.setNextCallback=function(t){var n=!0;return o.nextCallback=function(e){n&&(n=!1,o.nextCallback=null,t(e))},o.nextCallback.cancel=function(){n=!1},o.nextCallback},o.onTransitionEnd=function(e,t){o.setNextCallback(t),e?((0,r.default)(e,p,o.nextCallback),setTimeout(o.nextCallback,o.props.timeout)):setTimeout(o.nextCallback,0)};var n=void 0;return o.nextStatus=null,e.in?e.transitionAppear?(n=f,o.nextStatus=h):n=m:n=e.unmountOnExit||e.mountOnEnter?d:f,o.state={status:n},o.nextCallback=null,o}function g(){}y.propTypes={in:o.default.bool,mountOnEnter:o.default.bool,unmountOnExit:o.default.bool,transitionAppear:o.default.bool,timeout:o.default.number,exitedClassName:o.default.string,exitingClassName:o.default.string,enteredClassName:o.default.string,enteringClassName:o.default.string,onEnter:o.default.func,onEntering:o.default.func,onEntered:o.default.func,onExit:o.default.func,onExiting:o.default.func,onExited:o.default.func},y.displayName="Transition",y.defaultProps={in:!1,unmountOnExit:!1,transitionAppear:!1,timeout:5e3,onEnter:g,onEntering:g,onEntered:g,onExit:g,onExiting:g,onExited:g},t.default=y}),Kr=t(jr),Hr=(jr.EXITING,jr.ENTERED,jr.ENTERING,jr.EXITED,jr.UNMOUNTED,{height:["marginTop","marginBottom"],width:["marginLeft","marginRight"]});var Ur,$r={in:T.bool,mountOnEnter:T.bool,unmountOnExit:T.bool,transitionAppear:T.bool,timeout:T.number,onEnter:T.func,onEntering:T.func,onEntered:T.func,onExit:T.func,onExiting:T.func,onExited:T.func,dimension:T.oneOfType([T.oneOf(["height","width"]),T.func]),getDimensionValue:T.func,role:T.string},Br={in:!1,timeout:300,mountOnEnter:!1,unmountOnExit:!1,transitionAppear:!1,dimension:"height",getDimensionValue:function(e,t){var n=t["offset"+ur(e)],o=Hr[e];return n+parseInt(Lr(t,o[0]),10)+parseInt(Lr(t,o[1]),10)}},Vr=(Ur=P.Component,nn(Wr,Ur),Wr.prototype._dimension=function(){return"function"==typeof this.props.dimension?this.props.dimension():this.props.dimension},Wr.prototype._getScrollDimensionValue=function(e,t){return e["scroll"+ur(t)]+"px"},Wr.prototype.handleEnter=function(e){var t=this._dimension();e.style[t]="0"},Wr.prototype.handleEntered=function(e){var t=this._dimension();e.style[t]=null},Wr.prototype.handleEntering=function(e){var t=this._dimension();e.style[t]=this._getScrollDimensionValue(e,t)},Wr.prototype.handleExit=function(e){var t=this._dimension();e.style[t]=this.props.getDimensionValue(t,e)+"px",function(e){e.offsetHeight}(e)},Wr.prototype.handleExiting=function(e){var t=this._dimension();e.style[t]="0"},Wr.prototype.render=function(){var e=this.props,t=e.onEnter,n=e.onEntering,o=e.onEntered,r=e.onExit,i=e.onExiting,a=e.className,s=on(e,["onEnter","onEntering","onEntered","onExit","onExiting","className"]);delete s.dimension,delete s.getDimensionValue;var l=Rn(this.handleEnter,t),c=Rn(this.handleEntering,n),u=Rn(this.handleEntered,o),p=Rn(this.handleExit,r),d=Rn(this.handleExiting,i),f={width:"width"===this._dimension()};return P.createElement(Kr,be({},s,{"aria-expanded":s.role?s.in:null,className:rn(a,f),exitedClassName:"collapse",exitingClassName:"collapsing",enteredClassName:"collapse in",enteringClassName:"collapsing",onEnter:l,onEntering:c,onEntered:u,onExit:p,onExiting:d}))},Wr);function Wr(e,t){ge(this,Wr);var n=Gt(this,Ur.call(this,e,t));return n.handleEnter=n.handleEnter.bind(n),n.handleEntering=n.handleEntering.bind(n),n.handleEntered=n.handleEntered.bind(n),n.handleExit=n.handleExit.bind(n),n.handleExiting=n.handleExiting.bind(n),n}Vr.propTypes=$r,Vr.defaultProps=Br;var qr=n(function(e,t){t.__esModule=!0,t.default=function(e){return e&&e.ownerDocument||document},e.exports=t.default}),zr=t(qr),Gr=n(function(e,t){t.__esModule=!0,t.default=function(e){void 0===e&&(e=(0,n.default)());try{return e.activeElement}catch(e){}};var n=wr(qr);e.exports=t.default}),Yr=t(Gr),Xr=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=wr(Mr).default?function(e,t){return e.contains?e.contains(t):e.compareDocumentPosition?e===t||!!(16&e.compareDocumentPosition(t)):o(e,t)}:o;function o(e,t){if(t)do{if(t===e)return!0}while(t=t.parentNode);return!1}t.default=n,e.exports=t.default}),Jr=t(Xr),Zr=n(function(e,t){function n(e){if(e&&"object"==typeof e){var t=e.which||e.keyCode||e.charCode;t&&(e=t)}if("number"==typeof e)return a[e];var n,o=String(e);return(n=r[o.toLowerCase()])?n:(n=i[o.toLowerCase()])||(1===o.length?o.charCodeAt(0):void 0)}n.isEventKey=function(e,t){if(e&&"object"==typeof e){var n=e.which||e.keyCode||e.charCode;if(null==n)return!1;if("string"==typeof t){var o;if(o=r[t.toLowerCase()])return o===n;if(o=i[t.toLowerCase()])return o===n}else if("number"==typeof t)return t===n;return!1}};var r=(t=e.exports=n).code=t.codes={backspace:8,tab:9,enter:13,shift:16,ctrl:17,alt:18,"pause/break":19,"caps lock":20,esc:27,space:32,"page up":33,"page down":34,end:35,home:36,left:37,up:38,right:39,down:40,insert:45,delete:46,command:91,"left command":91,"right command":93,"numpad *":106,"numpad +":107,"numpad -":109,"numpad .":110,"numpad /":111,"num lock":144,"scroll lock":145,"my computer":182,"my calculator":183,";":186,"=":187,",":188,"-":189,".":190,"/":191,"`":192,"[":219,"\\":220,"]":221,"'":222},i=t.aliases={windows:91,"⇧":16,"⌥":18,"⌃":17,"⌘":91,ctl:17,control:17,option:18,pause:19,break:19,caps:20,return:13,escape:27,spc:32,spacebar:32,pgup:33,pgdn:34,ins:45,del:46,cmd:91};for(o=97;o<123;o++)r[String.fromCharCode(o)]=o-32;for(var o=48;o<58;o++)r[o-48]=o;for(o=1;o<13;o++)r["f"+o]=o+111;for(o=0;o<10;o++)r["numpad "+o]=o+96;var a=t.names=t.title={};for(o in r)a[r[o]]=o;for(var s in i)r[s]=i[s]}),Qr=(Zr.code,Zr.codes,Zr.aliases,Zr.names,Zr.title,t(n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(u){return function(e,t,n,o,r){var i=n||"<<anonymous>>",a=r||t;if(null==e[t])return new Error("The "+o+" `"+a+"` is required to make `"+i+"` accessible for users of assistive technologies such as screen readers.");for(var s=arguments.length,l=Array(5<s?s-5:0),c=5;c<s;c++)l[c-5]=arguments[c];return u.apply(void 0,[e,t,n,o,r].concat(l))}},e.exports=t.default}))),ei=n(function(e,t){t.__esModule=!0,t.version=void 0,t.uncontrolledPropTypes=function(e,t,o){var n={};"production"!=="production"&&t&&c(e,function(e,t,n){(0,r.default)("string"==typeof t&&t.trim().length,"Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable",o,n),e[n]=function(n,o){return function(e,t){if(void 0!==e[t]&&!e[n])return new Error("You have provided a `"+t+"` prop to `"+o+"` without an `"+n+"` handler. This will render a read-only field. If the field should be mutable use `"+l(t)+"`. Otherwise, set `"+n+"`")}}(t,o)},n);return n},t.getType=function(e){return 15<=i[0]||0===i[0]&&13<=i[1]?e:e.type},t.getValue=function(e,t){var n=s(t);return n&&!a(e,t)&&a(e,n)?e[n].value:e[t]},t.getLinkName=s,t.defaultKey=l,t.chain=function(o,r,i){return function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];r&&r.call.apply(r,[o].concat(t)),i&&i.call.apply(i,[o].concat(t))}},t.transform=c,t.each=u,t.has=p,t.isReactComponent=function(e){return!!(e&&e.prototype&&e.prototype.isReactComponent)};var n=o(P),r=o(pn);function o(e){return e&&e.__esModule?e:{default:e}}var i=t.version=n.default.version.split(".").map(parseFloat);function a(e,t){return void 0!==e[t]}function s(e){return"value"===e?"valueLink":"checked"===e?"checkedLink":null}function l(e){return"default"+e.charAt(0).toUpperCase()+e.substr(1)}function c(e,t,n){return u(e,t.bind(null,n=n||(Array.isArray(e)?[]:{}))),n}function u(e,t,n){if(Array.isArray(e))return e.forEach(t,n);for(var o in e)p(e,o)&&t.call(n,e[o],o,e)}function p(e,t){return!!e&&Object.prototype.hasOwnProperty.call(e,t)}});t(ei);ei.version,ei.uncontrolledPropTypes,ei.getType,ei.getValue,ei.getLinkName,ei.defaultKey,ei.chain,ei.transform,ei.each,ei.has,ei.isReactComponent;var ti=n(function(e,t){t.__esModule=!0;var b=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e};t.default=function(v,y){return function o(n,s){var e,t;var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:[];var i,a=n.displayName||n.name||"Component",l=C.getType(n).propTypes,c=C.isReactComponent(n),u=Object.keys(s);var p=["valueLink","checkedLink"].concat(u.map(C.defaultKey));i=C.uncontrolledPropTypes(s,l,a);(0,E.default)(c||!r.length,"[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: "+a+", attempting to pass through methods: "+r.join(", "));r=C.transform(r,function(e,t){e[t]=function(){var e;return(e=this.refs.inner)[t].apply(e,arguments)}},{});var d=(t=e=function(e){function t(){return N(this,t),O(this,e.apply(this,arguments))}return w(t,e),t.prototype.shouldComponentUpdate=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return!v.shouldComponentUpdate||v.shouldComponentUpdate.apply(this,t)},t.prototype.componentWillMount=function(){var t=this,n=this.props;this._values={},u.forEach(function(e){t._values[e]=n[C.defaultKey(e)]})},t.prototype.componentWillReceiveProps=function(t){var n=this,o=this.props;v.componentWillReceiveProps&&v.componentWillReceiveProps.call(this,t),u.forEach(function(e){void 0===C.getValue(t,e)&&void 0!==C.getValue(o,e)&&(n._values[e]=t[C.defaultKey(e)])})},t.prototype.componentWillUnmount=function(){this.unmounted=!0},t.prototype.getControlledInstance=function(){return this.refs.inner},t.prototype.render=function(){var r=this,i={},e=m(this.props);return C.each(s,function(e,t){var n=C.getLinkName(t),o=r.props[t];n&&!h(r.props,t)&&h(r.props,n)&&(o=r.props[n].value),i[t]=void 0!==o?o:r._values[t],i[e]=f.bind(r,t)}),i=b({},e,i,{ref:c?"inner":null}),g.default.createElement(n,i)},t}(g.default.Component),e.displayName="Uncontrolled("+a+")",e.propTypes=i,t);b(d.prototype,r);d.ControlledComponent=n;d.deferControlTo=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},n=arguments[2];return o(e,b({},s,t),n)};return d;function f(e,t){var n=C.getLinkName(e),o=this.props[s[e]];n&&h(this.props,n)&&!o&&(o=this.props[n].requestChange);for(var r=arguments.length,i=Array(2<r?r-2:0),a=2;a<r;a++)i[a-2]=arguments[a];y(this,e,o,t,i)}function h(e,t){return void 0!==e[t]}function m(e){var n={};return C.each(e,function(e,t){-1===p.indexOf(t)&&(n[t]=e)}),n}}};var g=n(P),E=n(pn),C=function(e){{if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}}(ei);function n(e){return e&&e.__esModule?e:{default:e}}function N(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function O(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function w(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}e.exports=t.default});t(ti);function ni(t,e,n,o){try{return o?e(h(n)[0],n[1]):e(n)}catch(e){var r=t.return;throw void 0!==r&&h(r.call(t)),e}}function oi(e,t,n){t in e?R.f(e,t,g(0,n)):e[t]=n}var ri=t(n(function(e,t){t.__esModule=!0;var n,o=(n=ti)&&n.__esModule?n:{default:n};t.default=(0,o.default)({shouldComponentUpdate:function(){return!this._notifying}},function(e,t,n,o,r){n&&(e._notifying=!0,n.call.apply(n,[e,o].concat(r)),e._notifying=!1),e._values[t]=o,e.unmounted||e.forceUpdate()}),e.exports=t.default})),ii=Pe("iterator"),ai=Array.prototype,si=Pe("toStringTag"),li="Arguments"==F(function(){return arguments}()),ci=Pe("iterator"),ui=N.getIteratorMethod=function(e){if(null!=e)return e[ci]||e["@@iterator"]||Ce[function(e){var t,n,o;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t]}catch(e){}}(t=Object(e),si))?n:li?F(t):"Object"==(o=F(t))&&"function"==typeof t.callee?"Arguments":o}(e)]},pi=Pe("iterator"),di=!1;try{var fi=[7][pi]();fi.return=function(){di=!0},Array.from(fi,function(){throw 2})}catch(e){}z(z.S+z.F*!function(e,t){if(!t&&!di)return!1;var n=!1;try{var o=[7],r=o[pi]();r.next=function(){return{done:n=!0}},o[pi]=function(){return r},e(o)}catch(e){}return n}(function(e){Array.from(e)}),"Array",{from:function(e,t,n){var o,r,i,a,s=W(e),l="function"==typeof this?this:Array,c=arguments.length,u=1<c?t:void 0,p=void 0!==u,d=0,f=ui(s);if(p&&(u=m(u,2<c?n:void 0,2)),null==f||l==Array&&function(e){return void 0!==e&&(Ce.Array===e||ai[ii]===e)}(f))for(r=new l(o=U(s.length));d<o;d++)oi(r,d,p?u(s[d],d):s[d]);else for(a=f.call(s),r=new l;!(i=a.next()).done;d++)oi(r,d,p?ni(a,u,[i.value,d],!0):i.value);return r.length=d,r}});var hi=N.Array.from,mi=t(n(function(e){e.exports={default:hi,__esModule:!0}})),vi=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=function(){};wr(Mr).default&&(n=document.addEventListener?function(e,t,n,o){return e.removeEventListener(t,n,o||!1)}:document.attachEvent?function(e,t,n){return e.detachEvent("on"+t,n)}:void 0);var o=n;t.default=o,e.exports=t.default});t(vi);var yi=n(function(e,t){t.__esModule=!0,t.default=function(e,t,n,o){return(0,r.default)(e,t,n,o),{remove:function(){(0,i.default)(e,t,n,o)}}};var r=n(Fr),i=n(vi);function n(e){return e&&e.__esModule?e:{default:e}}e.exports=t.default});t(yi);var bi=n(function(e,t){t.__esModule=!0,t.default=function(e){return(0,o.default)(n.default.findDOMNode(e))};var n=r(S),o=r(qr);function r(e){return e&&e.__esModule?e:{default:e}}e.exports=t.default});t(bi);var gi,Ei=n(function(e,t){t.__esModule=!0;var o=l(Xr),n=l(T),r=l(P),i=l(S),a=l(yi),s=l(bi);function l(e){return e&&e.__esModule?e:{default:e}}var c,u=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(p,c=r.default.Component),p.prototype.componentDidMount=function(){this.props.disabled||this.addEventListeners()},p.prototype.componentDidUpdate=function(e){!this.props.disabled&&e.disabled?this.addEventListeners():this.props.disabled&&!e.disabled&&this.removeEventListeners()},p.prototype.componentWillUnmount=function(){this.props.disabled||this.removeEventListeners()},p.prototype.render=function(){return this.props.children},p);function p(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,p);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,c.call(this,e,t));return n.addEventListeners=function(){var e=n.props.event,t=(0,s.default)(n);n.documentMouseCaptureListener=(0,a.default)(t,e,n.handleMouseCapture,!0),n.documentMouseListener=(0,a.default)(t,e,n.handleMouse),n.documentKeyupListener=(0,a.default)(t,"keyup",n.handleKeyUp)},n.removeEventListeners=function(){n.documentMouseCaptureListener&&n.documentMouseCaptureListener.remove(),n.documentMouseListener&&n.documentMouseListener.remove(),n.documentKeyupListener&&n.documentKeyupListener.remove()},n.handleMouseCapture=function(e){n.preventMouseRootClose=function(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}(e)||!function(e){return 0===e.button}(e)||(0,o.default)(i.default.findDOMNode(n),e.target)},n.handleMouse=function(e){!n.preventMouseRootClose&&n.props.onRootClose&&n.props.onRootClose(e)},n.handleKeyUp=function(e){27===e.keyCode&&n.props.onRootClose&&n.props.onRootClose(e)},n.preventMouseRootClose=!1,n}u.displayName="RootCloseWrapper",u.propTypes={onRootClose:n.default.func,children:n.default.element,disabled:n.default.bool,event:n.default.oneOf(["click","mousedown"])},u.defaultProps={event:"click"},t.default=u,e.exports=t.default}),Ci=t(Ei),Ni={open:T.bool,pullRight:T.bool,onClose:T.func,labelledBy:T.oneOfType([T.string,T.number]),onSelect:T.func,rootCloseEvent:T.oneOf(["click","mousedown"])},Oi=(gi=P.Component,nn(wi,gi),wi.prototype.getFocusableMenuItems=function(){var e=S.findDOMNode(this);return e?mi(e.querySelectorAll('[tabIndex="-1"]')):[]},wi.prototype.getItemsAndActiveIndex=function(){var e=this.getFocusableMenuItems(),t=e.indexOf(document.activeElement);return{items:e,activeIndex:t}},wi.prototype.focusNext=function(){var e=this.getItemsAndActiveIndex(),t=e.items,n=e.activeIndex;0!==t.length&&t[n===t.length-1?0:n+1].focus()},wi.prototype.focusPrevious=function(){var e=this.getItemsAndActiveIndex(),t=e.items,n=e.activeIndex;0!==t.length&&t[0===n?t.length-1:n-1].focus()},wi.prototype.handleKeyDown=function(e){switch(e.keyCode){case Zr.codes.down:this.focusNext(),e.preventDefault();break;case Zr.codes.up:this.focusPrevious(),e.preventDefault();break;case Zr.codes.esc:case Zr.codes.tab:this.props.onClose(e,{source:"keydown"})}},wi.prototype.handleRootClose=function(e){this.props.onClose(e,{source:"rootClose"})},wi.prototype.render=function(){var e,t=this,n=this.props,o=n.open,r=n.pullRight,i=n.labelledBy,a=n.onSelect,s=n.className,l=n.rootCloseEvent,c=n.children,u=Mn(on(n,["open","pullRight","labelledBy","onSelect","className","rootCloseEvent","children"]),["onClose"]),p=u[0],d=u[1],f=be({},Tn(p),((e={})[On(p,"right")]=r,e));return P.createElement(Ci,{disabled:!o,onRootClose:this.handleRootClose,event:l},P.createElement("ul",be({},d,{role:"menu",className:rn(s,f),"aria-labelledby":i}),In.map(c,function(e){return P.cloneElement(e,{onKeyDown:Rn(e.props.onKeyDown,t.handleKeyDown),onSelect:Rn(e.props.onSelect,a)})})))},wi);function wi(e){ge(this,wi);var t=Gt(this,gi.call(this,e));return t.handleRootClose=t.handleRootClose.bind(t),t.handleKeyDown=t.handleKeyDown.bind(t),t}Oi.propTypes=Ni,Oi.defaultProps={bsRole:"menu",pullRight:!1};var xi,_i=wn("dropdown-menu",Oi),Ti={noCaret:T.bool,open:T.bool,title:T.string,useAnchor:T.bool},Si=(xi=P.Component,nn(Pi,xi),Pi.prototype.render=function(){var e=this.props,t=e.noCaret,n=e.open,o=e.useAnchor,r=e.bsClass,i=e.className,a=e.children,s=on(e,["noCaret","open","useAnchor","bsClass","className","children"]);delete s.bsRole;var l=o?fo:To,c=!t;return P.createElement(l,be({},s,{role:"button",className:rn(i,r),"aria-haspopup":!0,"aria-expanded":n}),a||s.title,c&&" ",c&&P.createElement("span",{className:"caret"}))},Pi);function Pi(){return ge(this,Pi),Gt(this,xi.apply(this,arguments))}Si.propTypes=Ti,Si.defaultProps={open:!1,useAnchor:!1,bsRole:"toggle"};var ki=wn("dropdown-toggle",Si);var Mi,Ri=ki.defaultProps.bsRole,Ai=_i.defaultProps.bsRole,Ii={dropup:T.bool,id:Qr(T.oneOfType([T.string,T.number])),componentClass:lo,children:So(function(){for(var e=arguments.length,r=Array(e),t=0;t<e;t++)r[t]=arguments[t];return ao(function(e,t,n){var o=void 0;return r.every(function(t){return!!In.some(e.children,function(e){return e.props.bsRole===t})||(o=t,!1)}),o?new Error("(children) "+n+" - Missing a required child with bsRole: "+o+". "+n+" must have at least one child of each of the following bsRoles: "+r.join(", ")):null})}(Ri,Ai),function(){for(var e=arguments.length,r=Array(e),t=0;t<e;t++)r[t]=arguments[t];return ao(function(e,t,n){var o=void 0;return r.every(function(t){return!(1<In.filter(e.children,function(e){return e.props.bsRole===t}).length)||(o=t,!1)}),o?new Error("(children) "+n+" - Duplicate children detected of bsRole: "+o+". Only one child each allowed with the following bsRoles: "+r.join(", ")):null})}(Ai)),disabled:T.bool,pullRight:T.bool,open:T.bool,defaultOpen:T.bool,onToggle:T.func,onSelect:T.func,role:T.string,rootCloseEvent:T.oneOf(["click","mousedown"]),onMouseEnter:T.func,onMouseLeave:T.func},Di={componentClass:Ao},Li=(Mi=P.Component,nn(Fi,Mi),Fi.prototype.componentDidMount=function(){this.focusNextOnOpen()},Fi.prototype.componentWillUpdate=function(e){!e.open&&this.props.open&&(this._focusInDropdown=Jr(S.findDOMNode(this.menu),Yr(document)))},Fi.prototype.componentDidUpdate=function(e){var t=this.props.open,n=e.open;t&&!n&&this.focusNextOnOpen(),!t&&n&&this._focusInDropdown&&(this._focusInDropdown=!1,this.focus())},Fi.prototype.focus=function(){var e=S.findDOMNode(this.toggle);e&&e.focus&&e.focus()},Fi.prototype.focusNextOnOpen=function(){var e=this.menu;e.focusNext&&("keydown"!==this.lastOpenEventType&&"menuitem"!==this.props.role||e.focusNext())},Fi.prototype.handleClick=function(e){this.props.disabled||this.toggleOpen(e,{source:"click"})},Fi.prototype.handleClose=function(e,t){this.props.open&&this.toggleOpen(e,t)},Fi.prototype.handleKeyDown=function(e){if(!this.props.disabled)switch(e.keyCode){case Zr.codes.down:this.props.open?this.menu.focusNext&&this.menu.focusNext():this.toggleOpen(e,{source:"keydown"}),e.preventDefault();break;case Zr.codes.esc:case Zr.codes.tab:this.handleClose(e,{source:"keydown"})}},Fi.prototype.toggleOpen=function(e,t){var n=!this.props.open;n&&(this.lastOpenEventType=t.source),this.props.onToggle&&this.props.onToggle(n,e,t)},Fi.prototype.renderMenu=function(e,t){var n=this,o=t.id,r=t.onSelect,i=t.rootCloseEvent,a=on(t,["id","onSelect","rootCloseEvent"]),s=function(e){n.menu=e};return"string"==typeof e.ref?"production"!=="production"&&ar(!1,"String refs are not supported on `<Dropdown.Menu>` components. To apply a ref to the component use the callback signature:\n\n https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute"):s=Rn(e.ref,s),_.cloneElement(e,be({},a,{ref:s,labelledBy:o,bsClass:On(a,"menu"),onClose:Rn(e.props.onClose,this.handleClose),onSelect:Rn(e.props.onSelect,r,function(e,t){return n.handleClose(t,{source:"select"})}),rootCloseEvent:i}))},Fi.prototype.renderToggle=function(e,t){var n=this,o=function(e){n.toggle=e};return"string"==typeof e.ref?"production"!=="production"&&ar(!1,"String refs are not supported on `<Dropdown.Toggle>` components. To apply a ref to the component use the callback signature:\n\n https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute"):o=Rn(e.ref,o),_.cloneElement(e,be({},t,{ref:o,bsClass:On(t,"toggle"),onClick:Rn(e.props.onClick,this.handleClick),onKeyDown:Rn(e.props.onKeyDown,this.handleKeyDown)}))},Fi.prototype.render=function(){var e,t=this,n=this.props,o=n.componentClass,r=n.id,i=n.dropup,a=n.disabled,s=n.pullRight,l=n.open,c=n.onSelect,u=n.role,p=n.bsClass,d=n.className,f=n.rootCloseEvent,h=n.children,m=on(n,["componentClass","id","dropup","disabled","pullRight","open","onSelect","role","bsClass","className","rootCloseEvent","children"]);delete m.onToggle;var v=((e={})[p]=!0,e.open=l,e.disabled=a,e);return i&&(v[p]=!1,v.dropup=!0),P.createElement(o,be({},m,{className:rn(d,v)}),In.map(h,function(e){switch(e.props.bsRole){case Ri:return t.renderToggle(e,{id:r,disabled:a,open:l,role:u,bsClass:p});case Ai:return t.renderMenu(e,{id:r,open:l,pullRight:s,bsClass:p,onSelect:c,rootCloseEvent:f});default:return e}}))},Fi);function Fi(e,t){ge(this,Fi);var n=Gt(this,Mi.call(this,e,t));return n.handleClick=n.handleClick.bind(n),n.handleKeyDown=n.handleKeyDown.bind(n),n.handleClose=n.handleClose.bind(n),n._focusInDropdown=!1,n.lastOpenEventType=null,n}Li.propTypes=Ii,Li.defaultProps=Di,wn("dropdown",Li);var ji=ri(Li,{open:"onToggle"});function Ki(e,t){var o=t.propTypes,r={},i={};return cn(e).forEach(function(e){var t=e[0],n=e[1];o[t]?r[t]=n:i[t]=n}),[r,i]}ji.Toggle=ki,ji.Menu=_i;var Hi,Ui=be({},ji.propTypes,{bsStyle:T.string,bsSize:T.string,title:T.node.isRequired,noCaret:T.bool,children:T.node});function $i(){return ge(this,$i),Gt(this,Hi.apply(this,arguments))}(Hi=P.Component,nn($i,Hi),$i.prototype.render=function(){var e=this.props,t=e.bsSize,n=e.bsStyle,o=e.title,r=e.children,i=Ki(on(e,["bsSize","bsStyle","title","children"]),ji.ControlledComponent),a=i[0],s=i[1];return P.createElement(ji,be({},a,{bsSize:t,bsStyle:n}),P.createElement(ji.Toggle,be({},s,{bsSize:t,bsStyle:n}),o),P.createElement(ji.Menu,null,r))},$i).propTypes=Ui;var Bi,Vi={in:T.bool,mountOnEnter:T.bool,unmountOnExit:T.bool,transitionAppear:T.bool,timeout:T.number,onEnter:T.func,onEntering:T.func,onEntered:T.func,onExit:T.func,onExiting:T.func,onExited:T.func},Wi=(Bi=P.Component,nn(qi,Bi),qi.prototype.render=function(){return P.createElement(Kr,be({},this.props,{className:rn(this.props.className,"fade"),enteredClassName:"in",enteringClassName:"in"}))},qi);function qi(){return ge(this,qi),Gt(this,Bi.apply(this,arguments))}Wi.propTypes=Vi,Wi.defaultProps={in:!1,timeout:300,mountOnEnter:!1,unmountOnExit:!1,transitionAppear:!1};var zi,Gi={horizontal:T.bool,inline:T.bool,componentClass:lo},Yi=(zi=P.Component,nn(Xi,zi),Xi.prototype.render=function(){var e=this.props,t=e.horizontal,n=e.inline,o=e.componentClass,r=e.className,i=kn(on(e,["horizontal","inline","componentClass","className"])),a=i[0],s=i[1],l=[];return t&&l.push(On(a,"horizontal")),n&&l.push(On(a,"inline")),P.createElement(o,be({},s,{className:rn(r,l)}))},Xi);function Xi(){return ge(this,Xi),Gt(this,zi.apply(this,arguments))}Yi.propTypes=Gi,Yi.defaultProps={horizontal:!1,inline:!1,componentClass:"form"},wn("form",Yi);var Ji,Zi={$bs_formGroup:T.object},Qi=(Ji=P.Component,nn(ea,Ji),ea.prototype.getGlyph=function(e){switch(e){case"success":return"ok";case"warning":return"warning-sign";case"error":return"remove";default:return null}},ea.prototype.renderDefaultFeedback=function(e,t,n,o){var r=this.getGlyph(e&&e.validationState);return r?P.createElement(Qo,be({},o,{glyph:r,className:rn(t,n)})):null},ea.prototype.render=function(){var e=this.props,t=e.className,n=e.children,o=kn(on(e,["className","children"])),r=o[0],i=o[1],a=Tn(r);if(!n)return this.renderDefaultFeedback(this.context.$bs_formGroup,t,a,i);var s=P.Children.only(n);return P.cloneElement(s,be({},i,{className:rn(s.props.className,t,a)}))},ea);function ea(){return ge(this,ea),Gt(this,Ji.apply(this,arguments))}Qi.defaultProps={bsRole:"feedback"},Qi.contextTypes=Zi;var ta,na=wn("form-control-feedback",Qi),oa={componentClass:lo},ra=(ta=P.Component,nn(ia,ta),ia.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},ia);function ia(){return ge(this,ia),Gt(this,ta.apply(this,arguments))}ra.propTypes=oa,ra.defaultProps={componentClass:"p"};var aa,sa=wn("form-control-static",ra),la={componentClass:lo,type:T.string,id:T.string,inputRef:T.func},ca={$bs_formGroup:T.object},ua=(aa=P.Component,nn(pa,aa),pa.prototype.render=function(){var e=this.context.$bs_formGroup,t=e&&e.controlId,n=this.props,o=n.componentClass,r=n.type,i=n.id,a=void 0===i?t:i,s=n.inputRef,l=n.className,c=n.bsSize,u=kn(on(n,["componentClass","type","id","inputRef","className","bsSize"])),p=u[0],d=u[1];"production"!=="production"&&ar(null==t||a===t,"`controlId` is ignored on `<FormControl>` when `id` is specified.");var f=void 0;return"file"!==r&&(f=Tn(p)),c&&(f[On({bsClass:"input"},mn[c]||c)]=!0),P.createElement(o,be({},d,{type:r,id:a,ref:s,className:rn(l,f)}))},pa);function pa(){return ge(this,pa),Gt(this,aa.apply(this,arguments))}ua.propTypes=la,ua.defaultProps={componentClass:"input"},ua.contextTypes=ca,ua.Feedback=na,ua.Static=sa,wn("form-control",_n([fn,dn],ua));var da,fa={controlId:T.string,validationState:T.oneOf(["success","warning","error",null])},ha={$bs_formGroup:T.object.isRequired},ma=(da=P.Component,nn(va,da),va.prototype.getChildContext=function(){var e=this.props;return{$bs_formGroup:{controlId:e.controlId,validationState:e.validationState}}},va.prototype.hasFeedback=function(e){var t=this;return In.some(e,function(e){return"feedback"===e.props.bsRole||e.props.children&&t.hasFeedback(e.props.children)})},va.prototype.render=function(){var e=this.props,t=e.validationState,n=e.className,o=e.children,r=Mn(on(e,["validationState","className","children"]),["controlId"]),i=r[0],a=r[1],s=be({},Tn(i),{"has-feedback":this.hasFeedback(o)});return t&&(s["has-"+t]=!0),P.createElement("div",be({},a,{className:rn(n,s)}),o)},va);function va(){return ge(this,va),Gt(this,da.apply(this,arguments))}ma.propTypes=fa,ma.childContextTypes=ha,wn("form-group",_n([dn,fn],ma));var ya,ba={fluid:T.bool,componentClass:lo},ga=(ya=P.Component,nn(Ea,ya),Ea.prototype.render=function(){var e=this.props,t=e.fluid,n=e.componentClass,o=e.className,r=kn(on(e,["fluid","componentClass","className"])),i=r[0],a=r[1],s=On(i,t&&"fluid");return P.createElement(n,be({},a,{className:rn(o,s)}))},Ea);function Ea(){return ge(this,Ea),Gt(this,ya.apply(this,arguments))}ga.propTypes=ba,ga.defaultProps={componentClass:"div",fluid:!1};var Ca,Na=wn("container",ga);function Oa(){return ge(this,Oa),Gt(this,Ca.apply(this,arguments))}wn("help-block",(Ca=P.Component,nn(Oa,Ca),Oa.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("span",be({},r,{className:rn(t,i)}))},Oa));var wa,xa,_a={responsive:T.bool,rounded:T.bool,circle:T.bool,thumbnail:T.bool},Ta=(wa=P.Component,nn(Sa,wa),Sa.prototype.render=function(){var e,t=this.props,n=t.responsive,o=t.rounded,r=t.circle,i=t.thumbnail,a=t.className,s=kn(on(t,["responsive","rounded","circle","thumbnail","className"])),l=s[0],c=s[1],u=((e={})[On(l,"responsive")]=n,e[On(l,"rounded")]=o,e[On(l,"circle")]=r,e[On(l,"thumbnail")]=i,e);return P.createElement("img",be({},c,{className:rn(a,u)}))},Sa);function Sa(){return ge(this,Sa),Gt(this,wa.apply(this,arguments))}function Pa(){return ge(this,Pa),Gt(this,xa.apply(this,arguments))}Ta.propTypes=_a,Ta.defaultProps={responsive:!1,rounded:!1,circle:!1,thumbnail:!1},wn("img",Ta);var ka,Ma=wn("input-group-addon",(xa=P.Component,nn(Pa,xa),Pa.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("span",be({},r,{className:rn(t,i)}))},Pa));function Ra(){return ge(this,Ra),Gt(this,ka.apply(this,arguments))}var Aa,Ia=wn("input-group-btn",(ka=P.Component,nn(Ra,ka),Ra.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("span",be({},r,{className:rn(t,i)}))},Ra)),Da=(Aa=P.Component,nn(La,Aa),La.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("span",be({},r,{className:rn(t,i)}))},La);function La(){return ge(this,La),Gt(this,Aa.apply(this,arguments))}Da.Addon=Ma,Da.Button=Ia,wn("input-group",_n([dn,fn],Da));var Fa,ja={componentClass:lo},Ka=(Fa=P.Component,nn(Ha,Fa),Ha.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},Ha);function Ha(){return ge(this,Ha),Gt(this,Fa.apply(this,arguments))}Ka.propTypes=ja,Ka.defaultProps={componentClass:"div"},wn("jumbotron",Ka);var Ua,$a=(Ua=P.Component,nn(Ba,Ua),Ba.prototype.hasContent=function(e){var t=!1;return P.Children.forEach(e,function(e){t||!e&&0!==e||(t=!0)}),t},Ba.prototype.render=function(){var e=this.props,t=e.className,n=e.children,o=kn(on(e,["className","children"])),r=o[0],i=o[1],a=be({},Tn(r),{hidden:!this.hasContent(n)});return P.createElement("span",be({},i,{className:rn(t,a)}),n)},Ba);function Ba(){return ge(this,Ba),Gt(this,Ua.apply(this,arguments))}wn("label",xn([].concat(Vn(yn),[bn,gn]),bn,$a));var Va,Wa={active:T.any,disabled:T.any,header:T.node,listItem:T.bool,onClick:T.func,href:T.string,type:T.string},qa=(Va=P.Component,nn(za,Va),za.prototype.renderHeader=function(e,t){return P.isValidElement(e)?_.cloneElement(e,{className:rn(e.props.className,t)}):P.createElement("h4",{className:t},e)},za.prototype.render=function(){var e=this.props,t=e.active,n=e.disabled,o=e.className,r=e.header,i=e.listItem,a=e.children,s=kn(on(e,["active","disabled","className","header","listItem","children"])),l=s[0],c=s[1],u=be({},Tn(l),{active:t,disabled:n}),p=void 0;return c.href?p="a":c.onClick?(p="button",c.type=c.type||"button"):p=i?"li":"span",c.className=rn(o,u),r?P.createElement(p,c,this.renderHeader(r,On(l,"heading")),P.createElement("p",{className:On(l,"text")},a)):P.createElement(p,c,a)},za);function za(){return ge(this,za),Gt(this,Va.apply(this,arguments))}qa.propTypes=Wa,qa.defaultProps={listItem:!1};var Ga=wn("list-group-item",xn(Vn(yn),qa)),Ya={componentClass:lo};var Xa,Ja=(Xa=P.Component,nn(Za,Xa),Za.prototype.render=function(){var e=this.props,t=e.children,n=e.componentClass,o=void 0===n?function(e){return e?In.some(e,function(e){return e.type!==Ga||e.props.href||e.props.onClick})?"div":"ul":"div"}(t):n,r=e.className,i=kn(on(e,["children","componentClass","className"])),a=i[0],s=i[1],l=Tn(a),c="ul"===o&&In.every(t,function(e){return e.type===Ga});return P.createElement(o,be({},s,{className:rn(r,l)}),c?In.map(t,function(e){return _.cloneElement(e,{listItem:!0})}):t)},Za);function Za(){return ge(this,Za),Gt(this,Xa.apply(this,arguments))}Ja.propTypes=Ya,wn("list-group",Ja);var Qa,es={align:T.oneOf(["top","middle","bottom"]),componentClass:lo},ts=(Qa=P.Component,nn(ns,Qa),ns.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.align,o=e.className,r=kn(on(e,["componentClass","align","className"])),i=r[0],a=r[1],s=Tn(i);return n&&(s[On(ks.defaultProps,n)]=!0),P.createElement(t,be({},a,{className:rn(o,s)}))},ns);function ns(){return ge(this,ns),Gt(this,Qa.apply(this,arguments))}ts.propTypes=es,ts.defaultProps={componentClass:"div"};var os,rs=wn("media-body",ts),is={componentClass:lo},as=(os=P.Component,nn(ss,os),ss.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},ss);function ss(){return ge(this,ss),Gt(this,os.apply(this,arguments))}as.propTypes=is,as.defaultProps={componentClass:"h4"};var ls,cs=wn("media-heading",as),us={align:T.oneOf(["top","middle","bottom"])},ps=(ls=P.Component,nn(ds,ls),ds.prototype.render=function(){var e=this.props,t=e.align,n=e.className,o=kn(on(e,["align","className"])),r=o[0],i=o[1],a=Tn(r);return t&&(a[On(ks.defaultProps,t)]=!0),P.createElement("div",be({},i,{className:rn(n,a)}))},ds);function ds(){return ge(this,ds),Gt(this,ls.apply(this,arguments))}ps.propTypes=us;var fs,hs=wn("media-left",ps);function ms(){return ge(this,ms),Gt(this,fs.apply(this,arguments))}var vs,ys=wn("media-list",(fs=P.Component,nn(ms,fs),ms.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("ul",be({},r,{className:rn(t,i)}))},ms));function bs(){return ge(this,bs),Gt(this,vs.apply(this,arguments))}var gs,Es=wn("media",(vs=P.Component,nn(bs,vs),bs.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("li",be({},r,{className:rn(t,i)}))},bs)),Cs={align:T.oneOf(["top","middle","bottom"])},Ns=(gs=P.Component,nn(Os,gs),Os.prototype.render=function(){var e=this.props,t=e.align,n=e.className,o=kn(on(e,["align","className"])),r=o[0],i=o[1],a=Tn(r);return t&&(a[On(ks.defaultProps,t)]=!0),P.createElement("div",be({},i,{className:rn(n,a)}))},Os);function Os(){return ge(this,Os),Gt(this,gs.apply(this,arguments))}Ns.propTypes=Cs;var ws,xs=wn("media-right",Ns),_s={componentClass:lo},Ts=(ws=P.Component,nn(Ss,ws),Ss.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},Ss);function Ss(){return ge(this,Ss),Gt(this,ws.apply(this,arguments))}Ts.propTypes=_s,Ts.defaultProps={componentClass:"div"},Ts.Heading=cs,Ts.Body=rs,Ts.Left=hs,Ts.Right=xs,Ts.List=ys,Ts.ListItem=Es;var Ps,ks=wn("media",Ts),Ms={active:T.bool,disabled:T.bool,divider:So(T.bool,function(e){var t=e.divider,n=e.children;return t&&n?new Error("Children will not be rendered for dividers"):null}),eventKey:T.any,header:T.bool,href:T.string,onClick:T.func,onSelect:T.func},Rs=(Ps=P.Component,nn(As,Ps),As.prototype.handleClick=function(e){var t=this.props,n=t.href,o=t.disabled,r=t.onSelect,i=t.eventKey;n&&!o||e.preventDefault(),o||r&&r(i,e)},As.prototype.render=function(){var e=this.props,t=e.active,n=e.disabled,o=e.divider,r=e.header,i=e.onClick,a=e.className,s=e.style,l=Mn(on(e,["active","disabled","divider","header","onClick","className","style"]),["eventKey","onSelect"]),c=l[0],u=l[1];return o?(u.children=void 0,P.createElement("li",be({},u,{role:"separator",className:rn(a,"divider"),style:s}))):r?P.createElement("li",be({},u,{role:"heading",className:rn(a,On(c,"header")),style:s})):P.createElement("li",{role:"presentation",className:rn(a,{active:t,disabled:n}),style:s},P.createElement(fo,be({},u,{role:"menuitem",tabIndex:"-1",onClick:Rn(i,this.handleClick)})))},As);function As(e,t){ge(this,As);var n=Gt(this,Ps.call(this,e,t));return n.handleClick=n.handleClick.bind(n),n}Rs.propTypes=Ms,Rs.defaultProps={divider:!1,disabled:!1,header:!1},wn("dropdown",Rs);var Is=n(function(e,t){t.__esModule=!0,t.default=function(e,t){var n,o="#"===t[0],r="."===t[0],i=o||r?t.slice(1):t;if(a.test(i))return o?(e=e.getElementById?e:document,(n=e.getElementById(i))?[n]:[]):e.getElementsByClassName&&r?s(e.getElementsByClassName(i)):s(e.getElementsByTagName(t));return s(e.querySelectorAll(t))};var a=/^[\w-]*$/,s=Function.prototype.bind.call(Function.prototype.call,[].slice);e.exports=t.default});t(Is);var Ds=n(function(e,t){t.__esModule=!0,t.default=function(o,r){return function(e){var t=e.currentTarget,n=e.target;(0,a.default)(t,o).some(function(e){return(0,i.default)(e,n)})&&r.call(this,e)}};var i=wr(Xr),a=wr(Is);e.exports=t.default});t(Ds);var Ls=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=wr(Mr),r=wr(Fr),i=wr(vi),o=function(){};n.default&&(o=function(e,t,n,o){return(0,r.default)(e,t,n,o),function(){(0,i.default)(e,t,n,o)}});var a=o;t.default=a,e.exports=t.default});t(Ls);var Fs=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=wr(Fr);t.on=n.default;var o=wr(vi);t.off=o.default;var r=wr(Ds);t.filter=r.default;var i=wr(Ls);t.listen=i.default;var a={on:n.default,off:o.default,filter:r.default,listen:i.default};t.default=a}),js=t(Fs),Ks=(Fs.on,Fs.off,Fs.filter,Fs.listen,n(function(e,t){t.__esModule=!0,t.default=function(e){if((!n&&0!==n||e)&&o.default){var t=document.createElement("div");t.style.position="absolute",t.style.top="-9999px",t.style.width="50px",t.style.height="50px",t.style.overflow="scroll",document.body.appendChild(t),n=t.offsetWidth-t.clientWidth,document.body.removeChild(t)}return n};var n,o=wr(Mr);e.exports=t.default})),Hs=t(Ks),Us=n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},l=o(P),n=o(io);function o(e){return e&&e.__esModule?e:{default:e}}t.default=(0,n.default)(function(e,t,n,o,r){var i=e[t],a=void 0===i?"undefined":s(i);return l.default.isValidElement(i)?new Error("Invalid "+o+" `"+r+"` of type ReactElement supplied to `"+n+"`, expected a ReactComponent or a DOMElement. You can usually obtain a ReactComponent or DOMElement from a ReactElement by attaching a ref to it."):"object"===a&&"function"==typeof i.render||1===i.nodeType?null:new Error("Invalid "+o+" `"+r+"` of value `"+i+"` supplied to `"+n+"`, expected a ReactComponent or a DOMElement.")}),e.exports=t.default});t(Us);var $s=n(function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=o;var n,f=(n=ar)&&n.__esModule?n:{default:n};var h={};function o(p,d){return function(e,t,n,o,r){var i=n||"<<anonymous>>",a=r||t;if(null!=e[t]){var s=n+"."+t;(0,f.default)(h[s],"The "+o+" `"+a+"` of `"+i+"` is deprecated. "+d+"."),h[s]=!0}for(var l=arguments.length,c=Array(5<l?l-5:0),u=5;u<l;u++)c[u-5]=arguments[u];return p.apply(void 0,[e,t,n,o,r].concat(c))}}o._resetWarned=function(){h={}},e.exports=t.default});t($s);var Bs=n(function(e,t){t.__esModule=!0,t.default=function(e,t){return e.classList?!!t&&e.classList.contains(t):-1!==(" "+(e.className.baseVal||e.className)+" ").indexOf(" "+t+" ")},e.exports=t.default});t(Bs);var Vs=n(function(e,t){t.__esModule=!0,t.default=function(e,t){e.classList?e.classList.add(t):(0,n.default)(e,t)||("string"==typeof e.className?e.className=e.className+" "+t:e.setAttribute("class",(e.className&&e.className.baseVal||"")+" "+t))};var n=wr(Bs);e.exports=t.default});function Ws(e,t){return e.replace(new RegExp("(^|\\s)"+t+"(?:\\s|$)","g"),"$1").replace(/\s+/g," ").replace(/^\s*|\s*$/g,"")}t(Vs);function qs(e,t){e.classList?e.classList.remove(t):"string"==typeof e.className?e.className=Ws(e.className,t):e.setAttribute("class",Ws(e.className&&e.className.baseVal||"",t))}var zs=n(function(e,t){t.__esModule=!0,t.default=void 0;var n=wr(Vs);t.addClass=n.default;var o=wr(qs);t.removeClass=o.default;var r=wr(Bs);t.hasClass=r.default;var i={addClass:n.default,removeClass:o.default,hasClass:r.default};t.default=i});t(zs);zs.addClass,zs.removeClass,zs.hasClass;var Gs=n(function(e,t){t.__esModule=!0,t.default=function(e){return e===e.window?e:9===e.nodeType&&(e.defaultView||e.parentWindow)},e.exports=t.default});t(Gs);var Ys=n(function(e,t){t.__esModule=!0,t.default=function(e){return(0,r.default)(e)||function(e){return e&&"body"===e.tagName.toLowerCase()}(e)?function(e){var t=(0,i.default)(e),n=(0,r.default)(t).innerWidth;if(!n){var o=t.documentElement.getBoundingClientRect();n=o.right-Math.abs(o.left)}return t.body.clientWidth<n}(e):e.scrollHeight>e.clientHeight};var r=n(Gs),i=n(qr);function n(e){return e&&e.__esModule?e:{default:e}}e.exports=t.default}),Xs=t(Ys),Js=n(function(e,t){t.__esModule=!0,t.ariaHidden=r,t.hideSiblings=function(e,t){n(e,t,function(e){return r(!0,e)})},t.showSiblings=function(e,t){n(e,t,function(e){return r(!1,e)})};var o=["template","script","style"],n=function(e,t,n){t=[].concat(t),[].forEach.call(e.children,function(e){-1===t.indexOf(e)&&function(e){var t=e.nodeType,n=e.tagName;return 1===t&&-1===o.indexOf(n.toLowerCase())}(e)&&n(e)})};function r(e,t){t&&(e?t.setAttribute("aria-hidden","true"):t.removeAttribute("aria-hidden"))}});t(Js);Js.ariaHidden,Js.hideSiblings,Js.showSiblings;var Zs=n(function(e,t){t.__esModule=!0;var s=n(zs),l=n(Dr),c=n(Ks),u=n(Ys);function n(e){return e&&e.__esModule?e:{default:e}}t.default=function e(){var a=this,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=t.hideSiblingNodes,o=void 0===n||n,r=t.handleContainerOverflow,i=void 0===r||r;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.add=function(e,t,n){var o=a.modals.indexOf(e),r=a.containers.indexOf(t);if(-1!==o)return o;if(o=a.modals.length,a.modals.push(e),a.hideSiblingNodes&&(0,Js.hideSiblings)(t,e.mountNode),-1!==r)return a.data[r].modals.push(e),o;var i={modals:[e],classes:n?n.split(/\s+/):[],overflowing:(0,u.default)(t)};return a.handleContainerOverflow&&function(e,t){var n={overflow:"hidden"};e.style={overflow:t.style.overflow,paddingRight:t.style.paddingRight},e.overflowing&&(n.paddingRight=parseInt((0,l.default)(t,"paddingRight")||0,10)+(0,c.default)()+"px"),(0,l.default)(t,n)}(i,t),i.classes.forEach(s.default.addClass.bind(null,t)),a.containers.push(t),a.data.push(i),o},this.remove=function(e){var t=a.modals.indexOf(e);if(-1!==t){var n=function(e,t){return function(e,n){var o=-1;return e.some(function(e,t){if(n(e,t))return o=t,!0}),o}(e,function(e){return-1!==e.modals.indexOf(t)})}(a.data,e),o=a.data[n],r=a.containers[n];o.modals.splice(o.modals.indexOf(e),1),a.modals.splice(t,1),0===o.modals.length?(o.classes.forEach(s.default.removeClass.bind(null,r)),a.handleContainerOverflow&&function(e,t){var n=e.style;Object.keys(n).forEach(function(e){return t.style[e]=n[e]})}(o,r),a.hideSiblingNodes&&(0,Js.showSiblings)(r,e.mountNode),a.containers.splice(n,1),a.data.splice(n,1)):a.hideSiblingNodes&&(0,Js.ariaHidden)(!1,o.modals[o.modals.length-1].mountNode)}},this.isTopModal=function(e){return!!a.modals.length&&a.modals[a.modals.length-1]===e},this.hideSiblingNodes=o,this.handleContainerOverflow=i,this.modals=[],this.containers=[],this.data=[]},e.exports=t.default});t(Zs);var Qs=n(function(e,t){t.__esModule=!0,t.default=function(e,t){return e="function"==typeof e?e():e,o.default.findDOMNode(e)||t};var n,o=(n=S)&&n.__esModule?n:{default:n};e.exports=t.default});t(Qs);var el=n(function(e,t){t.__esModule=!0;var n=r(T),o=r(Us),i=r(P),a=r(S),s=r(Qs),l=r(bi);function r(e){return e&&e.__esModule?e:{default:e}}function c(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var u,p=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(d,u=i.default.Component),d.prototype.componentDidMount=function(){this._isMounted=!0,this._renderOverlay()},d.prototype.componentDidUpdate=function(){this._renderOverlay()},d.prototype.componentWillReceiveProps=function(e){this._overlayTarget&&e.container!==this.props.container&&(this._portalContainerNode.removeChild(this._overlayTarget),this._portalContainerNode=(0,s.default)(e.container,(0,l.default)(this).body),this._portalContainerNode.appendChild(this._overlayTarget))},d.prototype.componentWillUnmount=function(){this._isMounted=!1,this._unrenderOverlay(),this._unmountOverlayTarget()},d.prototype.render=function(){return null},d);function d(){var e,n;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,d);for(var t=arguments.length,o=Array(t),r=0;r<t;r++)o[r]=arguments[r];return(e=n=c(this,u.call.apply(u,[this].concat(o))))._mountOverlayTarget=function(){n._overlayTarget||(n._overlayTarget=document.createElement("div"),n._portalContainerNode=(0,s.default)(n.props.container,(0,l.default)(n).body),n._portalContainerNode.appendChild(n._overlayTarget))},n._unmountOverlayTarget=function(){n._overlayTarget&&(n._portalContainerNode.removeChild(n._overlayTarget),n._overlayTarget=null),n._portalContainerNode=null},n._renderOverlay=function(){var e=n.props.children?i.default.Children.only(n.props.children):null;if(null!==e){n._mountOverlayTarget();var t=!n._overlayInstance;n._overlayInstance=a.default.unstable_renderSubtreeIntoContainer(n,e,n._overlayTarget,function(){t&&n.props.onRendered&&n.props.onRendered()})}else n._unrenderOverlay(),n._unmountOverlayTarget()},n._unrenderOverlay=function(){n._overlayTarget&&(a.default.unmountComponentAtNode(n._overlayTarget),n._overlayInstance=null)},n.getMountNode=function(){return n._overlayTarget},c(n,e)}p.displayName="Portal",p.propTypes={container:n.default.oneOfType([o.default,n.default.func]),onRendered:n.default.func},t.default=p,e.exports=t.default});t(el);var tl=n(function(e,t){t.__esModule=!0;var n=c(T),o=c(Us),r=c(P),i=c(S),a=c(Qs),s=c(bi),l=c(el);function c(e){return e&&e.__esModule?e:{default:e}}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var p,d=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(f,p=r.default.Component),f.prototype.componentDidMount=function(){this.setContainer(),this.forceUpdate(this.props.onRendered)},f.prototype.componentWillReceiveProps=function(e){e.container!==this.props.container&&this.setContainer(e)},f.prototype.componentWillUnmount=function(){this._portalContainerNode=null},f.prototype.render=function(){return this.props.children&&this._portalContainerNode?i.default.createPortal(this.props.children,this._portalContainerNode):null},f);function f(){var e,t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,f);for(var n=arguments.length,o=Array(n),r=0;r<n;r++)o[r]=arguments[r];return(e=t=u(this,p.call.apply(p,[this].concat(o)))).setContainer=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:t.props;t._portalContainerNode=(0,a.default)(e.container,(0,s.default)(t).body)},t.getMountNode=function(){return t._portalContainerNode},u(t,e)}d.displayName="Portal",d.propTypes={container:n.default.oneOfType([o.default,n.default.func]),onRendered:n.default.func},t.default=i.default.createPortal?d:l.default,e.exports=t.default});t(tl);var nl=n(function(e,t){t.__esModule=!0;var n=r(T),o=r(P);function r(e){return e&&e.__esModule?e:{default:e}}var i,a={children:n.default.node},s=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(l,i=o.default.Component),l.prototype.render=function(){return this.props.children},l);function l(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,l),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,i.apply(this,arguments))}s.propTypes=a,t.default=s,e.exports=t.default});t(nl);var ol=n(function(e,t){t.__esModule=!0,t.default=function(e){var t=!document.addEventListener,n=void 0;n=t?(document.attachEvent("onfocusin",e),function(){return document.detachEvent("onfocusin",e)}):(document.addEventListener("focus",e,!0),function(){return document.removeEventListener("focus",e,!0)});return{remove:n}},e.exports=t.default});t(ol);var rl,il=t(n(function(e,t){t.__esModule=!0;var g=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},n=v(Gr),o=v(Xr),r=v(Mr),i=v(T),a=v(Us),s=v($s),l=v(so),E=v(P),c=v(S),u=v(ar),p=v(Zs),C=v(tl),N=v(nl),d=v(yi),f=v(ol),h=v(Qs),m=v(bi);function v(e){return e&&e.__esModule?e:{default:e}}function y(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var b,O=new p.default,w=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(x,b=E.default.Component),x.prototype.omitProps=function(t,n){var e=Object.keys(t),o={};return e.map(function(e){Object.prototype.hasOwnProperty.call(n,e)||(o[e]=t[e])}),o},x.prototype.render=function(){var e=this.props,t=e.show,n=e.container,o=e.children,r=e.transition,i=e.backdrop,a=e.dialogTransitionTimeout,s=e.className,l=e.style,c=e.onExit,u=e.onExiting,p=e.onEnter,d=e.onEntering,f=e.onEntered,h=E.default.Children.only(o),m=this.omitProps(this.props,x.propTypes);if(!(t||r&&!this.state.exited))return null;var v=h.props,y=v.role,b=v.tabIndex;return void 0!==y&&void 0!==b||(h=(0,P.cloneElement)(h,{role:void 0===y?"document":y,tabIndex:null==b?"-1":b})),r&&(h=E.default.createElement(r,{transitionAppear:!0,unmountOnExit:!0,in:t,timeout:a,onExit:c,onExiting:u,onExited:this.handleHidden,onEnter:p,onEntering:d,onEntered:f},h)),E.default.createElement(C.default,{ref:this.setMountNode,container:n,onRendered:this.onPortalRendered},E.default.createElement("div",g({ref:this.setModalNodeRef,role:y||"dialog"},m,{style:l,className:s}),i&&this.renderBackdrop(),E.default.createElement(N.default,{ref:this.setDialogRef},h)))},x.prototype.componentWillReceiveProps=function(e){e.show?this.setState({exited:!1}):e.transition||this.setState({exited:!0})},x.prototype.componentWillUpdate=function(e){!this.props.show&&e.show&&this.checkForFocus()},x.prototype.componentDidMount=function(){this._isMounted=!0,this.props.show&&this.onShow()},x.prototype.componentDidUpdate=function(e){var t=this.props.transition;!e.show||this.props.show||t?!e.show&&this.props.show&&this.onShow():this.onHide()},x.prototype.componentWillUnmount=function(){var e=this.props,t=e.show,n=e.transition;this._isMounted=!1,(t||n&&!this.state.exited)&&this.onHide()},x.prototype.autoFocus=function(){if(this.props.autoFocus){var e=this.getDialogElement(),t=(0,n.default)((0,m.default)(this));e&&!(0,o.default)(e,t)&&(this.lastFocus=t,e.hasAttribute("tabIndex")||((0,u.default)(!1,'The modal content node does not accept focus. For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'),e.setAttribute("tabIndex",-1)),e.focus())}},x.prototype.restoreLastFocus=function(){this.lastFocus&&this.lastFocus.focus&&(this.lastFocus.focus(),this.lastFocus=null)},x.prototype.getDialogElement=function(){return c.default.findDOMNode(this.dialog)},x.prototype.isTopModal=function(){return this.props.manager.isTopModal(this)},x);function x(){var e,t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,x);for(var n=arguments.length,o=Array(n),r=0;r<n;r++)o[r]=arguments[r];return e=t=y(this,b.call.apply(b,[this].concat(o))),_.call(t),y(t,e)}w.propTypes=g({},C.default.propTypes,{show:i.default.bool,container:i.default.oneOfType([a.default,i.default.func]),onShow:i.default.func,onHide:i.default.func,backdrop:i.default.oneOfType([i.default.bool,i.default.oneOf(["static"])]),renderBackdrop:i.default.func,onEscapeKeyDown:i.default.func,onEscapeKeyUp:(0,s.default)(i.default.func,"Please use onEscapeKeyDown instead for consistency"),onBackdropClick:i.default.func,backdropStyle:i.default.object,backdropClassName:i.default.string,containerClassName:i.default.string,keyboard:i.default.bool,transition:l.default,dialogTransitionTimeout:i.default.number,backdropTransitionTimeout:i.default.number,autoFocus:i.default.bool,enforceFocus:i.default.bool,restoreFocus:i.default.bool,onEnter:i.default.func,onEntering:i.default.func,onEntered:i.default.func,onExit:i.default.func,onExiting:i.default.func,onExited:i.default.func,manager:i.default.object.isRequired}),w.defaultProps={show:!1,backdrop:!0,keyboard:!0,autoFocus:!0,enforceFocus:!0,restoreFocus:!0,onHide:function(){},manager:O,renderBackdrop:function(e){return E.default.createElement("div",e)}};var _=function(){var s=this;this.state={exited:!this.props.show},this.renderBackdrop=function(){var e=s.props,t=e.backdropStyle,n=e.backdropClassName,o=e.renderBackdrop,r=e.transition,i=e.backdropTransitionTimeout,a=o({ref:function(e){return s.backdrop=e},style:t,className:n,onClick:s.handleBackdropClick});return r&&(a=E.default.createElement(r,{transitionAppear:!0,in:s.props.show,timeout:i},a)),a},this.onPortalRendered=function(){s.autoFocus(),s.props.onShow&&s.props.onShow()},this.onShow=function(){var e=(0,m.default)(s),t=(0,h.default)(s.props.container,e.body);s.props.manager.add(s,t,s.props.containerClassName),s._onDocumentKeydownListener=(0,d.default)(e,"keydown",s.handleDocumentKeyDown),s._onDocumentKeyupListener=(0,d.default)(e,"keyup",s.handleDocumentKeyUp),s._onFocusinListener=(0,f.default)(s.enforceFocus)},this.onHide=function(){s.props.manager.remove(s),s._onDocumentKeydownListener.remove(),s._onDocumentKeyupListener.remove(),s._onFocusinListener.remove(),s.props.restoreFocus&&s.restoreLastFocus()},this.setMountNode=function(e){s.mountNode=e?e.getMountNode():e},this.setModalNodeRef=function(e){s.modalNode=e},this.setDialogRef=function(e){s.dialog=e},this.handleHidden=function(){var e;s.setState({exited:!0}),s.onHide(),s.props.onExited&&(e=s.props).onExited.apply(e,arguments)},this.handleBackdropClick=function(e){e.target===e.currentTarget&&(s.props.onBackdropClick&&s.props.onBackdropClick(e),!0===s.props.backdrop&&s.props.onHide())},this.handleDocumentKeyDown=function(e){s.props.keyboard&&27===e.keyCode&&s.isTopModal()&&(s.props.onEscapeKeyDown&&s.props.onEscapeKeyDown(e),s.props.onHide())},this.handleDocumentKeyUp=function(e){s.props.keyboard&&27===e.keyCode&&s.isTopModal()&&s.props.onEscapeKeyUp&&s.props.onEscapeKeyUp(e)},this.checkForFocus=function(){r.default&&(s.lastFocus=(0,n.default)())},this.enforceFocus=function(){if(s.props.enforceFocus&&s._isMounted&&s.isTopModal()){var e=s.getDialogElement(),t=(0,n.default)((0,m.default)(s));e&&!(0,o.default)(e,t)&&e.focus()}}};w.Manager=p.default,t.default=w,e.exports=t.default})),al={componentClass:lo},sl=(rl=P.Component,nn(ll,rl),ll.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},ll);function ll(){return ge(this,ll),Gt(this,rl.apply(this,arguments))}sl.propTypes=al,sl.defaultProps={componentClass:"div"};var cl,ul=wn("modal-body",sl),pl={dialogClassName:T.string},dl=(cl=P.Component,nn(fl,cl),fl.prototype.render=function(){var e,t=this.props,n=t.dialogClassName,o=t.className,r=t.style,i=t.children,a=kn(on(t,["dialogClassName","className","style","children"])),s=a[0],l=a[1],c=On(s),u=be({display:"block"},r),p=be({},Tn(s),((e={})[c]=!1,e[On(s,"dialog")]=!0,e));return P.createElement("div",be({},l,{tabIndex:"-1",role:"dialog",style:u,className:rn(o,c)}),P.createElement("div",{className:rn(n,p)},P.createElement("div",{className:On(s,"content"),role:"document"},i)))},fl);function fl(){return ge(this,fl),Gt(this,cl.apply(this,arguments))}dl.propTypes=pl;var hl,ml=wn("modal",_n([dn,fn],dl)),vl={componentClass:lo},yl=(hl=P.Component,nn(bl,hl),bl.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},bl);function bl(){return ge(this,bl),Gt(this,hl.apply(this,arguments))}yl.propTypes=vl,yl.defaultProps={componentClass:"div"};var gl,El=wn("modal-footer",yl),Cl={closeLabel:T.string,closeButton:T.bool,onHide:T.func},Nl={$bs_modal:T.shape({onHide:T.func})},Ol=(gl=P.Component,nn(wl,gl),wl.prototype.render=function(){var e=this.props,t=e.closeLabel,n=e.closeButton,o=e.onHide,r=e.className,i=e.children,a=on(e,["closeLabel","closeButton","onHide","className","children"]),s=this.context.$bs_modal,l=kn(a),c=l[0],u=l[1],p=Tn(c);return P.createElement("div",be({},u,{className:rn(r,p)}),n&&P.createElement(qn,{label:t,onClick:Rn(s&&s.onHide,o)}),i)},wl);function wl(){return ge(this,wl),Gt(this,gl.apply(this,arguments))}Ol.propTypes=Cl,Ol.defaultProps={closeLabel:"Close",closeButton:!1},Ol.contextTypes=Nl;var xl,_l=wn("modal-header",Ol),Tl={componentClass:lo},Sl=(xl=P.Component,nn(Pl,xl),Pl.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},Pl);function Pl(){return ge(this,Pl),Gt(this,xl.apply(this,arguments))}Sl.propTypes=Tl,Sl.defaultProps={componentClass:"h4"};var kl,Ml=wn("modal-title",Sl),Rl=be({},il.propTypes,ml.propTypes,{backdrop:T.oneOf(["static",!0,!1]),backdropClassName:T.string,keyboard:T.bool,animation:T.bool,dialogComponentClass:lo,autoFocus:T.bool,enforceFocus:T.bool,restoreFocus:T.bool,show:T.bool,onHide:T.func,onEnter:T.func,onEntering:T.func,onEntered:T.func,onExit:T.func,onExiting:T.func,onExited:T.func,container:il.propTypes.container}),Al=be({},il.defaultProps,{animation:!0,dialogComponentClass:ml}),Il={$bs_modal:T.shape({onHide:T.func})},Dl=(kl=P.Component,nn(Ll,kl),Ll.prototype.getChildContext=function(){return{$bs_modal:{onHide:this.props.onHide}}},Ll.prototype.componentWillUnmount=function(){this.handleExited()},Ll.prototype.setModalRef=function(e){this._modal=e},Ll.prototype.handleDialogClick=function(e){e.target===e.currentTarget&&this.props.onHide()},Ll.prototype.handleEntering=function(){js.on(window,"resize",this.handleWindowResize),this.updateStyle()},Ll.prototype.handleExited=function(){js.off(window,"resize",this.handleWindowResize)},Ll.prototype.handleWindowResize=function(){this.updateStyle()},Ll.prototype.updateStyle=function(){if(Rr){var e=this._modal.getDialogElement(),t=e.scrollHeight,n=zr(e),o=Xs(S.findDOMNode(this.props.container||n.body)),r=t>n.documentElement.clientHeight;this.setState({style:{paddingRight:o&&!r?Hs():void 0,paddingLeft:!o&&r?Hs():void 0}})}},Ll.prototype.render=function(){var e=this.props,t=e.backdrop,n=e.backdropClassName,o=e.animation,r=e.show,i=e.dialogComponentClass,a=e.className,s=e.style,l=e.children,c=e.onEntering,u=e.onExited,p=on(e,["backdrop","backdropClassName","animation","show","dialogComponentClass","className","style","children","onEntering","onExited"]),d=Ki(p,il),f=d[0],h=d[1],m=r&&!o&&"in";return P.createElement(il,be({},f,{ref:this.setModalRef,show:r,onEntering:Rn(c,this.handleEntering),onExited:Rn(u,this.handleExited),backdrop:t,backdropClassName:rn(On(p,"backdrop"),n,m),containerClassName:On(p,"open"),transition:o?Wi:void 0,dialogTransitionTimeout:Ll.TRANSITION_DURATION,backdropTransitionTimeout:Ll.BACKDROP_TRANSITION_DURATION}),P.createElement(i,be({},h,{style:be({},this.state.style,s),className:rn(a,m),onClick:!0===t?this.handleDialogClick:null}),l))},Ll);function Ll(e,t){ge(this,Ll);var n=Gt(this,kl.call(this,e,t));return n.handleEntering=n.handleEntering.bind(n),n.handleExited=n.handleExited.bind(n),n.handleWindowResize=n.handleWindowResize.bind(n),n.handleDialogClick=n.handleDialogClick.bind(n),n.setModalRef=n.setModalRef.bind(n),n.state={style:{}},n}Dl.propTypes=Rl,Dl.defaultProps=Al,Dl.childContextTypes=Il,Dl.Body=ul,Dl.Header=_l,Dl.Title=Ml,Dl.Footer=El,Dl.Dialog=ml,Dl.TRANSITION_DURATION=300,Dl.BACKDROP_TRANSITION_DURATION=150;var Fl,jl=wn("modal",_n([dn,fn],Dl)),Kl={activeKey:T.any,activeHref:T.string,stacked:T.bool,justified:So(T.bool,function(e){var t=e.justified,n=e.navbar;return t&&n?Error("justified navbar `Nav`s are not supported"):null}),onSelect:T.func,role:T.string,navbar:T.bool,pullRight:T.bool,pullLeft:T.bool},Hl={$bs_navbar:T.shape({bsClass:T.string,onSelect:T.func}),$bs_tabContainer:T.shape({activeKey:T.any,onSelect:T.func.isRequired,getTabId:T.func.isRequired,getPaneId:T.func.isRequired})},Ul=(Fl=P.Component,nn($l,Fl),$l.prototype.componentDidUpdate=function(){var t=this;if(this._needsRefocus){this._needsRefocus=!1;var e=this.props.children,n=this.getActiveProps(),o=n.activeKey,r=n.activeHref,i=In.find(e,function(e){return t.isActive(e,o,r)}),a=In.toArray(e).indexOf(i),s=S.findDOMNode(this).children,l=s&&s[a];l&&l.firstChild&&l.firstChild.focus()}},$l.prototype.getActiveProps=function(){var e=this.context.$bs_tabContainer;return e?("production"!=="production"&&ar(null==this.props.activeKey&&!this.props.activeHref,"Specifying a `<Nav>` `activeKey` or `activeHref` in the context of a `<TabContainer>` is not supported. Instead use `<TabContainer activeKey={"+this.props.activeKey+"} />`."),e):this.props},$l.prototype.getNextActiveChild=function(e){var t=this,n=this.props.children,o=n.filter(function(e){return null!=e.props.eventKey&&!e.props.disabled}),r=this.getActiveProps(),i=r.activeKey,a=r.activeHref,s=In.find(n,function(e){return t.isActive(e,i,a)}),l=o.indexOf(s);if(-1===l)return o[0];var c=l+e,u=o.length;return u<=c?c=0:c<0&&(c=u-1),o[c]},$l.prototype.getTabProps=function(e,t,n,o,r){var i=this;if(!t&&"tablist"!==n)return null;var a=e.props,s=a.id,l=a["aria-controls"],c=a.eventKey,u=a.role,p=a.onKeyDown,d=a.tabIndex;return t&&("production"!=="production"&&ar(!s&&!l,"In the context of a `<TabContainer>`, `<NavItem>`s are given generated `id` and `aria-controls` attributes for the sake of proper component accessibility. Any provided ones will be ignored. To control these attributes directly, provide a `generateChildId` prop to the parent `<TabContainer>`."),s=t.getTabId(c),l=t.getPaneId(c)),"tablist"===n&&(u=u||"tab",p=Rn(function(e){return i.handleTabKeyDown(r,e)},p),d=o?d:-1),{id:s,role:u,onKeyDown:p,"aria-controls":l,tabIndex:d}},$l.prototype.handleTabKeyDown=function(e,t){var n=void 0;switch(t.keyCode){case Zr.codes.left:case Zr.codes.up:n=this.getNextActiveChild(-1);break;case Zr.codes.right:case Zr.codes.down:n=this.getNextActiveChild(1);break;default:return}t.preventDefault(),e&&n&&null!=n.props.eventKey&&e(n.props.eventKey),this._needsRefocus=!0},$l.prototype.isActive=function(e,t,n){var o=e.props;return!!(o.active||null!=t&&o.eventKey===t||n&&o.href===n)||o.active},$l.prototype.render=function(){var e,o=this,t=this.props,n=t.stacked,r=t.justified,i=t.onSelect,a=t.role,s=t.navbar,l=t.pullRight,c=t.pullLeft,u=t.className,p=t.children,d=on(t,["stacked","justified","onSelect","role","navbar","pullRight","pullLeft","className","children"]),f=this.context.$bs_tabContainer,h=a||(f?"tablist":null),m=this.getActiveProps(),v=m.activeKey,y=m.activeHref;delete d.activeKey,delete d.activeHref;var b=kn(d),g=b[0],E=b[1],C=be({},Tn(g),((e={})[On(g,"stacked")]=n,e[On(g,"justified")]=r,e)),N=null!=s?s:this.context.$bs_navbar,O=void 0,w=void 0;if(N){var x=this.context.$bs_navbar||{bsClass:"navbar"};C[On(x,"nav")]=!0,w=On(x,"right"),O=On(x,"left")}else w="pull-right",O="pull-left";return C[w]=l,C[O]=c,P.createElement("ul",be({},E,{role:h,className:rn(u,C)}),In.map(p,function(e){var t=o.isActive(e,v,y),n=Rn(e.props.onSelect,i,N&&N.onSelect,f&&f.onSelect);return _.cloneElement(e,be({},o.getTabProps(e,f,h,t,n),{active:t,activeKey:v,activeHref:y,onSelect:n}))}))},$l);function $l(){return ge(this,$l),Gt(this,Fl.apply(this,arguments))}Ul.propTypes=Kl,Ul.defaultProps={justified:!1,pullRight:!1,pullLeft:!1,stacked:!1},Ul.contextTypes=Hl;var Bl,Vl=wn("nav",xn(["tabs","pills"],Ul)),Wl={$bs_navbar:T.shape({bsClass:T.string})},ql=(Bl=P.Component,nn(zl,Bl),zl.prototype.render=function(){var e=this.props,t=e.className,n=e.children,o=on(e,["className","children"]),r=On(this.context.$bs_navbar||{bsClass:"navbar"},"brand");return P.isValidElement(n)?P.cloneElement(n,{className:rn(n.props.className,t,r)}):P.createElement("span",be({},o,{className:rn(t,r)}),n)},zl);function zl(){return ge(this,zl),Gt(this,Bl.apply(this,arguments))}ql.contextTypes=Wl;var Gl,Yl={$bs_navbar:T.shape({bsClass:T.string,expanded:T.bool})},Xl=(Gl=P.Component,nn(Jl,Gl),Jl.prototype.render=function(){var e=this.props,t=e.children,n=on(e,["children"]),o=this.context.$bs_navbar||{bsClass:"navbar"},r=On(o,"collapse");return P.createElement(Vr,be({in:o.expanded},n),P.createElement("div",{className:r},t))},Jl);function Jl(){return ge(this,Jl),Gt(this,Gl.apply(this,arguments))}Xl.contextTypes=Yl;var Zl,Ql={$bs_navbar:T.shape({bsClass:T.string})},ec=(Zl=P.Component,nn(tc,Zl),tc.prototype.render=function(){var e=this.props,t=e.className,n=on(e,["className"]),o=On(this.context.$bs_navbar||{bsClass:"navbar"},"header");return P.createElement("div",be({},n,{className:rn(t,o)}))},tc);function tc(){return ge(this,tc),Gt(this,Zl.apply(this,arguments))}ec.contextTypes=Ql;var nc,oc={onClick:T.func,children:T.node},rc={$bs_navbar:T.shape({bsClass:T.string,expanded:T.bool,onToggle:T.func.isRequired})},ic=(nc=P.Component,nn(ac,nc),ac.prototype.render=function(){var e=this.props,t=e.onClick,n=e.className,o=e.children,r=on(e,["onClick","className","children"]),i=this.context.$bs_navbar||{bsClass:"navbar"},a=be({type:"button"},r,{onClick:Rn(t,i.onToggle),className:rn(n,On(i,"toggle"),!i.expanded&&"collapsed")});return o?P.createElement("button",a,o):P.createElement("button",a,P.createElement("span",{className:"sr-only"},"Toggle navigation"),P.createElement("span",{className:"icon-bar"}),P.createElement("span",{className:"icon-bar"}),P.createElement("span",{className:"icon-bar"}))},ac);function ac(){return ge(this,ac),Gt(this,nc.apply(this,arguments))}ic.propTypes=oc,ic.contextTypes=rc;var sc,lc={fixedTop:T.bool,fixedBottom:T.bool,staticTop:T.bool,inverse:T.bool,fluid:T.bool,componentClass:lo,onToggle:T.func,onSelect:T.func,collapseOnSelect:T.bool,expanded:T.bool,role:T.string},cc={$bs_navbar:T.shape({bsClass:T.string,expanded:T.bool,onToggle:T.func.isRequired,onSelect:T.func})},uc=(sc=P.Component,nn(pc,sc),pc.prototype.getChildContext=function(){var e=this.props,t=e.bsClass,n=e.expanded,o=e.onSelect,r=e.collapseOnSelect;return{$bs_navbar:{bsClass:t,expanded:n,onToggle:this.handleToggle,onSelect:Rn(o,r?this.handleCollapse:null)}}},pc.prototype.handleCollapse=function(){var e=this.props,t=e.onToggle;e.expanded&&t(!1)},pc.prototype.handleToggle=function(){var e=this.props;(0,e.onToggle)(!e.expanded)},pc.prototype.render=function(){var e,t=this.props,n=t.componentClass,o=t.fixedTop,r=t.fixedBottom,i=t.staticTop,a=t.inverse,s=t.fluid,l=t.className,c=t.children,u=Mn(on(t,["componentClass","fixedTop","fixedBottom","staticTop","inverse","fluid","className","children"]),["expanded","onToggle","onSelect","collapseOnSelect"]),p=u[0],d=u[1];void 0===d.role&&"nav"!==n&&(d.role="navigation"),a&&(p.bsStyle=Cn);var f=be({},Tn(p),((e={})[On(p,"fixed-top")]=o,e[On(p,"fixed-bottom")]=r,e[On(p,"static-top")]=i,e));return P.createElement(n,be({},d,{className:rn(l,f)}),P.createElement(Na,{fluid:s},c))},pc);function pc(e,t){ge(this,pc);var n=Gt(this,sc.call(this,e,t));return n.handleToggle=n.handleToggle.bind(n),n.handleCollapse=n.handleCollapse.bind(n),n}uc.propTypes=lc,uc.defaultProps={componentClass:"nav",fixedTop:!1,fixedBottom:!1,staticTop:!1,inverse:!1,fluid:!1,collapseOnSelect:!1},uc.childContextTypes=cc,wn("navbar",uc);var dc=ri(uc,{expanded:"onToggle"});function fc(e,c,t){function n(e,t){var n=t.$bs_navbar,o=void 0===n?{bsClass:"navbar"}:n,r=e.componentClass,i=e.className,a=e.pullRight,s=e.pullLeft,l=on(e,["componentClass","className","pullRight","pullLeft"]);return P.createElement(r,be({},l,{className:rn(i,On(o,c),a&&On(o,"right"),s&&On(o,"left"))}))}return n.displayName=t,n.propTypes={componentClass:lo,pullRight:T.bool,pullLeft:T.bool},n.defaultProps={componentClass:e,pullRight:!1,pullLeft:!1},n.contextTypes={$bs_navbar:T.shape({bsClass:T.string})},n}dc.Brand=ql,dc.Header=ec,dc.Toggle=ic,dc.Collapse=Xl,dc.Form=fc("div","form","NavbarForm"),dc.Text=fc("p","text","NavbarText"),dc.Link=fc("a","link","NavbarLink"),xn([bn,Cn],bn,dc);var hc,mc=be({},ji.propTypes,{title:T.node.isRequired,noCaret:T.bool,active:T.bool,children:T.node});function vc(){return ge(this,vc),Gt(this,hc.apply(this,arguments))}(hc=P.Component,nn(vc,hc),vc.prototype.isActive=function(e,t,n){var o=e.props,r=this;return!!(o.active||null!=t&&o.eventKey===t||n&&o.href===n)||!!In.some(o.children,function(e){return r.isActive(e,t,n)})||o.active},vc.prototype.render=function(){var t=this,e=this.props,n=e.title,o=e.activeKey,r=e.activeHref,i=e.className,a=e.style,s=e.children,l=on(e,["title","activeKey","activeHref","className","style","children"]),c=this.isActive(this,o,r);delete l.active,delete l.eventKey;var u=Ki(l,ji.ControlledComponent),p=u[0],d=u[1];return P.createElement(ji,be({},p,{componentClass:"li",className:rn(i,{active:c}),style:a}),P.createElement(ji.Toggle,be({},d,{useAnchor:!0}),n),P.createElement(ji.Menu,null,In.map(s,function(e){return P.cloneElement(e,{active:t.isActive(e,o,r)})})))},vc).propTypes=mc;var yc,bc={active:T.bool,disabled:T.bool,role:T.string,href:T.string,onClick:T.func,onSelect:T.func,eventKey:T.any},gc=(yc=P.Component,nn(Ec,yc),Ec.prototype.handleClick=function(e){this.props.onSelect&&(e.preventDefault(),this.props.disabled||this.props.onSelect(this.props.eventKey,e))},Ec.prototype.render=function(){var e=this.props,t=e.active,n=e.disabled,o=e.onClick,r=e.className,i=e.style,a=on(e,["active","disabled","onClick","className","style"]);return delete a.onSelect,delete a.eventKey,delete a.activeKey,delete a.activeHref,a.role?"tab"===a.role&&(a["aria-selected"]=t):"#"===a.href&&(a.role="button"),P.createElement("li",{role:"presentation",className:rn(r,{active:t,disabled:n}),style:i},P.createElement(fo,be({},a,{disabled:n,onClick:Rn(o,this.handleClick)})))},Ec);function Ec(e,t){ge(this,Ec);var n=Gt(this,yc.call(this,e,t));return n.handleClick=n.handleClick.bind(n),n}gc.propTypes=bc,gc.defaultProps={active:!1,disabled:!1};var Cc=n(function(e,t){t.__esModule=!0,t.default=function(e){var t=(0,s.default)(e),n=(0,a.default)(t),o=t&&t.documentElement,r={top:0,left:0,height:0,width:0};if(!t)return;if(!(0,i.default)(o,e))return r;void 0!==e.getBoundingClientRect&&(r=e.getBoundingClientRect());return r={top:r.top+(n.pageYOffset||o.scrollTop)-(o.clientTop||0),left:r.left+(n.pageXOffset||o.scrollLeft)-(o.clientLeft||0),width:(null==r.width?e.offsetWidth:r.width)||0,height:(null==r.height?e.offsetHeight:r.height)||0}};var i=wr(Xr),a=wr(Gs),s=wr(qr);e.exports=t.default});t(Cc);var Nc=n(function(e){function t(){return e.exports=t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},t.apply(this,arguments)}e.exports=t}),Oc=n(function(e,t){t.__esModule=!0,t.default=function(e){var t=(0,r.default)(e),n=e&&e.offsetParent;for(;n&&"html"!==(o=e,o.nodeName&&o.nodeName.toLowerCase())&&"static"===(0,i.default)(n,"position");)n=n.offsetParent;var o;return n||t.documentElement};var r=wr(qr),i=wr(Dr);e.exports=t.default});t(Oc);var wc=n(function(e,t){t.__esModule=!0,t.default=function(e,t){var n=(0,o.default)(e);if(void 0===t)return n?"pageYOffset"in n?n.pageYOffset:n.document.documentElement.scrollTop:e.scrollTop;n?n.scrollTo("pageXOffset"in n?n.pageXOffset:n.document.documentElement.scrollLeft,t):e.scrollTop=t};var o=wr(Gs);e.exports=t.default});t(wc);var xc=n(function(e,t){t.__esModule=!0,t.default=function(e,t){var n=(0,o.default)(e);if(void 0===t)return n?"pageXOffset"in n?n.pageXOffset:n.document.documentElement.scrollLeft:e.scrollLeft;n?n.scrollTo(t,"pageYOffset"in n?n.pageYOffset:n.document.documentElement.scrollTop):e.scrollLeft=t};var o=wr(Gs);e.exports=t.default});t(xc);var _c=n(function(e,t){t.__esModule=!0,t.default=function(e,t){var n,o={top:0,left:0};"fixed"===(0,c.default)(e,"position")?n=e.getBoundingClientRect():(t=t||(0,a.default)(e),n=(0,i.default)(e),"html"!==function(e){return e.nodeName&&e.nodeName.toLowerCase()}(t)&&(o=(0,i.default)(t)),o.top+=parseInt((0,c.default)(t,"borderTopWidth"),10)-(0,s.default)(t)||0,o.left+=parseInt((0,c.default)(t,"borderLeftWidth"),10)-(0,l.default)(t)||0);return(0,r.default)({},n,{top:n.top-o.top-(parseInt((0,c.default)(e,"marginTop"),10)||0),left:n.left-o.left-(parseInt((0,c.default)(e,"marginLeft"),10)||0)})};var r=wr(Nc),i=wr(Cc),a=wr(Oc),s=wr(wc),l=wr(xc),c=wr(Dr);e.exports=t.default});t(_c);var Tc=n(function(e,t){t.__esModule=!0,t.default=function(e,t,n,o,r){var i="BODY"===o.tagName?(0,m.default)(n):(0,v.default)(n,o),a=(0,m.default)(t),s=a.height,l=a.width,c=void 0,u=void 0,p=void 0,d=void 0;if("left"===e||"right"===e){u=i.top+(i.height-s)/2,c="left"===e?i.left-l:i.left+i.width;var f=function(e,t,n,o){var r=y(n),i=r.scroll,a=r.height,s=e-o-i,l=e+o-i+t;return s<0?-s:a<l?a-l:0}(u,s,o,r);u+=f,d=50*(1-2*f/s)+"%",p=void 0}else{if("top"!==e&&"bottom"!==e)throw new Error('calcOverlayPosition(): No such placement of "'+e+'" found.');c=i.left+(i.width-l)/2,u="top"===e?i.top-s:i.top+i.height;var h=function(e,t,n,o){var r=y(n).width,i=e-o,a=e+o+t;{if(i<0)return-i;if(r<a)return r-a}return 0}(c,l,o,r);c+=h,p=50*(1-2*h/l)+"%",d=void 0}return{positionLeft:c,positionTop:u,arrowOffsetLeft:p,arrowOffsetTop:d}};var m=n(Cc),v=n(_c),i=n(wc),a=n(bi);function n(e){return e&&e.__esModule?e:{default:e}}function y(e){var t=void 0,n=void 0,o=void 0;if("BODY"===e.tagName)t=window.innerWidth,n=window.innerHeight,o=(0,i.default)((0,a.default)(e).documentElement)||(0,i.default)(e);else{var r=(0,m.default)(e);t=r.width,n=r.height,o=(0,i.default)(e)}return{width:t,height:n,scroll:o}}e.exports=t.default});t(Tc);var Sc=n(function(e,t){t.__esModule=!0;var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},u=l(rn),n=l(T),o=l(Us),p=l(P),r=l(S),i=l(Tc),a=l(Qs),s=l(bi);function l(e){return e&&e.__esModule?e:{default:e}}function d(e,t){var n={};for(var o in e)0<=t.indexOf(o)||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}var f,h=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(m,f=p.default.Component),m.prototype.componentDidMount=function(){this.updatePosition(this.getTarget())},m.prototype.componentWillReceiveProps=function(){this._needsFlush=!0},m.prototype.componentDidUpdate=function(e){this._needsFlush&&(this._needsFlush=!1,this.maybeUpdatePosition(this.props.placement!==e.placement))},m.prototype.render=function(){var e=this.props,t=e.children,n=e.className,o=d(e,["children","className"]),r=this.state,i=r.positionLeft,a=r.positionTop,s=d(r,["positionLeft","positionTop"]);delete o.target,delete o.container,delete o.containerPadding,delete o.shouldUpdatePosition;var l=p.default.Children.only(t);return(0,P.cloneElement)(l,c({},o,s,{positionLeft:i,positionTop:a,className:(0,u.default)(n,l.props.className),style:c({},l.props.style,{left:i,top:a})}))},m.prototype.updatePosition=function(e){if(this._lastTarget=e){var t=r.default.findDOMNode(this),n=(0,a.default)(this.props.container,(0,s.default)(this).body);this.setState((0,i.default)(this.props.placement,t,e,n,this.props.containerPadding))}else this.setState({positionLeft:0,positionTop:0,arrowOffsetLeft:null,arrowOffsetTop:null})},m);function m(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,m);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,f.call(this,e,t));return n.getTarget=function(){var e=n.props.target,t="function"==typeof e?e():e;return t&&r.default.findDOMNode(t)||null},n.maybeUpdatePosition=function(e){var t=n.getTarget();(n.props.shouldUpdatePosition||t!==n._lastTarget||e)&&n.updatePosition(t)},n.state={positionLeft:0,positionTop:0,arrowOffsetLeft:null,arrowOffsetTop:null},n._needsFlush=!1,n._lastTarget=null,n}h.propTypes={target:n.default.oneOfType([o.default,n.default.func]),container:n.default.oneOfType([o.default,n.default.func]),containerPadding:n.default.number,placement:n.default.oneOf(["top","right","bottom","left"]),shouldUpdatePosition:n.default.bool},h.displayName="Position",h.defaultProps={containerPadding:0,placement:"right",shouldUpdatePosition:!1},t.default=h,e.exports=t.default});t(Sc);var Pc,kc=t(n(function(e,t){t.__esModule=!0;var n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},i=r(T),o=r(so),v=r(P),y=r(tl),b=r(Sc),g=r(Ei);function r(e){return e&&e.__esModule?e:{default:e}}var a,s=(function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(l,a=v.default.Component),l.prototype.componentWillReceiveProps=function(e){e.show?this.setState({exited:!1}):e.transition||this.setState({exited:!0})},l.prototype.render=function(){var e=this.props,t=e.container,n=e.containerPadding,o=e.target,r=e.placement,i=e.shouldUpdatePosition,a=e.rootClose,s=e.children,l=e.transition,c=function(e,t){var n={};for(var o in e)0<=t.indexOf(o)||Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n}(e,["container","containerPadding","target","placement","shouldUpdatePosition","rootClose","children","transition"]);if(!(c.show||l&&!this.state.exited))return null;var u=s;if(u=v.default.createElement(b.default,{container:t,containerPadding:n,target:o,placement:r,shouldUpdatePosition:i},u),l){var p=c.onExit,d=c.onExiting,f=c.onEnter,h=c.onEntering,m=c.onEntered;u=v.default.createElement(l,{in:c.show,transitionAppear:!0,onExit:p,onExiting:d,onExited:this.onHiddenListener,onEnter:f,onEntering:h,onEntered:m},u)}return a&&(u=v.default.createElement(g.default,{onRootClose:c.onHide},u)),v.default.createElement(y.default,{container:t},u)},l);function l(e,t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,l);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,a.call(this,e,t));return n.handleHidden=function(){var e;n.setState({exited:!0}),n.props.onExited&&(e=n.props).onExited.apply(e,arguments)},n.state={exited:!e.show},n.onHiddenListener=n.handleHidden.bind(n),n}s.propTypes=n({},y.default.propTypes,b.default.propTypes,{show:i.default.bool,rootClose:i.default.bool,onHide:function(e){var t=i.default.func;e.rootClose&&(t=t.isRequired);for(var n=arguments.length,o=Array(1<n?n-1:0),r=1;r<n;r++)o[r-1]=arguments[r];return t.apply(void 0,[e].concat(o))},transition:o.default,onEnter:i.default.func,onEntering:i.default.func,onEntered:i.default.func,onExit:i.default.func,onExiting:i.default.func,onExited:i.default.func}),t.default=s,e.exports=t.default})),Mc=be({},kc.propTypes,{show:T.bool,rootClose:T.bool,onHide:T.func,animation:T.oneOfType([T.bool,lo]),onEnter:T.func,onEntering:T.func,onEntered:T.func,onExit:T.func,onExiting:T.func,onExited:T.func,placement:T.oneOf(["top","right","bottom","left"])}),Rc={animation:Wi,rootClose:!1,show:!1,placement:"right"},Ac=(Pc=P.Component,nn(Ic,Pc),Ic.prototype.render=function(){var e=this.props,t=e.animation,n=e.children,o=on(e,["animation","children"]),r=!0===t?Wi:t||null,i=void 0;return i=r?n:_.cloneElement(n,{className:rn(n.props.className,"in")}),P.createElement(kc,be({},o,{transition:r}),i)},Ic);function Ic(){return ge(this,Ic),Gt(this,Pc.apply(this,arguments))}function Dc(e,t){return Array.isArray(t)?0<=t.indexOf(e):e===t}Ac.propTypes=Mc,Ac.defaultProps=Rc;var Lc,Fc,jc=T.oneOf(["click","hover","focus"]),Kc=be({},Ac.propTypes,{trigger:T.oneOfType([jc,T.arrayOf(jc)]),delay:T.number,delayShow:T.number,delayHide:T.number,defaultOverlayShown:T.bool,overlay:T.node.isRequired,onBlur:T.func,onClick:T.func,onFocus:T.func,onMouseOut:T.func,onMouseOver:T.func,target:T.oneOf([null]),onHide:T.oneOf([null]),show:T.oneOf([null])}),Hc=(Lc=P.Component,nn(Uc,Lc),Uc.prototype.componentDidMount=function(){this._mountNode=document.createElement("div"),this.renderOverlay()},Uc.prototype.componentDidUpdate=function(){this.renderOverlay()},Uc.prototype.componentWillUnmount=function(){S.unmountComponentAtNode(this._mountNode),this._mountNode=null,clearTimeout(this._hoverShowDelay),clearTimeout(this._hoverHideDelay)},Uc.prototype.handleDelayedHide=function(){var e=this;if(null!=this._hoverShowDelay)return clearTimeout(this._hoverShowDelay),void(this._hoverShowDelay=null);if(this.state.show&&null==this._hoverHideDelay){var t=null!=this.props.delayHide?this.props.delayHide:this.props.delay;t?this._hoverHideDelay=setTimeout(function(){e._hoverHideDelay=null,e.hide()},t):this.hide()}},Uc.prototype.handleDelayedShow=function(){var e=this;if(null!=this._hoverHideDelay)return clearTimeout(this._hoverHideDelay),void(this._hoverHideDelay=null);if(!this.state.show&&null==this._hoverShowDelay){var t=null!=this.props.delayShow?this.props.delayShow:this.props.delay;t?this._hoverShowDelay=setTimeout(function(){e._hoverShowDelay=null,e.show()},t):this.show()}},Uc.prototype.handleHide=function(){this.hide()},Uc.prototype.handleMouseOverOut=function(e,t){var n=t.currentTarget,o=t.relatedTarget||t.nativeEvent.toElement;o&&o===n||Jr(n,o)||e(t)},Uc.prototype.handleToggle=function(){this.state.show?this.hide():this.show()},Uc.prototype.hide=function(){this.setState({show:!1})},Uc.prototype.makeOverlay=function(e,t){return P.createElement(Ac,be({},t,{show:this.state.show,onHide:this.handleHide,target:this}),e)},Uc.prototype.show=function(){this.setState({show:!0})},Uc.prototype.renderOverlay=function(){S.unstable_renderSubtreeIntoContainer(this,this._overlay,this._mountNode)},Uc.prototype.render=function(){var e=this.props,t=e.trigger,n=e.overlay,o=e.children,r=e.onBlur,i=e.onClick,a=e.onFocus,s=e.onMouseOut,l=e.onMouseOver,c=on(e,["trigger","overlay","children","onBlur","onClick","onFocus","onMouseOut","onMouseOver"]);delete c.delay,delete c.delayShow,delete c.delayHide,delete c.defaultOverlayShown;var u=P.Children.only(o),p=u.props,d={};return this.state.show&&(d["aria-describedby"]=n.props.id),d.onClick=Rn(p.onClick,i),Dc("click",t)&&(d.onClick=Rn(d.onClick,this.handleToggle)),Dc("hover",t)&&("production"!=="production"&&ar(!("hover"===t),'[react-bootstrap] Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.'),d.onMouseOver=Rn(p.onMouseOver,l,this.handleMouseOver),d.onMouseOut=Rn(p.onMouseOut,s,this.handleMouseOut)),Dc("focus",t)&&(d.onFocus=Rn(p.onFocus,a,this.handleDelayedShow),d.onBlur=Rn(p.onBlur,r,this.handleDelayedHide)),this._overlay=this.makeOverlay(n,c),_.cloneElement(u,d)},Uc);function Uc(e,t){ge(this,Uc);var n=Gt(this,Lc.call(this,e,t));return n.handleToggle=n.handleToggle.bind(n),n.handleDelayedShow=n.handleDelayedShow.bind(n),n.handleDelayedHide=n.handleDelayedHide.bind(n),n.handleHide=n.handleHide.bind(n),n.handleMouseOver=function(e){return n.handleMouseOverOut(n.handleDelayedShow,e)},n.handleMouseOut=function(e){return n.handleMouseOverOut(n.handleDelayedHide,e)},n._mountNode=null,n.state={show:e.defaultOverlayShown},n}function $c(){return ge(this,$c),Gt(this,Fc.apply(this,arguments))}Hc.propTypes=Kc,Hc.defaultProps={defaultOverlayShown:!1,trigger:["hover","focus"]},wn("page-header",(Fc=P.Component,nn($c,Fc),$c.prototype.render=function(){var e=this.props,t=e.className,n=e.children,o=kn(on(e,["className","children"])),r=o[0],i=o[1],a=Tn(r);return P.createElement("div",be({},i,{className:rn(t,a)}),P.createElement("h1",null,n))},$c));var Bc,Vc={disabled:T.bool,previous:T.bool,next:T.bool,onClick:T.func,onSelect:T.func,eventKey:T.any},Wc=(Bc=P.Component,nn(qc,Bc),qc.prototype.handleSelect=function(e){var t=this.props,n=t.disabled,o=t.onSelect,r=t.eventKey;(o||n)&&e.preventDefault(),n||o&&o(r,e)},qc.prototype.render=function(){var e=this.props,t=e.disabled,n=e.previous,o=e.next,r=e.onClick,i=e.className,a=e.style,s=on(e,["disabled","previous","next","onClick","className","style"]);return delete s.onSelect,delete s.eventKey,P.createElement("li",{className:rn(i,{disabled:t,previous:n,next:o}),style:a},P.createElement(fo,be({},s,{disabled:t,onClick:Rn(r,this.handleSelect)})))},qc);function qc(e,t){ge(this,qc);var n=Gt(this,Bc.call(this,e,t));return n.handleSelect=n.handleSelect.bind(n),n}Wc.propTypes=Vc,Wc.defaultProps={disabled:!1,previous:!1,next:!1};var zc={};function Gc(e,t,n){var o=void 0;"object"===(void 0===e?"undefined":zt(e))?o=e.message:(o=e+" is deprecated. Use "+t+" instead.",n&&(o+="\nYou can read more about it at "+n)),zc[o]||("production"!=="production"&&ar(!1,o),zc[o]=!0)}Gc.wrapper=function(e){for(var t=arguments.length,r=Array(1<t?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return nn(o,i=e),o.prototype.componentWillMount=function(){if(Gc.apply(void 0,r),i.prototype.componentWillMount){for(var e,t=arguments.length,n=Array(t),o=0;o<t;o++)n[o]=arguments[o];(e=i.prototype.componentWillMount).call.apply(e,[this].concat(n))}},o;function o(){return ge(this,o),Gt(this,i.apply(this,arguments))}var i},Gc.wrapper(Wc,"`<PageItem>`","`<Pager.Item>`");var Yc,Xc={onSelect:T.func},Jc=(Yc=P.Component,nn(Zc,Yc),Zc.prototype.render=function(){var e=this.props,t=e.onSelect,n=e.className,o=e.children,r=kn(on(e,["onSelect","className","children"])),i=r[0],a=r[1],s=Tn(i);return P.createElement("ul",be({},a,{className:rn(n,s)}),In.map(o,function(e){return _.cloneElement(e,{onSelect:Rn(e.props.onSelect,t)})}))},Zc);function Zc(){return ge(this,Zc),Gt(this,Yc.apply(this,arguments))}Jc.propTypes=Xc,Jc.Item=Wc,wn("pager",Jc);var Qc,eu={componentClass:lo,className:T.string,eventKey:T.any,onSelect:T.func,disabled:T.bool,active:T.bool,onClick:T.func},tu={componentClass:fo,active:!1,disabled:!1},nu=(Qc=P.Component,nn(ou,Qc),ou.prototype.handleClick=function(e){var t=this.props,n=t.disabled,o=t.onSelect,r=t.eventKey;n||o&&o(r,e)},ou.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.active,o=e.disabled,r=e.onClick,i=e.className,a=e.style,s=on(e,["componentClass","active","disabled","onClick","className","style"]);return t===fo&&delete s.eventKey,delete s.onSelect,P.createElement("li",{className:rn(i,{active:n,disabled:o}),style:a},P.createElement(t,be({},s,{disabled:o,onClick:Rn(r,this.handleClick)})))},ou);function ou(e,t){ge(this,ou);var n=Gt(this,Qc.call(this,e,t));return n.handleClick=n.handleClick.bind(n),n}nu.propTypes=eu,nu.defaultProps=tu;var ru,iu={activePage:T.number,items:T.number,maxButtons:T.number,boundaryLinks:T.bool,ellipsis:T.oneOfType([T.bool,T.node]),first:T.oneOfType([T.bool,T.node]),last:T.oneOfType([T.bool,T.node]),prev:T.oneOfType([T.bool,T.node]),next:T.oneOfType([T.bool,T.node]),onSelect:T.func,buttonComponentClass:lo},au=(ru=P.Component,nn(su,ru),su.prototype.renderPageButtons=function(e,t,n,o,r,i){var a=[],s=void 0,l=void 0;l=n&&n<t?(s=Math.max(Math.min(e-Math.floor(n/2,10),t-n+1),1))+n-1:(s=1,t);for(var c=s;c<=l;++c)a.push(P.createElement(nu,be({},i,{key:c,eventKey:c,active:c===e}),c));return r&&o&&1<s&&(2<s&&a.unshift(P.createElement(nu,{key:"ellipsisFirst",disabled:!0,componentClass:i.componentClass},P.createElement("span",{"aria-label":"More"},!0===r?"…":r))),a.unshift(P.createElement(nu,be({},i,{key:1,eventKey:1,active:!1}),"1"))),r&&l<t&&((!o||l<t-1)&&a.push(P.createElement(nu,{key:"ellipsis",disabled:!0,componentClass:i.componentClass},P.createElement("span",{"aria-label":"More"},!0===r?"…":r))),o&&a.push(P.createElement(nu,be({},i,{key:t,eventKey:t,active:!1}),t))),a},su.prototype.render=function(){var e=this.props,t=e.activePage,n=e.items,o=e.maxButtons,r=e.boundaryLinks,i=e.ellipsis,a=e.first,s=e.last,l=e.prev,c=e.next,u=e.onSelect,p=e.buttonComponentClass,d=e.className,f=kn(on(e,["activePage","items","maxButtons","boundaryLinks","ellipsis","first","last","prev","next","onSelect","buttonComponentClass","className"])),h=f[0],m=f[1],v=Tn(h),y={onSelect:u,componentClass:p};return P.createElement("ul",be({},m,{className:rn(d,v)}),a&&P.createElement(nu,be({},y,{eventKey:1,disabled:1===t}),P.createElement("span",{"aria-label":"First"},!0===a?"«":a)),l&&P.createElement(nu,be({},y,{eventKey:t-1,disabled:1===t}),P.createElement("span",{"aria-label":"Previous"},!0===l?"‹":l)),this.renderPageButtons(t,n,o,r,i,y),c&&P.createElement(nu,be({},y,{eventKey:t+1,disabled:n<=t}),P.createElement("span",{"aria-label":"Next"},!0===c?"›":c)),s&&P.createElement(nu,be({},y,{eventKey:n,disabled:n<=t}),P.createElement("span",{"aria-label":"Last"},!0===s?"»":s)))},su);function su(){return ge(this,su),Gt(this,ru.apply(this,arguments))}au.propTypes=iu,au.defaultProps={activePage:1,items:1,maxButtons:0,first:!1,last:!1,prev:!1,next:!1,ellipsis:!0,boundaryLinks:!1},wn("pagination",au);var lu,cu={collapsible:T.bool,onSelect:T.func,header:T.node,id:T.oneOfType([T.string,T.number]),footer:T.node,defaultExpanded:T.bool,expanded:T.bool,eventKey:T.any,headerRole:T.string,panelRole:T.string,onEnter:T.func,onEntering:T.func,onEntered:T.func,onExit:T.func,onExiting:T.func,onExited:T.func},uu=(lu=P.Component,nn(pu,lu),pu.prototype.handleClickTitle=function(e){e.persist(),e.selected=!0,this.props.onSelect?this.props.onSelect(this.props.eventKey,e):e.preventDefault(),e.selected&&this.setState({expanded:!this.state.expanded})},pu.prototype.renderAnchor=function(e,t,n,o){return P.createElement("a",{role:n,href:t&&"#"+t,onClick:this.handleClickTitle,"aria-controls":t,"aria-expanded":o,"aria-selected":o,className:o?null:"collapsed"},e)},pu.prototype.renderBody=function(e,t){var n=[],o=[],r=On(t,"body");function i(){o.length&&(n.push(P.createElement("div",{key:n.length,className:r},o)),o=[])}return P.Children.toArray(e).forEach(function(e){if(P.isValidElement(e)&&e.props.fill)return i(),void n.push(_.cloneElement(e,{fill:void 0}));o.push(e)}),i(),n},pu.prototype.renderCollapsibleBody=function(e,t,n,o,r,i){return P.createElement(Vr,be({in:t},i),P.createElement("div",{id:e,role:n,className:On(r,"collapse"),"aria-hidden":!t},this.renderBody(o,r)))},pu.prototype.renderHeader=function(e,t,n,o,r,i){var a=On(i,"title");return e?P.isValidElement(t)?_.cloneElement(t,{className:rn(t.props.className,a),children:this.renderAnchor(t.props.children,n,o,r)}):P.createElement("h4",{role:"presentation",className:a},this.renderAnchor(t,n,o,r)):P.isValidElement(t)?_.cloneElement(t,{className:rn(t.props.className,a)}):t},pu.prototype.render=function(){var e=this.props,t=e.collapsible,n=e.header,o=e.id,r=e.footer,i=e.expanded,a=e.headerRole,s=e.panelRole,l=e.className,c=e.children,u=e.onEnter,p=e.onEntering,d=e.onEntered,f=e.onExit,h=e.onExiting,m=e.onExited,v=Mn(on(e,["collapsible","header","id","footer","expanded","headerRole","panelRole","className","children","onEnter","onEntering","onEntered","onExit","onExiting","onExited"]),["defaultExpanded","eventKey","onSelect"]),y=v[0],b=v[1],g=null!=i?i:this.state.expanded,E=Tn(y);return P.createElement("div",be({},b,{className:rn(l,E),id:t?null:o}),n&&P.createElement("div",{className:On(y,"heading")},this.renderHeader(t,n,o,a,g,y)),t?this.renderCollapsibleBody(o,g,s,c,y,{onEnter:u,onEntering:p,onEntered:d,onExit:f,onExiting:h,onExited:m}):this.renderBody(c,y),r&&P.createElement("div",{className:On(y,"footer")},r))},pu);function pu(e,t){ge(this,pu);var n=Gt(this,lu.call(this,e,t));return n.handleClickTitle=n.handleClickTitle.bind(n),n.state={expanded:n.props.defaultExpanded},n}uu.propTypes=cu,uu.defaultProps={defaultExpanded:!1},wn("panel",xn([].concat(Vn(yn),[bn,gn]),bn,uu));var du,fu={id:Qr(T.oneOfType([T.string,T.number])),placement:T.oneOf(["top","right","bottom","left"]),positionTop:T.oneOfType([T.number,T.string]),positionLeft:T.oneOfType([T.number,T.string]),arrowOffsetTop:T.oneOfType([T.number,T.string]),arrowOffsetLeft:T.oneOfType([T.number,T.string]),title:T.node},hu=(du=P.Component,nn(mu,du),mu.prototype.render=function(){var e,t=this.props,n=t.placement,o=t.positionTop,r=t.positionLeft,i=t.arrowOffsetTop,a=t.arrowOffsetLeft,s=t.title,l=t.className,c=t.style,u=t.children,p=kn(on(t,["placement","positionTop","positionLeft","arrowOffsetTop","arrowOffsetLeft","title","className","style","children"])),d=p[0],f=p[1],h=be({},Tn(d),((e={})[n]=!0,e)),m=be({display:"block",top:o,left:r},c),v={top:i,left:a};return P.createElement("div",be({},f,{role:"tooltip",className:rn(l,h),style:m}),P.createElement("div",{className:"arrow",style:v}),s&&P.createElement("h3",{className:On(d,"title")},s),P.createElement("div",{className:On(d,"content")},u))},mu);function mu(){return ge(this,mu),Gt(this,du.apply(this,arguments))}hu.propTypes=fu,hu.defaultProps={placement:"right"},wn("popover",hu);var vu={min:T.number,now:T.number,max:T.number,label:T.node,srOnly:T.bool,striped:T.bool,active:T.bool,children:function(e,t,n){var o=e[t];if(!o)return null;var r=null;return P.Children.forEach(o,function(e){if(!r&&e.type!==bu){var t=P.isValidElement(e)?e.type.displayName||e.type.name||e.type:e;r=new Error("Children of "+n+" can contain only ProgressBar components. Found "+t+".")}}),r},isChild:T.bool};var yu,bu=(yu=P.Component,nn(gu,yu),gu.prototype.renderProgressBar=function(e){var t,n=e.min,o=e.now,r=e.max,i=e.label,a=e.srOnly,s=e.striped,l=e.active,c=e.className,u=e.style,p=kn(on(e,["min","now","max","label","srOnly","striped","active","className","style"])),d=p[0],f=p[1],h=be({},Tn(d),((t={active:l})[On(d,"striped")]=l||s,t));return P.createElement("div",be({},f,{role:"progressbar",className:rn(c,h),style:be({width:function(e,t,n){var o=(e-t)/(n-t)*100;return Math.round(1e3*o)/1e3}(o,n,r)+"%"},u),"aria-valuenow":o,"aria-valuemin":n,"aria-valuemax":r}),a?P.createElement("span",{className:"sr-only"},i):i)},gu.prototype.render=function(){var e=this.props,t=e.isChild,n=on(e,["isChild"]);if(t)return this.renderProgressBar(n);var o=n.min,r=n.now,i=n.max,a=n.label,s=n.srOnly,l=n.striped,c=n.active,u=n.bsClass,p=n.bsStyle,d=n.className,f=n.children,h=on(n,["min","now","max","label","srOnly","striped","active","bsClass","bsStyle","className","children"]);return P.createElement("div",be({},h,{className:rn(d,"progress")}),f?In.map(f,function(e){return _.cloneElement(e,{isChild:!0})}):this.renderProgressBar({min:o,now:r,max:i,label:a,srOnly:s,striped:l,active:c,bsClass:u,bsStyle:p}))},gu);function gu(){return ge(this,gu),Gt(this,yu.apply(this,arguments))}bu.propTypes=vu,bu.defaultProps={min:0,max:100,active:!1,isChild:!1,srOnly:!1,striped:!1},wn("progress-bar",xn(Vn(yn),bu));var Eu,Cu={inline:T.bool,disabled:T.bool,title:T.string,validationState:T.oneOf(["success","warning","error",null]),inputRef:T.func},Nu=(Eu=P.Component,nn(Ou,Eu),Ou.prototype.render=function(){var e=this.props,t=e.inline,n=e.disabled,o=e.validationState,r=e.inputRef,i=e.className,a=e.style,s=e.title,l=e.children,c=kn(on(e,["inline","disabled","validationState","inputRef","className","style","title","children"])),u=c[0],p=c[1],d=P.createElement("input",be({},p,{ref:r,type:"radio",disabled:n}));if(t){var f,h=((f={})[On(u,"inline")]=!0,f.disabled=n,f);return"production"!=="production"&&ar(!o,"`validationState` is ignored on `<Radio inline>`. To display validation state on an inline radio, set `validationState` on a parent `<FormGroup>` or other element instead."),P.createElement("label",{className:rn(i,h),style:a,title:s},d,l)}var m=be({},Tn(u),{disabled:n});return o&&(m["has-"+o]=!0),P.createElement("div",{className:rn(i,m),style:a},P.createElement("label",{title:s},d,l))},Ou);function Ou(){return ge(this,Ou),Gt(this,Eu.apply(this,arguments))}Nu.propTypes=Cu,Nu.defaultProps={inline:!1,disabled:!1,title:""},wn("radio",Nu);var wu,xu={children:T.element.isRequired,a16by9:T.bool,a4by3:T.bool},_u=(wu=P.Component,nn(Tu,wu),Tu.prototype.render=function(){var e,t=this.props,n=t.a16by9,o=t.a4by3,r=t.className,i=t.children,a=kn(on(t,["a16by9","a4by3","className","children"])),s=a[0],l=a[1];"production"!=="production"&&ar(n||o,"Either `a16by9` or `a4by3` must be set."),"production"!=="production"&&ar(!(n&&o),"Only one of `a16by9` or `a4by3` can be set.");var c=be({},Tn(s),((e={})[On(s,"16by9")]=n,e[On(s,"4by3")]=o,e));return P.createElement("div",{className:rn(c)},_.cloneElement(i,be({},l,{className:rn(r,On(s,"item"))})))},Tu);function Tu(){return ge(this,Tu),Gt(this,wu.apply(this,arguments))}_u.propTypes=xu,_u.defaultProps={a16by9:!1,a4by3:!1},wn("embed-responsive",_u);var Su,Pu={componentClass:lo},ku=(Su=P.Component,nn(Mu,Su),Mu.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=kn(on(e,["componentClass","className"])),r=o[0],i=o[1],a=Tn(r);return P.createElement(t,be({},i,{className:rn(n,a)}))},Mu);function Mu(){return ge(this,Mu),Gt(this,Su.apply(this,arguments))}ku.propTypes=Pu,ku.defaultProps={componentClass:"div"},wn("row",ku);var Ru,Au=(Ru=P.Component,nn(Iu,Ru),Iu.prototype.render=function(){return P.createElement(ki,be({},this.props,{useAnchor:!1,noCaret:!1}))},Iu);function Iu(){return ge(this,Iu),Gt(this,Ru.apply(this,arguments))}Au.defaultProps=ki.defaultProps;var Du,Lu=be({},ji.propTypes,{bsStyle:T.string,bsSize:T.string,href:T.string,onClick:T.func,title:T.node.isRequired,toggleLabel:T.string,children:T.node}),Fu=(Du=P.Component,nn(ju,Du),ju.prototype.render=function(){var e=this.props,t=e.bsSize,n=e.bsStyle,o=e.title,r=e.toggleLabel,i=e.children,a=on(e,["bsSize","bsStyle","title","toggleLabel","children"]),s=Ki(a,ji.ControlledComponent),l=s[0],c=s[1];return P.createElement(ji,be({},l,{bsSize:t,bsStyle:n}),P.createElement(To,be({},c,{disabled:a.disabled,bsSize:t,bsStyle:n}),o),P.createElement(Au,{"aria-label":r||o,bsSize:t,bsStyle:n}),P.createElement(ji.Menu,null,i))},ju);function ju(){return ge(this,ju),Gt(this,Du.apply(this,arguments))}Fu.propTypes=Lu,Fu.Toggle=Au;var Ku,Hu=T.oneOfType([T.string,T.number]),Uu={id:function(e){var t=null;if(!e.generateChildId){for(var n=arguments.length,o=Array(1<n?n-1:0),r=1;r<n;r++)o[r-1]=arguments[r];(t=Hu.apply(void 0,[e].concat(o)))||e.id||(t=new Error("In order to properly initialize Tabs in a way that is accessible to assistive technologies (such as screen readers) an `id` or a `generateChildId` prop to TabContainer is required"))}return t},generateChildId:T.func,onSelect:T.func,activeKey:T.any},$u={$bs_tabContainer:T.shape({activeKey:T.any,onSelect:T.func.isRequired,getTabId:T.func.isRequired,getPaneId:T.func.isRequired})},Bu=(Ku=P.Component,nn(Vu,Ku),Vu.prototype.getChildContext=function(){var e=this.props,t=e.activeKey,n=e.onSelect,o=e.generateChildId,r=e.id,i=o||function(e,t){return r?r+"-"+t+"-"+e:null};return{$bs_tabContainer:{activeKey:t,onSelect:n,getTabId:function(e){return i(e,"tab")},getPaneId:function(e){return i(e,"pane")}}}},Vu.prototype.render=function(){var e=this.props,t=e.children,n=on(e,["children"]);return delete n.generateChildId,delete n.onSelect,delete n.activeKey,P.cloneElement(P.Children.only(t),n)},Vu);function Vu(){return ge(this,Vu),Gt(this,Ku.apply(this,arguments))}Bu.propTypes=Uu,Bu.childContextTypes=$u;var Wu,qu=ri(Bu,{activeKey:"onSelect"}),zu={componentClass:lo,animation:T.oneOfType([T.bool,lo]),mountOnEnter:T.bool,unmountOnExit:T.bool},Gu={$bs_tabContainer:T.shape({activeKey:T.any})},Yu={$bs_tabContent:T.shape({bsClass:T.string,animation:T.oneOfType([T.bool,lo]),activeKey:T.any,mountOnEnter:T.bool,unmountOnExit:T.bool,onPaneEnter:T.func.isRequired,onPaneExited:T.func.isRequired,exiting:T.bool.isRequired})},Xu=(Wu=P.Component,nn(Ju,Wu),Ju.prototype.getChildContext=function(){var e=this.props,t=e.bsClass,n=e.animation,o=e.mountOnEnter,r=e.unmountOnExit,i=this.state.activeKey,a=this.getContainerActiveKey(),s=null!=i&&i!==a;return{$bs_tabContent:{bsClass:t,animation:n,activeKey:null!=i?i:a,mountOnEnter:o,unmountOnExit:r,onPaneEnter:this.handlePaneEnter,onPaneExited:this.handlePaneExited,exiting:s}}},Ju.prototype.componentWillReceiveProps=function(e){!e.animation&&this.state.activeChild&&this.setState({activeKey:null,activeChild:null})},Ju.prototype.componentWillUnmount=function(){this.isUnmounted=!0},Ju.prototype.getContainerActiveKey=function(){var e=this.context.$bs_tabContainer;return e&&e.activeKey},Ju.prototype.handlePaneEnter=function(e,t){return!!this.props.animation&&t===this.getContainerActiveKey()&&(this.setState({activeKey:t,activeChild:e}),!0)},Ju.prototype.handlePaneExited=function(t){this.isUnmounted||this.setState(function(e){return e.activeChild!==t?null:{activeKey:null,activeChild:null}})},Ju.prototype.render=function(){var e=this.props,t=e.componentClass,n=e.className,o=Mn(on(e,["componentClass","className"]),["animation","mountOnEnter","unmountOnExit"]),r=o[0],i=o[1];return P.createElement(t,be({},i,{className:rn(n,On(r,"content"))}))},Ju);function Ju(e,t){ge(this,Ju);var n=Gt(this,Wu.call(this,e,t));return n.handlePaneEnter=n.handlePaneEnter.bind(n),n.handlePaneExited=n.handlePaneExited.bind(n),n.state={activeKey:null,activeChild:null},n}Xu.propTypes=zu,Xu.defaultProps={componentClass:"div",animation:!0,mountOnEnter:!1,unmountOnExit:!1},Xu.contextTypes=Gu,Xu.childContextTypes=Yu;var Zu,Qu=wn("tab",Xu),ep={eventKey:T.any,animation:T.oneOfType([T.bool,lo]),id:T.string,"aria-labelledby":T.string,bsClass:T.string,onEnter:T.func,onEntering:T.func,onEntered:T.func,onExit:T.func,onExiting:T.func,onExited:T.func,mountOnEnter:T.bool,unmountOnExit:T.bool},tp={$bs_tabContainer:T.shape({getTabId:T.func,getPaneId:T.func}),$bs_tabContent:T.shape({bsClass:T.string,animation:T.oneOfType([T.bool,lo]),activeKey:T.any,mountOnEnter:T.bool,unmountOnExit:T.bool,onPaneEnter:T.func.isRequired,onPaneExited:T.func.isRequired,exiting:T.bool.isRequired})},np={$bs_tabContainer:T.oneOf([null])},op=(Zu=P.Component,nn(rp,Zu),rp.prototype.getChildContext=function(){return{$bs_tabContainer:null}},rp.prototype.componentDidMount=function(){this.shouldBeIn()&&this.handleEnter()},rp.prototype.componentDidUpdate=function(){this.in?this.shouldBeIn()||this.handleExited():this.shouldBeIn()&&this.handleEnter()},rp.prototype.componentWillUnmount=function(){this.in&&this.handleExited()},rp.prototype.getAnimation=function(){if(null!=this.props.animation)return this.props.animation;var e=this.context.$bs_tabContent;return e&&e.animation},rp.prototype.handleEnter=function(){var e=this.context.$bs_tabContent;e&&(this.in=e.onPaneEnter(this,this.props.eventKey))},rp.prototype.handleExited=function(){var e=this.context.$bs_tabContent;e&&(e.onPaneExited(this),this.in=!1)},rp.prototype.isActive=function(){var e=this.context.$bs_tabContent,t=e&&e.activeKey;return this.props.eventKey===t},rp.prototype.shouldBeIn=function(){return this.getAnimation()&&this.isActive()},rp.prototype.render=function(){var e=this.props,t=e.eventKey,n=e.className,o=e.onEnter,r=e.onEntering,i=e.onEntered,a=e.onExit,s=e.onExiting,l=e.onExited,c=e.mountOnEnter,u=e.unmountOnExit,p=on(e,["eventKey","className","onEnter","onEntering","onEntered","onExit","onExiting","onExited","mountOnEnter","unmountOnExit"]),d=this.context,f=d.$bs_tabContent,h=d.$bs_tabContainer,m=Mn(p,["animation"]),v=m[0],y=m[1],b=this.isActive(),g=this.getAnimation(),E=null!=c?c:f&&f.mountOnEnter,C=null!=u?u:f&&f.unmountOnExit;if(!b&&!g&&C)return null;var N=!0===g?Wi:g||null;f&&(v.bsClass=On(f,"pane"));var O=be({},Tn(v),{active:b});h&&("production"!=="production"&&ar(!y.id&&!y["aria-labelledby"],"In the context of a `<TabContainer>`, `<TabPanes>` are given generated `id` and `aria-labelledby` attributes for the sake of proper component accessibility. Any provided ones will be ignored. To control these attributes directly provide a `generateChildId` prop to the parent `<TabContainer>`."),y.id=h.getPaneId(t),y["aria-labelledby"]=h.getTabId(t));var w=P.createElement("div",be({},y,{role:"tabpanel","aria-hidden":!b,className:rn(n,O)}));if(N){var x=f&&f.exiting;return P.createElement(N,{in:b&&!x,onEnter:Rn(this.handleEnter,o),onEntering:r,onEntered:i,onExit:a,onExiting:s,onExited:Rn(this.handleExited,l),mountOnEnter:E,unmountOnExit:C},w)}return w},rp);function rp(e,t){ge(this,rp);var n=Gt(this,Zu.call(this,e,t));return n.handleEnter=n.handleEnter.bind(n),n.handleExited=n.handleExited.bind(n),n.in=!1,n}op.propTypes=ep,op.contextTypes=tp,op.childContextTypes=np;var ip,ap=wn("tab-pane",op),sp=be({},ap.propTypes,{disabled:T.bool,title:T.node,tabClassName:T.string}),lp=(ip=P.Component,nn(cp,ip),cp.prototype.render=function(){var e=be({},this.props);return delete e.title,delete e.disabled,delete e.tabClassName,P.createElement(ap,e)},cp);function cp(){return ge(this,cp),Gt(this,ip.apply(this,arguments))}lp.propTypes=sp,lp.Container=qu,lp.Content=Qu,lp.Pane=ap;var up,pp={striped:T.bool,bordered:T.bool,condensed:T.bool,hover:T.bool,responsive:T.bool},dp=(up=P.Component,nn(fp,up),fp.prototype.render=function(){var e,t=this.props,n=t.striped,o=t.bordered,r=t.condensed,i=t.hover,a=t.responsive,s=t.className,l=kn(on(t,["striped","bordered","condensed","hover","responsive","className"])),c=l[0],u=l[1],p=be({},Tn(c),((e={})[On(c,"striped")]=n,e[On(c,"bordered")]=o,e[On(c,"condensed")]=r,e[On(c,"hover")]=i,e)),d=P.createElement("table",be({},u,{className:rn(s,p)}));return a?P.createElement("div",{className:On(c,"responsive")},d):d},fp);function fp(){return ge(this,fp),Gt(this,up.apply(this,arguments))}dp.propTypes=pp,dp.defaultProps={bordered:!1,condensed:!1,hover:!1,responsive:!1,striped:!1},wn("table",dp);var hp=qu.ControlledComponent,mp={activeKey:T.any,bsStyle:T.oneOf(["tabs","pills"]),animation:T.bool,id:Qr(T.oneOfType([T.string,T.number])),onSelect:T.func,mountOnEnter:T.bool,unmountOnExit:T.bool};var vp,yp=(vp=P.Component,nn(bp,vp),bp.prototype.renderTab=function(e){var t=e.props,n=t.title,o=t.eventKey,r=t.disabled,i=t.tabClassName;return null==n?null:P.createElement(gc,{eventKey:o,disabled:r,className:i},n)},bp.prototype.render=function(){var e=this.props,t=e.id,n=e.onSelect,o=e.animation,r=e.mountOnEnter,i=e.unmountOnExit,a=e.bsClass,s=e.className,l=e.style,c=e.children,u=e.activeKey,p=void 0===u?function(e){var t=void 0;return In.forEach(e,function(e){null==t&&(t=e.props.eventKey)}),t}(c):u,d=on(e,["id","onSelect","animation","mountOnEnter","unmountOnExit","bsClass","className","style","children","activeKey"]);return P.createElement(hp,{id:t,activeKey:p,onSelect:n,className:s,style:l},P.createElement("div",null,P.createElement(Vl,be({},d,{role:"tablist"}),In.map(c,this.renderTab)),P.createElement(Qu,{bsClass:a,animation:o,mountOnEnter:r,unmountOnExit:i},c)))},bp);function bp(){return ge(this,bp),Gt(this,vp.apply(this,arguments))}yp.propTypes=mp,yp.defaultProps={bsStyle:"tabs",animation:!0,mountOnEnter:!1,unmountOnExit:!1},wn("tab",yp),ri(yp,{activeKey:"onSelect"});var gp,Ep={src:T.string,alt:T.string,href:T.string,onError:T.func,onLoad:T.func},Cp=(gp=P.Component,nn(Np,gp),Np.prototype.render=function(){var e=this.props,t=e.src,n=e.alt,o=e.onError,r=e.onLoad,i=e.className,a=e.children,s=kn(on(e,["src","alt","onError","onLoad","className","children"])),l=s[0],c=s[1],u=c.href?fo:"div",p=Tn(l);return P.createElement(u,be({},c,{className:rn(i,p)}),P.createElement("img",{src:t,alt:n,onError:o,onLoad:r}),a&&P.createElement("div",{className:"caption"},a))},Np);function Np(){return ge(this,Np),Gt(this,gp.apply(this,arguments))}Cp.propTypes=Ep,wn("thumbnail",Cp);var Op,wp={type:T.oneOf(["checkbox","radio"]),name:T.string,checked:T.bool,disabled:T.bool,onChange:T.func,value:T.any.isRequired},xp=(Op=P.Component,nn(_p,Op),_p.prototype.render=function(){var e=this.props,t=e.children,n=e.name,o=e.checked,r=e.type,i=e.onChange,a=e.value,s=on(e,["children","name","checked","type","onChange","value"]),l=s.disabled;return P.createElement(To,be({},s,{active:!!o,componentClass:"label"}),P.createElement("input",{name:n,type:r,autoComplete:"off",value:a,checked:!!o,disabled:!!l,onChange:i}),t)},_p);function _p(){return ge(this,_p),Gt(this,Op.apply(this,arguments))}xp.propTypes=wp;var Tp,Sp={name:T.string,value:T.any,onChange:T.func,type:T.oneOf(["checkbox","radio"]).isRequired},Pp=(Tp=P.Component,nn(kp,Tp),kp.prototype.getValues=function(){var e=this.props.value;return null==e?[]:[].concat(e)},kp.prototype.handleToggle=function(t){var e=this.props,n=e.type,o=e.onChange,r=this.getValues(),i=-1!==r.indexOf(t);"radio"!==n?o(i?r.filter(function(e){return e!==t}):[].concat(r,[t])):i||o(t)},kp.prototype.render=function(){var r=this,e=this.props,t=e.children,i=e.type,a=e.name,n=on(e,["children","type","name"]),s=this.getValues();return"radio"!==i||a||( false?pn(!1,'A `name` is required to group the toggle buttons when the `type` is set to "radio"'):pn(!1)),delete n.onChange,delete n.value,P.createElement(Ao,be({},n,{"data-toggle":"buttons"}),In.map(t,function(e){var t=e.props,n=t.value,o=t.onChange;return P.cloneElement(e,{type:i,name:e.name||a,checked:-1!==s.indexOf(n),onChange:Rn(o,function(){return r.handleToggle(n)})})}))},kp);function kp(){return ge(this,kp),Gt(this,Tp.apply(this,arguments))}Pp.propTypes=Sp,Pp.defaultProps={type:"radio"},ri(Pp,{value:"onChange"}).Button=xp;var Mp,Rp,Ap={id:Qr(T.oneOfType([T.string,T.number])),placement:T.oneOf(["top","right","bottom","left"]),positionTop:T.oneOfType([T.number,T.string]),positionLeft:T.oneOfType([T.number,T.string]),arrowOffsetTop:T.oneOfType([T.number,T.string]),arrowOffsetLeft:T.oneOfType([T.number,T.string])},Ip=(Mp=P.Component,nn(Dp,Mp),Dp.prototype.render=function(){var e,t=this.props,n=t.placement,o=t.positionTop,r=t.positionLeft,i=t.arrowOffsetTop,a=t.arrowOffsetLeft,s=t.className,l=t.style,c=t.children,u=kn(on(t,["placement","positionTop","positionLeft","arrowOffsetTop","arrowOffsetLeft","className","style","children"])),p=u[0],d=u[1],f=be({},Tn(p),((e={})[n]=!0,e)),h=be({top:o,left:r},l),m={top:i,left:a};return P.createElement("div",be({},d,{role:"tooltip",className:rn(s,f),style:h}),P.createElement("div",{className:On(p,"arrow"),style:m}),P.createElement("div",{className:On(p,"inner")},c))},Dp);function Dp(){return ge(this,Dp),Gt(this,Mp.apply(this,arguments))}function Lp(){return ge(this,Lp),Gt(this,Rp.apply(this,arguments))}Ip.propTypes=Ap,Ip.defaultProps={placement:"right"},wn("tooltip",Ip),wn("well",_n([dn,fn],(Rp=P.Component,nn(Lp,Rp),Lp.prototype.render=function(){var e=this.props,t=e.className,n=kn(on(e,["className"])),o=n[0],r=n[1],i=Tn(o);return P.createElement("div",be({},r,{className:rn(t,i)}))},Lp)));function Fp(){var o=this,e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"en_US";r(this,Fp),this.locale=e,this.get=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"",t=e,n=o.locale.split("_")[0];return Hp[e]&&(Hp[e][n]?t=Hp[e][n]:Hp[e].en&&(t=Hp[e].en)),t}}var jp="CASH_BACK",Kp="PROMOTION_FROM",Hp={AND:{en:"and",es:"y",fr:"et"},OR:{en:"or",es:"o",fr:"ou"},DETAILS:{en:"Details",es:"Detalles",fr:"Détails"},DISCLAIMER:{en:"Disclaimer",es:"Exención de responsabilidad",fr:"Avertissement"},EFFECTIVE:{en:"Effective",es:"Efectivo",fr:"Entrée en vigueur"},THROUGH:{en:"through",es:"hasta",fr:"par"},PERCENT_APR_FOR:{en:"% APR for",es:"% tasa de porcentaje anual",fr:"% taux d'intérêt annuel"},PER_MONTH:{en:"per month",es:"por mes",fr:"par mois"},MONTHS:{en:"months",es:"meses",fr:"mois"},CASH_BACK:{en:"cash back",es:"reembolso",fr:"argent en remise"},CASH_DUE_AT_SIGNING:{en:"cash due at signing",es:"pago en efectivo al firmar",fr:"argent dû au moment de la signature"},VIEW_APPLICABLE_VEHICLES:{en:"view applicable vehicles",es:"ver vehículos aplicables",fr:"voir les véhicules applicables"},CASH_OFFER_FROM:{en:"Cash Offer from",es:"Oferta en Efectivo de",fr:"Offre en Espèces de"},FINANCE_AND_CASH_OFFER_FROM:{en:"APR Finance and Cash Offer from",es:"APR Finance y Oferta en Efectivo de",fr:"APR Offre de Financement et en Espèces de"},FINANCE_OR_CASH_OFFER_FROM:{en:"APR Finance or Cash Offer from",es:"APR Finance o Oferta en Efectivo de",fr:"APR Offre de Financement ou en Espèces de"},FINANCE_OFFER_FROM:{en:"APR Finance Offer from",es:"APR Finance Offer de",fr:"APR Finance Offre de"},LEASE_OFFER_FROM:{en:"Lease Offer from",es:"Oferta de arrendamiento de",fr:"Offre de location de"},PROMOTION_FROM:{en:"Promotion from",es:"Promoción desde",fr:"Promotion à partir de"}},Up=function(){function o(e){var t;r(this,o),t=d(this,c(o).call(this,e));var n=e.locale;return t.labels=new Fp(n),t}return s(o,P.Component),a(o,[{key:"render",value:function(){var e=this.props,t=e.incentiveId,n=e.incentiveAccountId,o=e.incentiveName,r=e.condition,i=e.newListingPath,a=e.usedListingPath,s="";return(s="NEW"===r?i:a)?(s="".concat(s,"?incentiveId=").concat(encodeURIComponent(t),"&incentiveAccountId=").concat(encodeURIComponent(n)),"CERTIFIED"===r&&(s="".concat(s,"&compositeType=certified")),P.createElement("a",{className:"small text-capitalize",href:s,"data-ga-event":"incentives|click|view inventory","data-incentive-id":t,"data-incentive-name":o},this.labels.get("VIEW_APPLICABLE_VEHICLES"))):null}}]),o}();function $p(e,t,n){var o,r=1<arguments.length&&void 0!==t?t:"en_US",i=2<arguments.length&&void 0!==n&&n,a={style:"currency",currency:r.length&&-1<r.indexOf("CA")?"CAD":"USD"};return"number"!=typeof e?"":(i?o=e:(o=Math.round(e),a.minimumFractionDigits=0),new Intl.NumberFormat(r.replace("_","-"),a).format(o))}Up.propTypes={incentiveId:T.string.isRequired,incentiveAccountId:T.string.isRequired,incentiveName:T.string,condition:T.string,newListingPath:T.string,usedListingPath:T.string,locale:T.string.isRequired},Up.defaultProps={incentiveName:"",condition:"NEW",newListingPath:null,usedListingPath:null};var Bp=function(){function o(e){var t;r(this,o);var n=(t=d(this,c(o).call(this,e))).props.locale;return t.labels=new Fp(n),t}return s(o,P.Component),a(o,[{key:"render",value:function(){var t,n=this,e=this.props,o=e.incentiveTerms,r=e.locale,i=null;o&&o.length&&(o.forEach(function(e){t=P.createElement(P.Fragment,null,t,P.createElement("li",{className:"list-group-item p-0 pb-1"},"".concat(function(e,t){var n=1<arguments.length&&void 0!==t?t:"en_US";return"number"!=typeof e?"":new Intl.NumberFormat(n.replace("_","-")).format(e)}(e.value,r)).concat(n.labels.get("PERCENT_APR_FOR")," ").concat(e.term," ").concat(n.labels.get("MONTHS"))))}),i=P.createElement("ul",{className:"list-group list-group-flush mt-4"},t));return i}}]),o}();Bp.propTypes={incentiveTerms:T.arrayOf(T.shape({term:T.number.isRequired,value:T.number.isRequired})),locale:T.string.isRequired},Bp.defaultProps={incentiveTerms:[]};var Vp=function(){function o(e){var t;r(this,o);var n=(t=d(this,c(o).call(this,e))).props.locale;return t.labels=new Fp(n),t}return s(o,P.Component),a(o,[{key:"render",value:function(){var e=this.props,t=e.incentive,n=e.locale,o=null;if(t&&t.specific){var r=t.specific,i=t.effectiveDate,a=t.expirationDate,s=P.createElement("p",null,"".concat(this.labels.get("EFFECTIVE")," ").concat(i," ").concat(this.labels.get("THROUGH")," ").concat(a)),l=r.cashOption?P.createElement("p",null,"".concat($p(r.cashOption,n)," ").concat(this.labels.get(jp))):null,c=r.cashDue?P.createElement("p",null,"".concat($p(r.cashDue,n)," ").concat(this.labels.get("CASH_DUE_AT_SIGNING"))):null,u=r.monthlyPayment?P.createElement("p",null,"".concat($p(r.monthlyPayment,n)," ").concat(this.labels.get("PER_MONTH")),r.cashOption?P.createElement(P.Fragment,null,P.createElement("br",null),"".concat($p(r.cashOption,n)," ").concat(this.labels.get(jp))):null):"";if(r._type)switch(r._type){case"CASH":o=P.createElement(P.Fragment,null,l,s);break;case"FINANCE":o=P.createElement(P.Fragment,null,P.createElement(Bp,{incentiveTerms:r.terms,locale:n}),s,c);break;case"CASH_AND_FINANCE":o=P.createElement(P.Fragment,null,P.createElement(Bp,{incentiveTerms:r.terms,locale:n}),r.cashOption?P.createElement(P.Fragment,null,P.createElement("p",null,this.labels.get("AND")),l):null,s,c);break;case"CASH_OR_FINANCE":o=P.createElement(P.Fragment,null,P.createElement(Bp,{incentiveTerms:r.terms,locale:n}),r.cashOption?P.createElement(P.Fragment,null,P.createElement("p",null,this.labels.get("OR")),l):null,s,c);break;case"LEASE":o=P.createElement(P.Fragment,null,u,s,c);break;case"UNDEFINED_TERM":o=P.createElement(P.Fragment,null,l,s,c);break;default:o=s}}return o}}]),o}();Vp.propTypes={incentive:T.shape({key:T.string,title:T.string,label:T.string,offerDetails:T.string,shortTitle:T.string,disclaimer:T.string,effectiveDate:T.string,expirationDate:T.string,conditional:T.bool,make:T.string,condition:T.string,manufacturerOffer:T.bool,specific:T.object}).isRequired,locale:T.string.isRequired};var Wp={widgetId:"",widgetName:"wsm-incentive-modal",widgetState:"default",event:"widgetUserEvent",element:"",elementCTA:void 0,action:"clicked",result:"",fieldValue:void 0,formId:void 0,formEventId:void 0,value:void 0};function qp(e){var t=window.jQuery(document)||{};0<Object.keys(t).length&&t.trigger("trackEvent",function(r){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{},t=Object.keys(i);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(i).filter(function(e){return Object.getOwnPropertyDescriptor(i,e).enumerable}))),t.forEach(function(e){var t,n,o;t=r,o=i[n=e],n in t?Object.defineProperty(t,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):t[n]=o})}return r}({},Wp,e))}var zp=function(){function o(e){var t;r(this,o),t=d(this,c(o).call(this,e));var n=e.locale;return t.labels=new Fp(n),t.onClose=t.onClose.bind(p(t)),t.onOpen=t.onOpen.bind(p(t)),t}return s(o,P.Component),a(o,[{key:"onOpen",value:function(){var e=this.props,t=e.incentive,n=e.widgetInfo,o=n.windowId,r=n.widgetName;t&&0<Object.keys(t).length&&function(e,t,n){qp({widgetId:t,widgetName:e,element:"Specials details link",elementCTA:n,result:"Opened dialog"})}(r,o,t.title)}},{key:"onClose",value:function(){var e=this.props,t=e.onModalClose,n=e.widgetInfo,o=n.windowId,r=n.widgetName;t(),function(e,t){qp({widgetId:t,widgetName:e,widgetState:"Special dialog",element:"Close button",result:"Closed dialog"})}(r,o)}},{key:"getOfferType",value:function(e,t,n,o){var r=o;t&&(r=n);var i=Kp;if(e&&e._type)switch(e._type){case"CASH":i="CASH_OFFER_FROM";break;case"FINANCE":case"UNDEFINED_TERM":i="FINANCE_OFFER_FROM";break;case"CASH_AND_FINANCE":i="FINANCE_AND_CASH_OFFER_FROM";break;case"CASH_OR_FINANCE":i="FINANCE_OR_CASH_OFFER_FROM";break;case"LEASE":i="LEASE_OFFER_FROM";break;default:i=Kp}return"".concat(this.labels.get(i)," ").concat(r)}},{key:"getIncentiveDetails",value:function(){var e=this.props,t=e.incentive,n=e.newListingPath,o=e.usedListingPath,r=e.account,i=e.locale,a=t.key,s=t.specific,l=t.title,c=t.shortTitle,u=t.offerDetails,p=t.make,d=t.condition,f=t.manufacturerOffer,h=function(e){var t={incentiveAccountId:"",incentiveId:""};if("string"==typeof e){var n=e.split("_");1<n.length&&(t={incentiveAccountId:n[0],incentiveId:n[1]})}return t}(a),m=h.incentiveId,v=h.incentiveAccountId,y=this.getOfferType(s,f,p,r.name);return P.createElement(P.Fragment,null,P.createElement("h4",{className:"mt-2 mb-0 h5","data-testid":"offerType"},y),P.createElement("p",{className:"mt-0"},l),P.createElement("h4",{className:"mt-2 mb-0 h5 text-capitalize"},this.labels.get("DETAILS")),P.createElement("p",null,u),P.createElement(Vp,{incentive:t,locale:i}),P.createElement(Up,{incentiveId:m,incentiveAccountId:v,incentiveName:c,condition:d,newListingPath:n,usedListingPath:o,locale:i}))}},{key:"getIncentiveDisclaimer",value:function(e){var t=null;return e&&(t=P.createElement("div",{className:"text-muted small mt-4"},P.createElement("p",null,"".concat(this.labels.get("DISCLAIMER"),": ").concat(e)))),t}},{key:"render",value:function(){var e=this.props,t=e.incentive,n=e.isMobile,o=e.isOpen,r=t.shortTitle,i=t.disclaimer,a=this.getIncentiveDetails(),s=this.getIncentiveDisclaimer(i);return P.createElement(jl,{show:o,onHide:this.onClose,onShow:this.onOpen,className:"m-1 ".concat(n?"dock-right":null)},P.createElement(jl.Header,null,P.createElement(jl.Title,{className:"text-center"},P.createElement("button",{type:"button","aria-label":"Close",className:"close text-muted",onClick:this.onClose},P.createElement("i",{className:"ddc-icon ddc-icon-close","aria-hidden":"true"})),P.createElement("span",{className:"h3 my-0 px-5"},r))),P.createElement(jl.Body,null,a,s))}}]),o}();zp.propTypes={incentive:T.shape({key:T.string,title:T.string,label:T.string,offerDetails:T.string,shortTitle:T.string,disclaimer:T.string,effectiveDate:T.string,expirationDate:T.string,conditional:T.bool,make:T.string,condition:T.string,manufacturerOffer:T.bool,specific:T.object}).isRequired,widgetInfo:T.shape({windowId:T.string.isRequired,widgetName:T.string.isRequired,deviceType:T.string.isRequired}).isRequired,isOpen:T.bool.isRequired,isMobile:T.bool.isRequired,onModalClose:T.func.isRequired,account:T.shape({name:T.string,id:T.string}).isRequired,newListingPath:T.string,usedListingPath:T.string,locale:T.string},zp.defaultProps={newListingPath:null,usedListingPath:null,locale:"en_US"};var Gp=function(){var e=function(s){return function(){var e=this,a=arguments;return new Promise(function(t,n){var o=s.apply(e,a);function r(e){l(o,t,n,r,i,"next",e)}function i(e){l(o,t,n,r,i,"throw",e)}r(void 0)})}}(o.mark(function e(){return o.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",Promise.resolve("done"));case 1:case"end":return e.stop()}},e)}));return function(){return e.apply(this,arguments)}}();e.IncentiveModal=zp,e.asyncFunc=Gp,Object.defineProperty(e,"__esModule",{value:!0})});
//# sourceMappingURL=lib.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.f60fba11f860068f0674.js